/**
 * Traducciones del feature de COMANDAS (es/en/pt). Vive en su propio módulo y
 * se mergea por idioma en translations.js (igual que cashRegister/reservationsNew).
 */
const comandas = {
  es: {
    // Dashboard card
    "comandas.menuDashboard.title": "Comandas",
    "comandas.menuDashboard.desc": "Tomá pedidos por mesa y mandá la comanda a la cocina.",
    "comandas.menuDashboard.badge": "Nuevo",

    // Nav
    "comandas.nav.back": "Volver al panel",
    "comandas.nav.turno": "Turno",
    "comandas.nav.config": "Configuración",
    "comandas.nav.historial": "Historial",
    "comandas.nav.stock": "Stock",
    // ── Stock ──
    "comandas.hist.voidedItems": "Platos anulados ({n})",
    "comandas.hist.voidedItemsPaid": "Los que están en una mesa que SÍ se cobró son los que hay que mirar: ese plato se cocinó y no lo pagó nadie.",
    "comandas.hist.viOpenTable": "MESA ABIERTA",
    "comandas.hist.viVoidTable": "MESA ANULADA",
    "comandas.hist.viMerged": "MESA JUNTADA",
    "comandas.hist.voidedItemsHint": "Salieron a cocina y después se sacaron de la cuenta. Puede ser legítimo (se cargó en la mesa equivocada, salió mal) o no: por eso queda con nombre y hora.",
    "comandas.hist.voided": "Anuladas ({n})",
    "comandas.hist.voidedHint":
      "No suman a los totales: no se cobraron. Entran las que mandaron algo a cocina y las que se anularon después de imprimirle la cuenta al cliente.",
    // Mesas que quedaron abiertas de días anteriores (plata sin cobrar).
    "comandas.stale.bar": "{n} mesa(s) quedaron abiertas de días anteriores · {total} sin cobrar",
    "comandas.stale.see": "Ver",
    "comandas.stale.eyebrow": "Quedaron abiertas",
    "comandas.stale.title": "Mesas de días anteriores",
    "comandas.stale.hint":
      "Se cerró el día y estas mesas nunca se cobraron ni se anularon. Traelas a hoy para cobrarlas, o anulalas si no se van a cobrar. Lo que ya salió a cocina descontó stock igual.",
    "comandas.stale.meta": "{items} ítem(s) · {total}",
    "comandas.stale.bring": "Traer a hoy",
    "comandas.stale.void": "Anular",
    "comandas.stale.voidConfirm": "¿Seguro? Anular",
    // Avisos en la carta del salón (mesa): solo salen cuando hay dato confiable.
    "comandas.stock.out": "Agotado",
    "comandas.stock.left": "Quedan {n}",
    "comandas.stock.blocked": "Sin stock: {name}",
    "comandas.stock.eyebrow": "Inventario",
    "comandas.stock.title": "Stock",
    "comandas.stock.subtitle": "El saldo de cada insumo se calcula solo: parte de tu recuento y descuenta lo que se vende, según las recetas de Costos.",
    "comandas.stock.refresh": "Actualizar",
    "comandas.stock.error.title": "No se pudo cargar el stock",
    "comandas.stock.error.body": "Firestore rechazó la lectura. Suele ser porque las reglas de comandas todavía no están deployadas.",
    "comandas.stock.noIng.title": "Todavía no cargaste insumos",
    "comandas.stock.noIng.body": "El stock usa los insumos y recetas que cargás en Costos. Cargalos ahí y volvé para elegir cuáles seguir.",
    "comandas.stock.noIng.cta": "Ir a Costos",
    "comandas.stock.banner.out": "{n} sin stock",
    "comandas.stock.banner.low": "{n} por reponer",
    "comandas.stock.banner.need": "{n} sin recuento inicial",
    "comandas.stock.banner.quickNoStock": "{n} plato(s) vendido(s) NO descuentan stock (costeados en modo rápido). Cargales la receta detallada para que descuenten.",
    "comandas.stock.banner.ok": "Todo en orden",
    "comandas.stock.inventory.title": "Inventario",
    "comandas.stock.inventory.desc": "Saldo estimado de cada insumo que seguís. Un recuento físico lo recalibra.",
    "comandas.stock.inventory.empty": "No estás siguiendo ningún insumo todavía. Elegí abajo cuáles seguir.",
    "comandas.stock.row.consumed": "Consumió {qty} {unit} en el período",
    "comandas.stock.row.needCount": "Falta recuento",
    "comandas.stock.row.min": "Mínimo",
    "comandas.stock.status.ok": "OK",
    "comandas.stock.status.low": "Bajo",
    "comandas.stock.status.out": "Sin stock",
    "comandas.stock.status.unknown": "Sin recuento",
    "comandas.stock.status.stale": "Recuento viejo",
    "comandas.stock.row.stale": "Recuento vencido — volvé a contar",
    "comandas.stock.row.recipeIssue": "⚠ Revisá la unidad en la receta",
    "comandas.stock.act.purchase": "Ingreso",
    "comandas.stock.act.waste": "Merma",
    "comandas.stock.act.count": "Recuento",
    "comandas.stock.act.adjust": "Ajuste",
    "comandas.stock.act.untrack": "Dejar de seguir",
    "comandas.stock.track.title": "Insumos a seguir",
    "comandas.stock.track.desc": "Elegí qué insumos querés controlar. Tocá uno para empezar a seguirlo (después hacé el recuento inicial).",
    "comandas.stock.track.allTracked": "Estás siguiendo todos tus insumos.",
    "comandas.stock.movs.title": "Movimientos",
    "comandas.stock.movs.desc": "Últimos ingresos, mermas, ajustes y recuentos.",
    "comandas.stock.movs.empty": "Todavía no registraste movimientos.",
    "comandas.stock.movType.count": "Recuento",
    "comandas.stock.movType.purchase": "Ingreso",
    "comandas.stock.movType.waste": "Merma",
    "comandas.stock.movType.adjust": "Ajuste",
    "comandas.stock.modal.count": "¿Cuánto hay AHORA? Esto fija el saldo y arranca a contar desde acá.",
    "comandas.stock.modal.purchase": "¿Cuánto entró? Se suma al stock.",
    "comandas.stock.modal.waste": "¿Cuánto se perdió, rompió o venció? Se resta del stock.",
    "comandas.stock.modal.adjust": "Corrección manual. Usá negativo para restar (ej: -2).",
    "comandas.stock.modal.notePlaceholder": "Nota (opcional)",
    "comandas.stock.modal.cancel": "Cancelar",
    "comandas.stock.modal.confirm": "Guardar",

    // Turno
    "comandas.turno.title": "Turno — mesas",
    "comandas.turno.items": "ítems",
    "comandas.turno.free": "Libre",
    "comandas.turno.opened": "Abierta",
    "comandas.turno.pending": "Pedido sin enviar",
    "comandas.turno.sent": "Enviado a cocina",

    // Mesa (buscador tipo-y-dispara)
    "comandas.mesa.title": "Mesa",
    "comandas.mesa.searchPlaceholder": "Escribí y Enter… (ej: milane, cocacola, cubierto)",
    "comandas.turno.eyebrow": "Servicio en curso",
    "comandas.turno.openHint": "Tocá una mesa, o escribí el número",
    "comandas.turno.openGo": "Abrir mesa",
    "comandas.turno.summaryOpen": "{open} de {total} mesas abiertas",
    "comandas.turno.noPrinterLocal": "Todavía no configuraste una comandera. Tocá “Impresoras” para conectarla — hasta entonces las comandas no se imprimen.",
    "comandas.turno.printerConnecting": "Conectando con la comandera… el agente la está reconectando solo, no toques nada.",
    "comandas.turno.noPrinterCloud": "Todavía no hay comandera conectada. Configurala desde la PC del local (abrí “Comandas” ahí → Impresoras).",
    "comandas.mesa.searchHint": "Enter agrega · 1-9 cantidad",
    "comandas.mesa.ticketLabel": "Comanda de la mesa",
    "comandas.mesa.itemsCount": "{n} productos",
    "comandas.mesa.emptyShort": "vacía",
    "comandas.mesa.products": "Productos",
    "comandas.mesa.allSent": "Todo enviado",
    "comandas.mesa.lineNew": "Nuevo",
    "comandas.mesa.lineSent": "En cocina",
    "comandas.mesa.editHint": "1-9 cantidad · +/− ajustar · Supr borrar · Enter listo",
    "comandas.mesa.shortcutsTitle": "Atajos de teclado",
    "comandas.mesa.bill": "Cobrar / cerrar mesa",
    "comandas.mesa.close": "Cerrar mesa",
    "comandas.mesa.billSoonTitle": "Disponible pronto: cobro y cierre de mesa",
    "comandas.mesa.soon": "Pronto",
    "comandas.mesa.noteEyebrow": "Aclaración",
    "comandas.mesa.justOpened": "recién abierta",
    "comandas.mesa.minAgo": "hace {m} min",
    "comandas.mesa.hAgo": "hace {h}h {m}m",
    "comandas.mesa.sc.add": "Agrega el producto resaltado",
    "comandas.mesa.sc.move": "Elegí entre los resultados",
    "comandas.mesa.sc.qtyMatch": "Con un match: agrega esa cantidad",
    "comandas.mesa.sc.qtyPrefix": "Número adelante = cantidad",
    "comandas.mesa.sc.note": "Aclaración de la última línea",
    "comandas.mesa.sc.send": "Envía a cocina · vacío vuelve a mesas",
    "comandas.mesa.sc.dlv": "Cliente y dirección",
    "comandas.mesa.sc.dlvApp": "N° de pedido de la app",
    "comandas.mesa.sc.dlvRetiro": "Nombre y teléfono",
    "comandas.mesa.sc.dlvPay": "Hora y cobro",
    "comandas.turno.billed": "Cuenta pedida",
    "comandas.cobro.title": "Cerrar mesa",
    "comandas.cobro.printBill": "Imprimir cuenta",
    "comandas.cobro.reprintBill": "Reimprimir cuenta",
    "comandas.cobro.printing": "Imprimiendo…",
    "comandas.cobro.billPrinted": "Cuenta de {table} impresa ✓",
    "comandas.cobro.method": "¿Con qué pagó?",
    "comandas.cobro.oneMethod": "Un medio",
    "comandas.cobro.splitPay": "Varios medios",
    "comandas.cobro.remaining": "Falta",
    "comandas.cobro.over": "Sobra",
    "comandas.cobro.settled": "Listo ✓",
    "comandas.cobro.addPay": "Agregar",
    "comandas.cobro.addRest": "Resto",
    "comandas.cobro.amountPh": "Monto $",
    "comandas.cobro.splitHint": "Dividiste en {n} cuentas — elegí el medio de cada una",
    "comandas.cobro.confirm": "Cerrar mesa",
    "comandas.cobro.charging": "Cerrando…",
    "comandas.cobro.done": "{table} cerrada ✓",
    "comandas.cobro.needMethod": "Falta elegir el medio de pago de una de las partes.",
    "comandas.cobro.sumMismatch": "Los pagos no suman el total de la mesa. Revisá el desglose.",
    "comandas.covers.title": "¿Cuántos cubiertos?",
    "comandas.covers.confirm": "Abrir mesa",
    "comandas.covers.skip": "Sin especificar",
    "comandas.covers.chargeLabel": "Cubiertos",
    "comandas.covers.priceNote": "{money} por cubierto",
    "comandas.covers.takeaway": "Para llevar",
    "comandas.covers.placeholder": "Otra cantidad",
    "comandas.covers.short": "{n} cub.",
    "comandas.covers.add": "Cubiertos",
    "comandas.config.covers.title": "Cubiertos",
    "comandas.config.covers.track": "Pedir cubiertos al abrir una mesa",
    "comandas.config.covers.desc": "Al abrir una mesa te pregunta cuántos comensales. Suma al total de cubiertos del día en el cierre.",
    "comandas.config.covers.perCover": "Mostrar el gasto por cubierto",
    "comandas.config.covers.perCoverDesc": "Lo recaudado dividido los cubiertos, en el cierre, el historial y el ticket impreso. Es el número que no cambia si la gente vino de a dos o de a seis.",
    "comandas.config.covers.price": "Cuánto cobrás cada cubierto",
    "comandas.config.covers.priceHint": "Se suma solo a la cuenta según cuántos cubiertos cargues en la mesa. Dejalo en 0 si no cobrás cubierto. Cambiar el precio no toca las mesas que ya están abiertas.",
    "comandas.config.waiterSales.title": "Ventas por mozo",
    "comandas.config.waiterSales.track": "Mostrar el desglose por mozo en el cierre",
    "comandas.config.waiterSales.desc": "Suma las ventas de cada mozo (quién cerró cada mesa) en el cierre del día. Solo aparece si trabajó más de uno.",
    "comandas.config.tips.title": "Propinas",
    "comandas.config.tips.track": "Registrar propinas por mozo",
    "comandas.config.tips.desc": "Al cobrar una mesa aparece un campo para anotar la propina. En el cierre del día se totaliza por mozo (para repartir) y muestra el % que sacó cada uno.",
    "comandas.cobro.tip": "Propina (opcional)",
    "comandas.cobro.tipCash": "En efectivo",
    "comandas.cobro.tipWhere": "¿La propina fue en efectivo?",
    "comandas.cobro.payTitle": "¿Cómo pagó?",
    "comandas.cobro.tipWithPay": "Con el pago",
    "comandas.cierre.tipsByWaiter": "Propinas por mozo",
    "comandas.config.routing.title": "Ruteo por estación",
    "comandas.config.routing.desc": "Elegí por qué comandera sale cada categoría. “No imprime” = no sale comanda (ej. bebidas de heladera) pero SÍ va en la cuenta. Si no tocás nada, todo va a Cocina.",
    "comandas.config.routing.empty": "Cargá el menú para ver las categorías.",
    "comandas.config.routing.none": "No imprime",
    "comandas.config.routing.category": "Categoría",
    "comandas.config.routing.station": "Comandera",
    "comandas.config.routing.separate": "Ticket aparte",
    "comandas.config.routing.default": "Por defecto",
    "comandas.config.routing.addonsEmpty": "Todavía no cargaste adicionales fuera de carta.",
    "comandas.config.tables.count": "Cantidad (mesas 1 al N)",
    "comandas.config.tables.customLabel": "Mesas personalizadas EXTRA (opcional)",
    "comandas.config.tables.customHint": "Separá por comas: Barra, Delivery, Patio 1. Se AGREGAN a las numeradas de arriba (no las reemplazan).",
    "comandas.waiter.eyebrow": "Modo local",
    "comandas.waiter.title": "¿Cómo te llamás?",
    "comandas.waiter.hint": "Para saber qué mesa tomó cada mozo. Se guarda en este celular.",
    "comandas.waiter.placeholder": "Tu nombre",
    "comandas.waiter.save": "Guardar",
    "comandas.waiter.later": "Después",
    "comandas.waiter.chip": "Mozo: {name}",
    "comandas.waiter.set": "Poné tu nombre",
    "comandas.closed.eyebrow": "Hoy",
    "comandas.closed.title": "Mesas cerradas hoy",
    "comandas.closed.button": "Cerradas hoy ({n})",
    "comandas.closed.reopen": "Reabrir",
    "comandas.closed.reprint": "Reimprimir",
    "comandas.closed.done": "Listo",
    "comandas.voided.button": "Canceladas hoy ({n})",
    "comandas.unpaid.chip": "Sin cobrar ({n})",
    "comandas.unpaid.eyebrow": "Quedaron abiertas",
    "comandas.unpaid.title": "{n} sin cobrar",
    "comandas.unpaid.hint": "No están en el cierre del día. Tocá una para cobrarla o anularla.",
    "comandas.unpaid.since": "abierta {time}",
    "comandas.unpaid.total": "Total sin cobrar",
    "comandas.unpaid.banner": "Quedan {n} sin cobrar ({total}): no están en este resumen.",
    "comandas.unpaid.see": "Ver",
    "comandas.unpaid.goTurno": "Ir al Turno",
    "comandas.cierre.unpaidTitle": "SIN COBRAR: {n}",
    "comandas.cierre.unpaidNote": "No están en este cierre: cobralas o anulalas.",
    "comandas.voided.eyebrow": "Control",
    "comandas.voided.title": "Mesas canceladas hoy",
    "comandas.voided.hint": "Mesas que se cancelaron sin cobrar. Si dice CUENTA IMPRESA, al cliente ya se le había pasado la cuenta.",
    "comandas.voided.billed": "CUENTA IMPRESA",
    "comandas.voided.items": "{n} ítem(s)",
    "comandas.voided.noName": "sin nombre",
    "comandas.voided.total": "Total cancelado",
    "comandas.reopen.done": "{table} reabierta",
    "comandas.reopen.occupied": "La mesa {table} ya está abierta. Cerrala o cambiala de número antes de reabrir esta.",
    "comandas.reopen.pickEyebrow": "Mesa ocupada",
    "comandas.reopen.pickTitle": "La mesa {table} ya está abierta. ¿A qué mesa la reabrís?",
    "comandas.reopen.pickHint": "Elegí una mesa libre.",
    "comandas.reopen.noneFree": "No hay mesas libres ahora mismo.",
    "comandas.reopen.pickCancel": "Cancelar",
    "comandas.cancel.chip": "Cancelar",
    "comandas.cancel.confirm": "¿Cancelar {table}? Se anula sin cobrar y sale de las abiertas.",
    "comandas.cierre.button": "Reporte del día",
    "comandas.turno.printers": "Impresoras",
    "comandas.cierre.title": "Cierre del día",
    "comandas.cierre.mesas": "Mesas cerradas",
    "comandas.cierre.covers": "Cubiertos",
    "comandas.cierre.byMethod": "Por medio de pago",
    "comandas.cierre.byWaiter": "Por mozo",
    "comandas.hist.pickRange": "Elegir los días",
    "comandas.hist.dayCount": "{n} días",
    "comandas.hist.presetToday": "Hoy",
    "comandas.hist.presetYesterday": "Ayer",
    "comandas.hist.presetWeek": "Esta semana",
    "comandas.hist.presetMonth": "Este mes",
    "comandas.hist.presetPrevMonth": "Mes pasado",
    "comandas.hist.daysPicked": "{n} días elegidos",
    "comandas.hist.rangeSameMonth": "{a} al {b} de {m}",
    "comandas.hist.rangeSpan": "{a} – {b}",
    "comandas.hist.pickDays": "Días sueltos",
    "comandas.hist.pickDaysHint": "Tocá los días que quieras comparar (los sábados, por ejemplo).",
    "comandas.hist.rangeHint": "Tocá el primer día y después el último.",
    "comandas.hist.clearPick": "Borrar",
    "comandas.hist.apply": "Ver estos días",
    "comandas.hist.maxRange": "Hasta 3 meses por vez.",
    "comandas.hist.perDay": "prom. {m} por día",
    "comandas.hist.tablesRange": "Mesas cobradas",
    "comandas.hist.prev": "Anterior",
    "comandas.hist.next": "Siguiente",
    "comandas.hist.emptyRange": "Sin ventas cerradas en esos días.",
    "comandas.hist.loadFailed": "No se pudieron leer esas ventas. Tocá Actualizar para reintentar.",
    "comandas.hist.scopeVisible": "de lo que estás mirando",
    "comandas.hist.eyebrow": "Reporte de gestión",
    "comandas.hist.title": "Historial",
    "comandas.hist.nonFiscal": "No fiscal — control interno",
    "comandas.hist.emptyDay": "Sin ventas cerradas este día.",
    "comandas.hist.total": "Vendido",
    "comandas.hist.avgTicket": "Ticket promedio",
    "comandas.hist.reprint": "Reimprimir cierre del día",
    "comandas.hist.sold": "Lo que se vendió",
    "comandas.hist.soldCount": "{n} productos · {u} unidades",
    "comandas.hist.soldSearch": "Buscar un plato…",
    "comandas.hist.soldNoMatch": "No se vendió nada con ese nombre en estos días.",
    "comandas.hist.soldNote": "No incluye cubiertos, adicionales cargados a mano ni el recargo de delivery, y no descuenta los descuentos.",
    "comandas.hist.byQty": "Por cantidad",
    "comandas.hist.byMoney": "Por plata",
    "comandas.hist.flat": "Todo junto",
    "comandas.hist.byCat": "Por categoría",
    "comandas.hist.catUnits": "{u} unidades",
    "comandas.hist.noCat": "Sin categoría",
    "comandas.hist.showRest": "Ver los {n} restantes",
    "comandas.hist.tipLabel": "Propina",
    "comandas.hist.tip": "propina {m} ({how})",
    "comandas.hist.tipApart": "La propina no entra en el total de la mesa: entró aparte, por ese medio.",
    "comandas.hist.dlvPhone": "Tel.",
    "comandas.hist.dlvTime": "Para las {time}",
    "comandas.hist.tables": "Mesas del día",
    "comandas.hist.detailEyebrow": "Detalle de la mesa",
    "comandas.hist.paidWith": "Pagó con",
    "comandas.hist.loadError": "No pude cargar ese día",
    "comandas.hist.refresh": "Actualizar",
    "comandas.hist.last30": "Últimos 30 días",
    "comandas.cierre.empty": "Sin ventas todavía",
    "comandas.cierre.print": "Imprimir cierre",
    "comandas.cierre.printing": "Imprimiendo…",
    "comandas.cierre.ticketTitle": "CIERRE DEL DIA",
    "comandas.cierre.productsTitle": "PRODUCTOS VENDIDOS",
    "comandas.cierre.voidedTitle": "ANULADAS (no cobradas)",
    "comandas.cierre.voidedItemsTitle": "Platos anulados ya enviados",
    "comandas.cierre.periodTitle": "RESUMEN DEL PERIODO",
    "comandas.cierre.periodRange": "Ultimos 30 dias",
    "comandas.mesa.subtotal": "Subtotal",
    "comandas.adj.eyebrow": "Cuenta",
    "comandas.adj.title": "Adicionales y descuentos",
    "comandas.adj.charge": "Adicional",
    "comandas.adj.discount": "Descuento",
    "comandas.adj.labelPlaceholder": "Concepto (ej: torta, servicio)",
    "comandas.adj.add": "Agregar",
    "comandas.adj.presets": "Guardados",
    "comandas.adj.savePreset": "Guardar como preset",
    "comandas.adj.button": "Adicional / descuento",
    "comandas.adj.buttonN": "Ajustes ({n})",
    "comandas.cats.button": "Ver carta por categorías",
    "comandas.cats.title": "Categorías",
    "comandas.cats.other": "Otros",
    "comandas.cats.empty": "La carta todavía no cargó.",
    "comandas.cats.added": "Agregado: {name}",
    "comandas.void.action": "Anular mesa sin cobrar",
    "comandas.void.confirm": "¿Seguro? Anular sin cobrar",
    "comandas.void.done": "{table} anulada",
    "comandas.void.label": "Anulada (sin cobro)",
    "comandas.void.tag": "ANULADA",
    "comandas.void.sentAction": "Anular este producto (ya está en cocina)",
    "comandas.void.sentActionShort": "Anular",
    "comandas.void.sentEyebrow": "Anular producto enviado",
    "comandas.void.sentWarn": "Se imprime un aviso de ANULACIÓN en la comandera y el producto sale de la cuenta.",
    "comandas.void.sentConfirm": "Sí, anular",
    "comandas.void.sentConfirmN": "Anular ({n})",
    "comandas.void.sentTitle": "Anular productos enviados",
    "comandas.void.sentBusy": "Anulando…",
    "comandas.void.sentDone": "{name} anulado",
    "comandas.void.sentDoneN": "{n} productos anulados",
    "comandas.split.button": "Dividir",
    "comandas.split.eyebrow": "Dividir la cuenta",
    "comandas.split.title": "¿Cómo dividir?",
    "comandas.split.equal": "Partes iguales",
    "comandas.split.byItem": "Por producto",
    "comandas.split.howMany": "¿En cuántas partes?",
    "comandas.split.eachPays": "Cada uno (÷ {n}): ",
    "comandas.split.printEqual": "Imprimir {n} tickets",
    "comandas.split.printing": "Imprimiendo…",
    "comandas.split.pickItems": "Elegí cuánto de cada producto",
    "comandas.split.tapHint": "Tocá la fila para sumar de a uno",
    "comandas.split.each": "{price} c/u",
    "comandas.split.unassigned": "Quedan {n} sin repartir",
    "comandas.split.allAssigned": "Ya repartiste todo",
    "comandas.split.zeroPart": "Esa parte da $0 — no hay nada que cobrar",
    "comandas.split.selected": "Seleccionado: ",
    "comandas.split.printPart": "Imprimir esta parte",
    "comandas.split.printedEqual": "Impresas {n} partes",
    "comandas.split.printedPart": "Parte impresa",
    "comandas.split.partOf": "Parte {i} de {n}",
    "comandas.split.partLabel": "Parte de la cuenta",
    "comandas.move.chip": "Mover",
    "comandas.move.eyebrow": "Mover / Juntar mesa",
    "comandas.move.title": "Mesa {table} → ¿a dónde?",
    "comandas.move.hint": "Libre = mover la mesa entera. Ocupada = juntar las dos.",
    "comandas.move.moveHere": "Mover acá",
    "comandas.move.join": "Juntar",
    "comandas.move.ticketTitle": "CAMBIO DE MESA",
    "comandas.move.moved": "Mesa {from} movida a {to}",
    "comandas.move.merged": "Mesa {from} juntada con la {to}",
    "comandas.move.mergeSrcFail": "Juntadas, pero no pude liberar la mesa {from}. Anulala a mano.",
    "comandas.move.confirmEyebrow": "Juntar mesas",
    "comandas.move.confirmTitle": "Mesa {from} → Mesa {to}",
    "comandas.move.confirmItems": "Se suman a la mesa {to}:",
    "comandas.move.confirmNoItems": "La mesa {from} no tiene productos cargados.",
    "comandas.move.confirmCovers": "Cubiertos: la {to} tiene {a} + la {from} tiene {b} → queda con {sum}",
    "comandas.move.confirmTotal": "Total de la mesa {to}: {total}",
    "comandas.move.confirmWarn": "La mesa {from} se cierra y todo queda en la {to}.",
    "comandas.move.confirmBack": "Volver",
    "comandas.move.confirmGo": "Juntar",
    "comandas.send.sentNoPrint": "Enviado (eso no sale por la comanda)",
    "comandas.pay.efectivo": "Efectivo",
    "comandas.pay.mixto": "Mixto",
    "comandas.pay.debito": "Débito",
    "comandas.pay.credito": "Crédito",
    "comandas.pay.transferencia": "Transferencia",
    "comandas.pay.mercadopago": "MercadoPago",
    "comandas.pay.modo": "MODO",
    "comandas.pay.cuentadni": "Cuenta DNI",
    "comandas.pay.vales": "Vales",
    "comandas.channel.salon": "Salón",
    "comandas.channel.delivery": "Delivery",
    "comandas.channel.takeaway": "Para llevar",
    "comandas.delivery.title": "Delivery y para llevar",
    "comandas.delivery.hint": "Pedidos que no son de una mesa.",
    "comandas.delivery.new": "Nuevo pedido",
    "comandas.delivery.empty": "No hay pedidos abiertos.",
    "comandas.delivery.emptyOwn": "No hay pedidos abiertos. Tocá un botón de arriba para cargar uno.",
    "comandas.delivery.envioSub": "Lo llevamos nosotros",
    "comandas.delivery.retiroSub": "Lo pasan a buscar",
    "comandas.delivery.fromApp": "De una app:",
    "comandas.delivery.appNoAddress": "En un pedido de app no se carga dirección ni cobro: los maneja la app. ¿Lo llevás y lo cobrás vos? Abrilo como Envío desde el Turno.",
    "comandas.delivery.count": "Delivery ({n})",
    "comandas.delivery.eyebrow": "Pedido de app",
    "comandas.delivery.refTitle": "¿Qué número de pedido es?",
    "comandas.delivery.refHint": "El número que muestra la app. Sirve para encontrarlo después, cuando la app te liquide.",
    "comandas.delivery.ref": "N° de pedido",
    "comandas.delivery.refPh": "ej. A4F2",
    "comandas.delivery.customer": "Cliente (opcional)",
    "comandas.delivery.customerPh": "Nombre",
    "comandas.delivery.save": "Listo",
    "comandas.delivery.noMove": "Un pedido de app no se mueve ni se junta con una mesa.",
    "comandas.delivery.markup": "Recargo {pct}%",
    "comandas.delivery.commissionChip": "Comisión {pct}%",
    "comandas.delivery.items": "prod.",
    "comandas.delivery.gone": "Ese tipo de pedido ya no está disponible. Abrilo de nuevo desde el Turno.",
    "comandas.delivery.closed": "Ese pedido ya no está abierto.",
    "comandas.dlv.kind.envio": "Envío",
    "comandas.dlv.kind.retiro": "Para llevar",
    "comandas.dlv.orderShort": "Pedido {n}",
    "comandas.dlv.addCustomerEnvio": "Cargar cliente y dirección",
    "comandas.dlv.addCustomerRetiro": "Cargar nombre y teléfono",
    "comandas.dlv.bagPrint": "Imprimir ticket del pedido",
    "comandas.dlv.bagReprint": "Reimprimir ticket del pedido",
    "comandas.dlv.bagPrinted": "Ticket del pedido impreso ({table})",
    "comandas.dlv.bagNoPrinter": "{table}: no hay comandera disponible para el ticket de la bolsa. Revisala y tocá «Imprimir ticket del pedido».",
    "comandas.dlv.bagFailed": "{table}: el ticket de la bolsa NO salió. Revisá la comandera de la cuenta y tocá «Imprimir ticket del pedido».",
    "comandas.dlv.bagUnconfirmed": "{table}: no se pudo confirmar si salió el ticket de la bolsa. Fijate en la comandera antes de reimprimirlo.",
    "comandas.dlv.feeLabel": "Envío",
    "comandas.dlv.a.titleEnvio": "¿Para quién y adónde?",
    "comandas.dlv.a.titleRetiro": "¿A nombre de quién?",
    "comandas.dlv.a.orderIs": "Es el pedido {n}",
    "comandas.dlv.a.later": "Si te falta algo, lo completás después desde «Cliente y entrega».",
    "comandas.dlv.a.name": "Nombre",
    "comandas.dlv.a.namePh": "Graciela",
    "comandas.dlv.a.phone": "Teléfono",
    "comandas.dlv.a.phonePh": "3492 55-1234",
    "comandas.dlv.a.address": "Calle y número",
    "comandas.dlv.a.addressPh": "San Martín 1234",
    "comandas.dlv.a.noNumber": "¿Falta la altura? Sin número, el cadete no encuentra la casa.",
    "comandas.dlv.a.floor": "Piso / depto",
    "comandas.dlv.a.floorPh": "2º B",
    "comandas.dlv.a.ref": "Entre calles / referencia (para el cadete)",
    "comandas.dlv.a.refPh": "e/ Moreno y Belgrano, portón verde",
    "comandas.dlv.kbdHint": "Enter pasa al siguiente · Esc cierra sin perder lo escrito",
    "comandas.dlv.b.title": "Hora y cobro",
    "comandas.dlv.b.whenEnvio": "¿Para cuándo?",
    "comandas.dlv.b.whenRetiro": "¿Cuándo lo pasa a buscar?",
    "comandas.dlv.b.asap": "Lo antes posible",
    "comandas.dlv.b.in30": "+30 min",
    "comandas.dlv.b.in45": "+45 min",
    "comandas.dlv.b.in60": "+1 h",
    "comandas.dlv.b.timePh": "o escribí la hora: 2130",
    "comandas.dlv.b.timeAria": "Hora",
    "comandas.dlv.b.timeBad": "No entiendo esa hora. Probá con 21:30 o 2130.",
    "comandas.dlv.b.timeIs": "Queda para las {time}",
    "comandas.dlv.b.fee": "Costo de envío",
    "comandas.dlv.b.pay": "¿Cómo paga?",
    "comandas.dlv.b.payUnset": "Sin definir",
    "comandas.dlv.b.paid": "Ya pagó (lo viste acreditado)",
    "comandas.dlv.b.paidAmount": "Pagó",
    "comandas.dlv.b.paidShort": "Falta cobrar {amount}: el ticket se lo va a decir al cadete.",
    "comandas.dlv.b.paidOver": "Pagó {amount} de más.",
    "comandas.dlv.b.payWith": "¿Con cuánto paga?",
    "comandas.dlv.b.exact": "Justo",
    "comandas.dlv.b.payWithPh": "Monto",
    "comandas.dlv.b.change": "Vuelto: {amount}",
    "comandas.dlv.b.notEnough": "No alcanza: faltan {amount}",
    "comandas.dlv.b.note": "Nota del pedido (sale en la comanda y en el ticket)",
    "comandas.dlv.b.notePh": "celíaco, mandar servilletas…",
    "comandas.dlv.card.title": "Cliente y entrega",
    "comandas.dlv.card.whenPay": "Hora y cobro",
    "comandas.dlv.card.noPhone": "Sin teléfono",
    "comandas.dlv.card.noAddress": "Sin dirección",
    "comandas.dlv.card.edit": "Editar",
    "comandas.dlv.send.title": "Antes de mandarlo a cocina",
    "comandas.dlv.send.hint": "En el ticket del pedido, lo que falte sale con una raya para completar a mano.",
    "comandas.dlv.send.fixAddress": "Cargar la dirección",
    "comandas.dlv.send.fixPay": "Cargar cómo paga",
    "comandas.dlv.send.anyway": "Mandar igual",
    "comandas.dlv.send.kbd": "Enter lo completa · Esc lo manda igual",
    "comandas.dlv.send.back": "Volver al pedido (no lo mando todavía)",
    "comandas.dlv.card.noName": "Sin nombre",
    "comandas.dlv.card.deliverAt": "Entregar a las {time}",
    "comandas.dlv.card.pickupAt": "Retira a las {time}",
    "comandas.dlv.card.asap": "Lo antes posible",
    "comandas.dlv.card.paid": "Ya pagó · {method}",
    "comandas.dlv.card.paidPart": "Pagó {paid} · falta {rest}",
    "comandas.dlv.card.payUnset": "Forma de pago sin definir",
    "comandas.dlv.card.cashExact": "Efectivo · paga justo",
    "comandas.dlv.card.cashChange": "Efectivo · paga con {payWith} → vuelto {change}",
    "comandas.dlv.card.fee": "Costo de envío {amount}",
    "comandas.dlv.card.note": "Nota: {note}",
    "comandas.dlv.warn.noAddress": "Falta la dirección",
    "comandas.dlv.warn.noPay": "Falta cómo paga",
    "comandas.dlv.warn.shortPay": "Paga con menos que el total (faltan {amount})",
    "comandas.dlv.warn.overPaid": "Pagó {amount} de más",
    "comandas.dlv.warn.stale": "El ticket de la bolsa salió con datos viejos",
    "comandas.dlv.warn.reprint": "Reimprimir",
    "comandas.dlv.agentOld": "Tu comandera todavía no imprime los datos de entrega. Se actualiza sola en unos minutos; mientras, el ticket sale como siempre.",
    "comandas.dlv.cobro.plan": "Previsto: {method}",
    "comandas.dlv.cobro.planPaid": "Previsto: {method} · ya pagó {amount}",
    "comandas.dlv.cobro.change": "Pagaba con {payWith}: vuelto {change}",
    "comandas.dlv.p.tagEnvio": "ENVÍO",
    "comandas.dlv.p.tagRetiro": "PARA LLEVAR",
    "comandas.dlv.p.forTime": "PARA LAS {time}",
    "comandas.dlv.p.note": "NOTA: {note}",
    "comandas.dlv.p.updated": "ACTUALIZADO",
    "comandas.dlv.p.updatedHint": "Reemplaza al ticket anterior - no volver a cocinar",
    "comandas.dlv.p.orderNo": "PEDIDO {n}",
    "comandas.dlv.p.typeEnvio": "ENVÍO A DOMICILIO",
    "comandas.dlv.p.typeRetiro": "RETIRA EN EL LOCAL",
    "comandas.dlv.p.deliverAt": "Entregar a las {time}",
    "comandas.dlv.p.pickupAt": "Retira a las {time}",
    "comandas.dlv.p.asap": "Lo antes posible",
    "comandas.dlv.p.phone": "Tel. cliente: {phone}",
    "comandas.dlv.p.addressBlank": "Dirección: ______________________",
    "comandas.dlv.p.paidAll": "YA PAGADO - NO COBRAR",
    "comandas.dlv.p.paidPart": "PAGÓ {paid} - COBRAR {rest}",
    "comandas.dlv.p.collect": "COBRAR {amount}",
    "comandas.dlv.p.payBlank": "Forma de pago: ______________",
    "comandas.dlv.p.exact": "Paga justo, sin vuelto",
    "comandas.dlv.p.payWith": "Paga con",
    "comandas.dlv.p.change": "LLEVAR VUELTO",
    "comandas.dlv.p.notEnough": "Paga con {amount} - NO ALCANZA",
    "comandas.dlv.p.paidDone": "PAGADO {amount}",
    "comandas.dlv.list.paid": "Pagado",
    "comandas.dlv.list.dupNo": "Nº repetido",
    "comandas.dlv.list.stale": "Ticket viejo",
    "comandas.dlv.list.noBag": "Falta el ticket",
    "comandas.dlv.renumbered": "Otro equipo tomó el pedido {from}: este pasa a ser el {n}. Avisale al cliente.",
    "comandas.dlv.b.timeIsTomorrow": "Queda para MAÑANA a las {time}",
    "comandas.dlv.b.paidPh": "¿Cuánto pagó? (del comprobante)",
    "comandas.dlv.b.paidMissing": "Poné cuánto pagó, o destildá «Ya pagó». Sin monto, el ticket le diría al cadete que cobre.",
    "comandas.dlv.card.paidNoMethod": "Pagó {paid} · falta el medio",
    "comandas.dlv.warn.paidNoMethod": "Pagó, pero falta con qué medio",
    "comandas.dlv.warn.noBag": "El ticket de la bolsa no salió",
    "comandas.dlv.warn.print": "Imprimir",
    "comandas.dlv.cobro.paidNoMethod": "Ya pagó {amount}, pero no se anotó con qué: elegí el medio.",
    "comandas.cobro.appPaid": "Lo cobra {app}",
    "comandas.cobro.appPaidHint": "Te lo deposita después: esta plata no entra en la caja de hoy.",
    "comandas.cobro.payNow": "Lo cobro yo ahora",
    "comandas.cobro.payNowHint": "Pagó al repartidor o por transferencia: esta plata sí entra hoy.",
    "comandas.cobro.todayGroup": "Entra hoy",
    "comandas.cobro.deferredGroup": "Lo cobra la app",
    "comandas.cobro.commission": "Comisión {pct}%",
    "comandas.cobro.net": "Te queda",
    "comandas.cobro.gross": "Bruto",
    "comandas.cierre.today": "Entra hoy",
    "comandas.cierre.deferred": "Se cobra después",
    "comandas.cierre.deferredHint": "Lo cobraron las apps. No está en el cajón: te lo depositan más adelante.",
    "comandas.cierre.commission": "Comisión de las apps",
    "comandas.cierre.commissionDay": "Comisión de las apps (todo el día)",
    "comandas.cierre.net": "Neto (después de comisiones)",
    "comandas.cierre.byChannel": "Por canal",
    "comandas.cierre.dlvFeesTitle": "Envíos",
    "comandas.cierre.dlvFees": "Envíos cobrados ({n})",
    "comandas.cierre.dlvFeesCash": "De eso, en efectivo",
    "comandas.cierre.dlvFeesHint": "Ya están incluidos en el total: no se suman aparte. Si el envío es del cadete, lo cobrado en efectivo es lo que hay que darle.",
    "comandas.cierre.delivery": "Delivery y para llevar",
    "comandas.cierre.avgSalon": "Ticket promedio (salón)",
    "comandas.cierre.perCover": "Por cubierto",
    "comandas.cierre.perCoverTitle": "Por cubierto",
    "comandas.cierre.todayTitle": "ENTRA HOY",
    "comandas.cierre.deferredTitle": "SE COBRA DESPUES",
    "comandas.cierre.deferredNote": "lo cobran las apps - no esta en la caja",
    "comandas.cierre.commissionTitle": "Comision apps",
    "comandas.cierre.commissionOf": "comision",
    "comandas.cierre.commissionDayTitle": "Comision apps (total del dia)",
    "comandas.cierre.netTitle": "te depositan",
    "comandas.cierre.subtotalTitle": "subtotal",
    "comandas.cierre.deliveryTitle": "Delivery y para llevar",
    "comandas.settle.title": "Te deben las apps",
    "comandas.settle.hint": "Lo que cobraron las apps en este período y todavía no marcaste como depositado.",
    "comandas.settle.empty": "No te deben nada: está todo cobrado.",
    "comandas.settle.gross": "Bruto",
    "comandas.settle.commission": "Comisión",
    "comandas.settle.net": "Neto estimado",
    "comandas.settle.pending": "Pendiente",
    "comandas.settle.orders": "{n} pedidos",
    "comandas.settle.mark": "Marcar cobrado",
    "comandas.settle.markConfirm": "¿Seguro?",
    "comandas.settle.saving": "Guardando…",
    "comandas.settle.done": "Listo: {n} pedidos marcados como cobrados.",
    "comandas.settle.partial": "Se marcaron {n} de {total}. Probá de nuevo con los que faltan.",
    "comandas.settle.undone": "Se deshizo: {n} pedidos vuelven a estar pendientes.",
    "comandas.settle.settledTag": "cobrado",
    "comandas.settle.undo": "Deshacer",
    "comandas.config.delivery.title": "Delivery y para llevar",
    "comandas.config.delivery.railTitle": "Delivery",
    "comandas.config.delivery.desc": "Pedidos que no son de una mesa: los que mandás a domicilio, los que pasan a buscar y, si querés, los de las apps.",
    "comandas.config.delivery.enable": "Tomar pedidos de delivery y para llevar",
    "comandas.config.delivery.enableHint": "Aparecen arriba de las mesas, en el Turno. Al abrir uno te pide los datos del cliente (en un envío, también la dirección). No hace falta configurar nada más.",
    "comandas.config.delivery.ownTitle": "Tus pedidos",
    "comandas.config.delivery.ownDesc": "Los cobrás vos, como una mesa. Vienen listos para usar.",
    "comandas.config.delivery.envio": "Envío a domicilio",
    "comandas.config.delivery.envioDesc": "Lo lleva tu cadete. Cargás nombre, teléfono y dirección, y sale un ticket para la bolsa con cuánto cobrar y el vuelto.",
    "comandas.config.delivery.retiro": "Para llevar",
    "comandas.config.delivery.retiroDesc": "El cliente lo pasa a buscar. Cargás nombre y teléfono.",
    "comandas.config.delivery.more": "Más opciones",
    "comandas.config.delivery.remove": "Quitar",
    "comandas.config.delivery.ownNameHint": "Así queda anotado en los pedidos cerrados y en el historial. Vale para los pedidos nuevos.",
    "comandas.config.delivery.ownMarkupHint": "Si estos pedidos los cobrás más caros que en el salón. Se suma solo; los precios de la carta no se tocan.",
    "comandas.config.delivery.noneActive": "Así no vas a ver ningún botón en el Turno: prendé Envío o Para llevar, o agregá una app.",
    "comandas.config.delivery.appsTitle": "Apps de delivery",
    "comandas.config.delivery.optional": "opcional",
    "comandas.config.delivery.appsDesc": "Si también vendés por una app, agregala. Lo que cobra la app no entra en la caja de ese día: te lo deposita después.",
    "comandas.config.delivery.appsEmpty": "No agregaste ninguna app. No hace falta para tomar tus propios pedidos.",
    "comandas.config.delivery.addOther": "Otra app",
    "comandas.config.delivery.appsNote": "En un pedido de app solo se carga el número de pedido: la dirección y el cobro los tiene la app.",
    "comandas.config.delivery.platforms": "Plataformas",
    "comandas.config.delivery.name": "Nombre",
    "comandas.config.delivery.namePh": "Nombre de la app",
    "comandas.config.delivery.commission": "Comisión %",
    "comandas.config.delivery.commissionHint": "Comisión: lo que se queda la app. No cambia lo que cobrás: sirve para saber cuánto te queda de verdad.",
    "comandas.config.delivery.markup": "Recargo %",
    "comandas.config.delivery.markupHint": "Si en la app vendés más caro, poné cuánto. Se suma solo al pedido; los precios de la carta no se tocan.",
    "comandas.config.delivery.settlementDays": "Te deposita a los… (días)",
    "comandas.config.delivery.settlementDaysHint": "Para que la caja te avise si una liquidación se atrasó. En 0 no avisa.",
    "comandas.settle.overdue": "vencido hace {d} días",
    "comandas.settle.overdueTotal": "Vencido",
    "comandas.config.delivery.needName": "Ponele nombre a la app antes de guardar.",
    "comandas.config.delivery.tableWarn": "Ojo: tenés una mesa llamada “{name}”. Si empezás a usar esta sección, sacala de las mesas personalizadas para no cargar el mismo pedido dos veces.",
    "comandas.config.delivery.fee": "Costo de envío",
    "comandas.config.delivery.feeHint": "Se suma solo a cada envío, y en cada pedido lo podés cambiar. En 0 no se cobra.",
    "comandas.config.delivery.ticketTitle": "Qué se imprime",
    "comandas.config.delivery.ticketDesc": "Un envío saca dos papeles: la comanda para la cocina (número, nombre, hora y nota; sin plata ni dirección) y el ticket del pedido, que va abrochado a la bolsa (cliente, dirección, cuánto cobrar y el vuelto). Un pedido para llevar saca solo la comanda, salvo que prendas su ticket acá abajo.",
    "comandas.config.delivery.ticketEnvio": "Ticket del pedido en los envíos",
    "comandas.config.delivery.ticketEnvioDesc": "Sale solo al mandar a cocina un envío, por la comandera de la cuenta. Lo lee el cadete: adónde va, cuánto cobrar y cuánto vuelto llevar.",
    "comandas.config.delivery.ticketRetiro": "Ticket del pedido en los pedidos para llevar",
    "comandas.config.delivery.ticketRetiroDesc": "Para los pedidos por teléfono que pasan a buscar: nombre, hora y si ya pagó. Apagado, una venta de mostrador no gasta un segundo papel.",
    "comandas.config.delivery.kitchenName": "Nombre del cliente en la comanda",
    "comandas.config.delivery.kitchenNameDesc": "Grande, arriba de los platos: es lo que se grita en el mostrador y lo que distingue dos pedidos iguales.",
    "comandas.config.delivery.agentOld": "Tu comandera todavía no imprime los datos de los pedidos para llevar (se actualiza sola en unos minutos). Mientras tanto el ticket del pedido no sale solo y los papeles salen como antes.",
    "comandas.mesa.empty": "Todavía no cargaste nada. Escribí un plato arriba y apretá Enter.",
    "comandas.mesa.total": "Total",
    "comandas.mesa.menuPending": "Bajando la carta… las mesas y los pedidos funcionan igual.",
    "comandas.mesa.send": "Enviar a cocina ({n})",
    "comandas.mesa.sendAdd": "Enviar agregado ({n})",
    "comandas.mesa.reprintAll": "Reimprimir todo",
    "comandas.mesa.sending": "Enviando…",
    "comandas.mesa.sent": "enviado ✓",
    "comandas.mesa.note": "Aclaración",
    "comandas.mesa.noteFor": "Aclaración para",
    "comandas.mesa.notePlaceholder": "Ej: sin sal, bien cocido…",
    "comandas.mesa.saveNote": "Guardar",
    "comandas.mesa.cancel": "Cancelar",
    "comandas.mesa.cs.add": "agregar",
    "comandas.mesa.cs.qty": "cantidad",
    "comandas.mesa.cs.note": "aclarar",
    "comandas.mesa.cs.move": "elegir",
    "comandas.mesa.cs.send": "enviar",
    "comandas.turno.open": "Abrí una mesa:",
    "comandas.turno.openPlaceholder": "N° + Enter",
    "comandas.mesa.lineSelected": "Línea elegida — número = cantidad · + / − ajusta · Supr borra · Esc suelta",

    // Envío
    "comandas.send.nothing": "No hay ítems nuevos para enviar.",
    "comandas.send.closedOrder": "{table} ya está cerrada: no se puede mandar a cocina. Para seguir cargándole, reabrila desde «Cerradas hoy».",
    "comandas.mesa.paidElsewhere": "{table} se cobró en otro equipo. Ya está libre: abrila de nuevo para los próximos clientes.",
    "comandas.mesa.paidElsewhereUnsent": "{table} se cobró en otro equipo. {n} plato(s) que cargaste acá NO se mandaron a cocina: abrí la mesa de nuevo y cargalos.",
    "comandas.mesa.voidedElsewhere": "{table} se anuló en otro equipo. Ya está libre.",
    "comandas.mesa.voidedElsewhereUnsent": "{table} se anuló en otro equipo. {n} plato(s) que cargaste acá NO se mandaron a cocina: abrí la mesa de nuevo y cargalos.",
    "comandas.send.saveError": "No se pudo guardar el pedido: {msg}",

    // Config — mesas
    "comandas.config.tables.title": "Cantidad de mesas",
    "comandas.config.tables.desc": "Cuántas mesas mostrar en la grilla de turno.",

    // Config — general
    "comandas.config.title": "Configuración de comandas",
    "comandas.config.subtitle": "Configurá tus comanderas y cómo se ven la comanda y la cuenta. La vista previa de la derecha es el papel de 80mm real.",
    "comandas.config.title.eyebrow": "Mi local",
    "comandas.config.sections": "Secciones",
    "comandas.config.tipBox.title": "Tip:",
    "comandas.config.tipBox.body": "tocá una sección para saltar a ella. Todo lo que cambiás se ve al instante en el ticket.",
    "comandas.preview.live": "En vivo",
    "comandas.config.comanda.showWaiterDesc": "La cocina sabe a quién avisarle.",
    "comandas.config.comanda.showTimeDesc": "Hora exacta en que entró el pedido.",
    "comandas.config.comanda.showOrderNumberDesc": "Correlativo del día, para reclamos.",
    "comandas.config.comanda.groupByStationDesc": "Parrilla, cocina fría, barra… cada uno lee lo suyo.",
    "comandas.config.comanda.invertNotes": "Aclaraciones resaltadas en negro",
    "comandas.config.comanda.invertNotesDesc": "Fondo negro con letra blanca. Si en tu comandera se empasta y no se lee, apagalo: salen en negrita normal.",
    "comandas.tiempos.markHere": "Marcar hasta acá",
    "comandas.tiempos.removeMark": "Sacar la línea",
    "comandas.tiempos.pill": "{n}.º tiempo",
    "comandas.tiempos.hereAfter": "Línea acá",
    "comandas.tiempos.removeAria": "Sacar esta línea",
    "comandas.tiempos.ticket": "TIEMPO {n}",
    "comandas.tiempos.ticketWait": "TIEMPO {n} - ESPERAR",
    "comandas.config.comanda.tiempos": "Marcar tiempos con una línea",
    "comandas.config.comanda.tiemposDesc": "Para que la cocina no largue todo junto. El mozo marca hasta dónde sale ahora y qué espera a que la mesa termine lo anterior, y la comanda ya sale dividida. Sirve para entradas y principales, y también cuando alguien arranca con un plato principal. Se marca con el botón al pie del pedido (o con la tecla / si comandás con teclado), y los platos salen en el orden en que se cargaron.",
    "comandas.config.comanda.courseMode": "Cómo se ve la línea",
    "comandas.config.comanda.courseModeText": "Con texto",
    "comandas.config.comanda.courseModeLine": "Solo la raya",
    "comandas.config.comanda.courseLabel": "Qué dice la línea",
    "comandas.config.comanda.courseLabelHelp": "Escribí {n} donde quieras que salga el número de tiempo. Vacío = el texto de siempre.",
    "comandas.config.comanda.courseH": "Alto de la línea",
    "comandas.config.comanda.courseW": "Ancho de la línea",
    "comandas.config.style.title": "Cómo se lee la comanda",
    "comandas.config.style.desc": "En la cocina hay poca luz, vapor y apuro. Tocá estas opciones y mirá el ticket de al lado hasta que se lea de un vistazo; después imprimí una prueba de verdad.",
    "comandas.config.style.itemSize": "Tamaño del plato",
    "comandas.config.style.itemH": "Alto del plato",
    "comandas.config.style.itemW": "Ancho del plato",
    "comandas.config.style.noteH": "Alto de las aclaraciones",
    "comandas.config.style.noteW": "Ancho de las aclaraciones",
    "comandas.config.style.itemBold": "Nombre del plato en negrita",
    "comandas.config.style.itemBoldDesc": "Es la letra más gruesa, la misma que tiene el título COCINA. Si los platos salen desteñidos, esto es lo primero que hay que probar.",
    "comandas.config.style.noteSize": "Tamaño de las aclaraciones",
    "comandas.config.style.tableSize": "Tamaño del número de mesa",
    "comandas.config.style.stationBold": "Separadores de estación en negrita",
    "comandas.config.style.stationBoldDesc": "Las líneas “-- PARRILLA --” que dividen la comanda.",
    "comandas.config.style.sizeNormal": "Normal",
    "comandas.config.style.sizeTall": "Grande",
    "comandas.config.style.sizeTall2": "Más grande",
    "comandas.config.style.sizeBig": "Muy grande",
    "comandas.config.style.sizeAuto": "Automático",
    "comandas.config.style.paper": "Ancho del papel",
    "comandas.config.style.paperHint": "Para que la vista previa muestre la verdad. No cambia la comandera: es el ancho del rollo que ya tenés.",
    "comandas.config.style.wrapWarn": "Con “Muy grande” entran {n} caracteres por renglón: los platos de nombre largo salen partidos en dos. Se arregla poniéndoles un nombre corto para la cocina, más abajo.",
    "comandas.config.style.agentOld": "La comandera de este local se actualiza sola en unos minutos. Hasta entonces sigue imprimiendo como antes, aunque acá ya lo veas cambiado.",
    "comandas.config.style.test": "Imprimir una prueba",
    "comandas.config.kitchenNames.title": "Nombres para la cocina",
    "comandas.config.kitchenNames.desc": "Un plato puede llamarse “PENNE RIGATE CON LANGOSTINOS SALTEADOS” en la carta y salir a la cocina como “PENNE”. El chef sabe cuál es y se lee mucho más rápido. La carta, la cuenta del cliente y los reportes no cambian.",
    "comandas.config.kitchenNames.search": "Buscar un plato…",
    "comandas.config.kitchenNames.placeholder": "Nombre corto",
    "comandas.config.kitchenNames.empty": "Buscá un plato para ponerle un nombre corto.",
    "comandas.config.kitchenNames.none": "Todavía no hay ninguno. Los platos sin nombre corto salen con el nombre de la carta.",
    "comandas.config.kitchenNames.count": "{n} con nombre corto",
    "comandas.config.kitchenNames.stale": "revisar",
    "comandas.config.kitchenNames.staleHint": "Este plato cambió de nombre en la carta. Mientras tanto sale con el nombre completo: confirmalo volviendo a escribir el nombre corto.",
    "comandas.config.kitchenNames.readOnly": "Esto se configura desde el panel, no desde la pantalla del local (si no, se pisa solo).",
    "comandas.config.cuenta.showTipDesc": "Aparece calculada al pie de la cuenta.",
    "comandas.config.cuenta.footerHelper": "La última línea que lee tu cliente. Que sea tuya.",
    "comandas.config.save": "Guardar cambios",
    "comandas.config.unsaved": "Tenés cambios sin guardar",
    "comandas.config.printers.namePlaceholder": "Ej: Cocina",
    "comandas.config.printers.connected": "Conectada",
    "comandas.config.printers.notConnected": "Sin conectar",
    "comandas.config.printers.showTech": "Datos técnicos (IP y puerto)",
    "comandas.config.printers.hideTech": "Ocultar datos técnicos",
    "comandas.config.printers.addManual": "Agregar a mano",
    "comandas.config.printers.detectOnLocalPc": "¿No sabés la IP? La comandera se conecta sola desde la PC del local: abrí “Comandas” ahí → botón Impresoras.",
    "comandas.config.printers.addDetect": "Detectar comandera",
    "comandas.config.printers.billPrinter": "Comandera de la cuenta",
    "comandas.config.printers.billPrinterAuto": "Automático (caja → barra → cocina)",
    "comandas.config.printers.billPrinterHelp": "Por qué comandera sale la cuenta del cliente y el cierre del día.",
    "comandas.config.printers.unnamed": "Comandera sin nombre",
    "comandas.config.printers.viaUsb": "USB",
    "comandas.config.printers.viaNet": "Red",
    "comandas.config.printers.usbQueue": "Impresora de Windows",
    "comandas.config.printers.techHint": "Si conectás la comandera con el código de arriba, la IP se completa sola. Esto es solo para configurarla a mano.",
    "comandas.print.expired": "La comanda no se pudo confirmar (sin confirmar). Revisá la comandera y reimprimí.",
    "comandas.print.failedMixed": "MESA {table}: parte de la comanda no salió y volvió a pendientes, y otra parte no se pudo confirmar. Fijate en las comanderas antes de reimprimir.",
    "comandas.print.failedTable": "MESA {table}: la comanda NO salió. Esos platos volvieron a pendientes: revisá la comandera y tocá Enviar de nuevo.",
    "comandas.print.failedBill": "{table}: la cuenta o el ticket del pedido NO salió. Revisá la comandera y reimprimí ese papel.",
    "comandas.print.unconfirmedBill": "{table}: no se pudo confirmar si salió la cuenta o el ticket del pedido. Fijate en la comandera antes de reimprimirlo.",
    "comandas.print.failedTableAndBag": "{table}: NO salieron ni la comanda ni el ticket de la bolsa. Los platos volvieron a pendientes: revisá la comandera y tocá Enviar (el ticket sale de nuevo con la comanda).",
    "comandas.print.failedReprint": "MESA {table}: la comanda NO salió. Revisá la comandera y reimprimí la comanda completa.",
    "comandas.print.failedTableClosed": "MESA {table}: la comanda NO salió y la mesa ya se cerró. Fijate si falta hacer ese pedido.",
    "comandas.print.unconfirmedTable": "MESA {table}: no pudimos confirmar la impresión. Fijate en la comandera ANTES de reimprimir: puede haber salido igual.",
    "comandas.print.someFailed": "{n} de {total} comanda(s) no se imprimieron. Revisá esa(s) comandera(s) y reimprimí la comanda completa.",
    "comandas.print.someUnconfirmed": "{n} de {total} comanda(s) sin confirmar. Fijate en la(s) comandera(s) ANTES de reimprimir: pueden haber salido igual.",
    "comandas.send.partialNoPrinter": "{n} ítem(s) no se imprimieron: la comandera de esa estación no está disponible. Quedaron pendientes.",
    "comandas.wizard.title": "Agregar comandera",
    "comandas.wizard.detected": "Impresora encontrada",
    "comandas.wizard.close": "Cerrar",
    "comandas.wizard.back": "Atrás",
    "comandas.wizard.next": "Siguiente",
    "comandas.wizard.retry": "Reintentar",
    "comandas.wizard.howQuestion": "¿Cómo está enchufada la comandera?",
    "comandas.wizard.usb": "Por USB",
    "comandas.wizard.usbDesc": "Con cable USB a esta computadora.",
    "comandas.wizard.net": "Por red (Ethernet)",
    "comandas.wizard.netDesc": "Con cable de red al router o extensor.",
    "comandas.wizard.detectingUsb": "Buscando impresoras USB…",
    "comandas.wizard.detectingNet": "Buscando la comandera en la red…",
    "comandas.wizard.pickUsb": "Elegí la impresora USB:",
    "comandas.wizard.pickNet": "Comandera encontrada:",
    "comandas.wizard.noUsb": "No veo impresoras USB. Si aparece en 'No especificado', falta el driver: instalá 'Generic / Text Only' en su puerto USB y reintentá.",
    "comandas.wizard.noNet": "No la encontré sola. Escribí la IP a mano:",
    "comandas.wizard.foundNet": "encontrada en la red",
    "comandas.wizard.netExcluded": "(Oculté las ya registradas.)",
    "comandas.wizard.netTestHint": "Elegí una; después imprimí una prueba para confirmar cuál es.",
    "comandas.wizard.netAllRegistered": "Las que encontré ya están registradas. Si es nueva, escribí su IP a mano.",
    "comandas.wizard.netTestBeforeRegister": "Imprimí una prueba antes de registrar: el ticket sale por la impresora real, así confirmás cuál es.",
    "comandas.wizard.factoryBtn": "Fijarle IP (impresora en 192.168.123.100)",
    "comandas.wizard.factoryHint": "Para una impresora en 192.168.123.100 (de fábrica). La PC tiene que estar por CABLE (no WiFi) en el mismo router que la impresora. Tarda 1-2 min.",
    "comandas.wizard.factoryWorking": "Configurando… hasta 1-2 min. No cierres esta ventana.",
    "comandas.wizard.factoryNotFound": "No la encontré. Fijate que esté prendida, en 192.168.123.100 (self-test), y que la PC esté por cable en el mismo router.",
    "comandas.wizard.orManualIp": "O escribí la IP a mano",
    "comandas.wizard.changeIpBtn": "Cambiar la IP (si dos quedaron iguales)",
    "comandas.wizard.changeIpTitle": "Cambiar la IP de una impresora",
    "comandas.wizard.changeIpHint": "Apagá las demás y dejá prendida SOLO esta. Poné su IP actual (mirá el self-test). Después confirmá con el self-test que cambió.",
    "comandas.wizard.changeIpCurLabel": "IP actual de la impresora",
    "comandas.wizard.changeIpGo": "Cambiar IP",
    "comandas.wizard.changeIpWorking": "Cambiando la IP…",
    "comandas.wizard.errChangeIp": "No pude cambiar la IP. Fijate que esté prendida y que apagaste las otras.",
    "comandas.wizard.usbCfgBtn": "Configurar por USB",
    "comandas.wizard.usbCfgWhy": "Le mando la IP por el cable USB (no depende de la red).",
    "comandas.wizard.usbCfgTitle": "Configurar por USB",
    "comandas.wizard.usbCfgStep1b": "Desenchufá otras impresoras USB (para no confundirlas).",
    "comandas.wizard.usbCfgStep1": "Enchufá la impresora nueva por USB.",
    "comandas.wizard.usbCfgStep2": "Prendela y esperá que Windows la reconozca.",
    "comandas.wizard.usbCfgStep3": "Tocá \"Configurar por USB\": le fijo una IP de tu red.",
    "comandas.wizard.usbCfgDetect": "Detectar impresora USB",
    "comandas.wizard.usbCfgPick": "¿Cuál es la impresora nueva?",
    "comandas.wizard.usbCfgNoQueue": "No veo impresoras USB. Si aparece en 'No especificado', instalale el driver 'Generic / Text Only' y reintentá.",
    "comandas.wizard.usbCfgGo": "Configurar esta",
    "comandas.wizard.usbCfgWorking": "Configurando…",
    "comandas.wizard.usbCfgSent": "IP enviada por USB:",
    "comandas.wizard.usbReplug1": "Desenchufá el cable que usaste para configurar.",
    "comandas.wizard.usbReplug2": "Enchufá el cable de red al extensor/router.",
    "comandas.wizard.usbReplug3": "Prendela y esperá ~20 seg.",
    "comandas.wizard.usbReplugTest": "Ya está conectada — imprimir prueba",
    "comandas.wizard.usbCfgReplug": "Confirmá con el self-test que la IP cambió. Si salió la prueba, registrala.",
    "comandas.wizard.errUsbCfg": "No pude configurar por USB. Fijate que esté enchufada por USB y prendida.",
    "comandas.wizard.offline": "sin conexión",
    "comandas.wizard.nameUsb": "Ej: Cocina (USB)",
    "comandas.wizard.nameNet": "Ej: Barra",
    "comandas.wizard.test": "Imprimir prueba",
    "comandas.wizard.register": "Registrar",
    "comandas.wizard.working": "Un momento…",
    "comandas.wizard.testOk": "✓ Salió la prueba. Si viste el ticket, registrala.",
    "comandas.wizard.testFail": "No se pudo imprimir la prueba",
    "comandas.wizard.done": "✓ ¡Comandera lista!",
    "comandas.wizard.errGeneric": "Algo salió mal. Reintentá.",
    "comandas.wizard.errDetect": "No se pudo detectar. Reintentá.",
    "comandas.wizard.errTest": "No se pudo imprimir la prueba.",
    "comandas.wizard.errRegister": "No se pudo registrar la comandera.",
    "comandas.config.local.useMenu": "Usar datos del menú",
    "comandas.config.comanda.desc": "Es el ticket que sale en la cocina. Elegí qué mostrar (nunca lleva precios).",
    "comandas.config.cuenta.desc": "Es la pre-cuenta que se le da al cliente.",
    "comandas.config.advanced.title": "Opciones avanzadas",
    "comandas.config.advanced.desc": "Ruteo por comandera, ventas por mozo y hora de comienzo del día. Solo si lo necesitás.",
    "comandas.config.saving": "Guardando…",
    "comandas.config.saved": "Configuración guardada",

    // Config — comanderas
    "comandas.config.printers.title": "Comanderas",
    "comandas.config.printers.desc": "Las impresoras del local. Cada una tiene su IP y su estación.",
    "comandas.config.printers.add": "Agregar comandera",
    "comandas.config.printers.name": "Nombre",
    "comandas.config.printers.ip": "IP",
    "comandas.config.printers.port": "Puerto",
    "comandas.config.printers.station": "Estación",
    "comandas.config.printers.empty": "Todavía no cargaste ninguna comandera.",
    "comandas.config.printers.test": "Imprimir prueba",
    "comandas.config.printers.testing": "Enviando…",
    "comandas.config.printers.remove": "Quitar",
    "comandas.config.printers.autoDetected": "Detectada por el agente",

    // Estaciones
    "comandas.station.cocina": "Cocina",
    "comandas.station.barra": "Barra",
    "comandas.station.caja": "Caja",

    // Config — local
    "comandas.config.local.title": "Datos del local (para la cuenta)",
    "comandas.config.local.desc": "Aparecen en el encabezado de la cuenta que se le da al cliente.",
    "comandas.config.local.name": "Nombre del local",
    "comandas.config.local.address": "Dirección",
    "comandas.config.local.phone": "Teléfono",

    // Config — comanda template
    "comandas.config.comanda.title": "Comanda de cocina",
    "comandas.config.comanda.showWaiter": "Mostrar el mozo",
    "comandas.config.comanda.showTime": "Mostrar la hora",
    "comandas.config.comanda.showOrderNumber": "Mostrar N° de comanda",
    "comandas.config.comanda.groupByStation": "Agrupar por estación",
    "comandas.config.comanda.noPrices": "La comanda de cocina NUNCA lleva precios (así debe ser).",

    // Config — cuenta template
    "comandas.config.cuenta.scale": "Tamaño de la letra",
    "comandas.config.cuenta.scale1": "Normal",
    "comandas.config.cuenta.scale2": "Grande",
    "comandas.config.cuenta.scale3": "Muy grande",
    "comandas.config.cuenta.scaleHelper": "Agranda la cuenta entera, no una parte. Crece a lo alto: los nombres de los platos no se cortan y los precios quedan alineados. «Muy grande» usa casi el doble de papel.",
    "comandas.config.cuenta.title": "Cuenta (cliente)",
    "comandas.config.cuenta.showTip": "Sugerir propina",
    "comandas.config.cuenta.tipPercent": "Porcentaje sugerido",
    "comandas.config.cuenta.footer": "Mensaje final",
    "comandas.config.cuenta.legendLocked": "Leyenda legal fija (no se puede editar): protege al local y a vos de que la cuenta se confunda con una factura.",

    // Config — adicionales
    "comandas.config.addons.title": "Adicionales fuera de carta",
    "comandas.config.addons.desc": "Ítems cobrables que no están en la carta (cubierto, extra crema…). Después los buscás rápido al cargar el pedido.",
    "comandas.config.addons.add": "Agregar adicional",
    "comandas.config.addons.name": "Nombre",
    "comandas.config.addons.price": "Precio",
    "comandas.config.addons.empty": "Sin adicionales todavía.",
    "comandas.config.addons.route": "Comandera",
    "comandas.config.addons.routeHint": "“No imprime” = ese adicional NO sale por la comanda, pero se cobra igual. “Por defecto” = como hasta ahora.",
    "comandas.config.addons.needName": "Poné el nombre del adicional: si lo dejás vacío, se borra al guardar.",

    // Config — aclaraciones frecuentes
    "comandas.config.quickNotes.title": "Aclaraciones frecuentes",
    "comandas.config.quickNotes.desc": "Se eligen con un toque al aclarar un plato (sin sal, bien cocido…).",
    "comandas.config.quickNotes.add": "Agregar",
    "comandas.config.quickNotes.placeholder": "Nueva aclaración…",

    // Config — día de negocio
    "comandas.config.dayRollover.title": "Comienzo del día",
    "comandas.config.dayRollover.desc": "Hora en que arranca un nuevo 'día de negocio'. Ponela en una hora tranquila de la madrugada (no a la que cierra el bar), así el turno noche no se parte y tenés tiempo de hacer la caja.",
    "comandas.config.separateTickets.title": "Ticket separado por estación",
    "comandas.config.separateTickets.desc": "Cocina y barra salen en comandas cortadas aparte (una para llevar a cada lado), aunque usen la misma comandera.",
    "comandas.config.revokeDevices.button": "Desvincular celulares",
    "comandas.config.revokeDevices.desc": "Corta el acceso de todos los celulares vinculados. Tienen que volver a escanear el QR. Útil si echás a un mozo.",
    "comandas.config.revokeDevices.confirm": "¿Desvincular todos los celulares? Todos los mozos van a tener que volver a escanear el QR.",
    "comandas.config.revokeDevices.done": "Listo. Los celulares quedaron desvinculados — pediles que escaneen el QR de nuevo (puede tardar hasta 2 minutos en aplicarse).",

    // Preview
    "comandas.preview.title": "Vista previa (papel 80mm)",
    "comandas.preview.comanda": "Comanda",
    "comandas.preview.cuenta": "Cuenta",
    "comandas.preview.delivery": "Delivery",
    "comandas.preview.deliveryKitchen": "Comanda (cocina)",
    "comandas.preview.deliveryBag": "Ticket del pedido (va en la bolsa)",

    // Toasts de impresión
    "comandas.print.queued": "Enviado a la comandera… {table}",
    "comandas.print.printing": "Imprimiendo…",
    "comandas.print.done": "{table} → ¡impreso! ✓",
    "comandas.print.queuedOk": "{table} → en la comandera ✓",
    "comandas.print.error": "Falló la impresión: {msg}",
    "comandas.print.noPrinter": "Primero agregá una comandera con su IP.",
    "comandas.print.slow": "{table}: tarda más de lo normal. Esperá antes de reimprimir…",
    "comandas.print.timeout": "{table}: sin confirmación. Fijate en la comandera ANTES de reimprimir: puede haber salido igual.",
    // ── Plano del salón (Turno › Grilla | Plano, editor y su sección en Configuración) ──
    "comandas.plan.view.aria": "Cómo ver las mesas",
    "comandas.plan.view.grid": "Grilla",
    "comandas.plan.view.plan": "Plano",
    "comandas.plan.miniHint": "Tocá una parte para acercarte",
    "comandas.plan.miniOpen": "{open} de {total} abiertas",
    "comandas.plan.outside": "Fuera del plano",
    "comandas.plan.outsideFree": "+{n} libres",
    "comandas.plan.items": "{n} prod.",
    "comandas.plan.cfg.title": "Plano del salón",
    "comandas.plan.cfg.desc": "Dibujá tu salón y el Turno te muestra cada mesa en su lugar, con el color de cómo está.",
    "comandas.plan.cfg.empty": "Todavía no dibujaste tu salón. Es opcional: si no lo dibujás, el Turno sigue con la grilla de siempre.",
    "comandas.plan.cfg.draw": "Dibujar mi salón",
    "comandas.plan.cfg.edit": "Editar el plano",
    "comandas.plan.cfg.placed": "{n} de {total} mesas en el plano",
    "comandas.plan.cfg.noTables": "Todavía no pusiste ninguna mesa en el plano: hasta que pongas al menos una, el Turno sigue con la grilla.",
    "comandas.plan.cfg.start": "Al abrir el Turno, mostrar",
    "comandas.plan.cfg.startDesc": "Cada equipo puede cambiar con el botón Grilla | Plano; cuando se vuelve a abrir, arranca como digas acá.",
    "comandas.plan.cfg.cloudOnly": "El plano se dibuja desde el panel en la nube, en esta misma sección.",
    "comandas.plan.ed.title": "Plano del salón",
    "comandas.plan.ed.back": "Volver",
    "comandas.plan.ed.save": "Guardar",
    "comandas.plan.ed.saving": "Guardando…",
    "comandas.plan.ed.saved": "Guardado",
    "comandas.plan.ed.unsaved": "Sin guardar",
    "comandas.plan.ed.saveError": "No se pudo guardar. Revisá la conexión y probá de nuevo.",
    "comandas.plan.ed.undo": "Deshacer",
    "comandas.plan.ed.redo": "Rehacer",
    "comandas.plan.ed.cancel": "Cancelar",
    "comandas.plan.ed.clear": "Empezar de nuevo",
    "comandas.plan.ed.clearConfirm": "¿Borrar todo el plano? Lo podés deshacer mientras no guardes.",
    "comandas.plan.ed.clearYes": "Borrar todo",
    "comandas.plan.ed.canvas": "Hoja del plano",
    "comandas.plan.ed.tool.move": "Mover",
    "comandas.plan.ed.tool.wall": "Pared",
    "comandas.plan.ed.tool.text": "Nombre",
    "comandas.plan.ed.tool.tables": "Mesas",
    "comandas.plan.ed.tip.move": "Arrastrá paredes, nombres y mesas para acomodarlos; arrastrando el fondo movés la hoja. Tocá uno para cambiarlo o borrarlo.",
    "comandas.plan.ed.tip.wall": "Arrastrá de una punta a la otra para dibujar una pared. Queda recta y se une sola con las otras. La puerta es el hueco que dejás. Para mover la hoja, usá dos dedos o volvé a Mover.",
    "comandas.plan.ed.tip.text": "Tocá donde va el nombre de esa parte del local: salón, vereda, patio…",
    "comandas.plan.ed.tip.place": "Tocá el plano donde va la mesa {t}.",
    "comandas.plan.ed.tip.allPlaced": "Todas tus mesas están en el plano. Arrastralas para acomodarlas.",
    "comandas.plan.ed.tray.title": "Sin ubicar ({n})",
    "comandas.plan.ed.tray.all": "Poner todas en filas",
    "comandas.plan.ed.tray.done": "Todas las mesas están en el plano.",
    "comandas.plan.ed.tray.hint": "Las mesas que agregues o borres acá cambian también en Configuración › Cantidad de mesas.",
    "comandas.plan.ed.tray.orphans": "{list}: ya no son mesas de tu local, así que no se ven en el Turno.",
    "comandas.plan.ed.tray.orphansOut": "Sacarlas del plano",
    "comandas.plan.ed.tray.add": "Agregar mesa",
    "comandas.plan.ed.tray.deleteLeft": "Borrar las que sobran ({n})",
    "comandas.plan.ed.newTable.label": "Mesa nueva: número o nombre",
    "comandas.plan.ed.newTable.hint": "Después tocá la hoja donde va.",
    "comandas.plan.ed.newTable.ok": "Agregar",
    "comandas.plan.ed.newTable.empty": "Escribí un número o un nombre.",
    "comandas.plan.ed.newTable.long": "Un nombre más corto (hasta 20 letras).",
    "comandas.plan.ed.newTable.comma": "Sin comas, por favor.",
    "comandas.plan.ed.newTable.exists": "Ya hay una mesa {t}.",
    "comandas.plan.ed.newTable.full": "Llegaste al máximo de mesas con nombre (200).",
    "comandas.plan.ed.left.title": "Borrar las mesas que sobran",
    "comandas.plan.ed.left.body": "Se borran de tu local: {list}. Si después te falta alguna, la agregás de nuevo desde acá.",
    "comandas.plan.ed.left.busy": "Quedan las que tienen un pedido abierto: {list}.",
    "comandas.plan.ed.left.one": "La 1 queda: la numeración de las mesas arranca ahí.",
    "comandas.plan.ed.left.tooMany": "Todas juntas no se pueden borrar: quedarían más de 200 mesas con nombre. Bajá la cantidad en Configuración › Cantidad de mesas.",
    "comandas.plan.ed.left.yes": "Borrar ({n})",
    "comandas.plan.ed.left.ok": "Entendido",
    "comandas.plan.ed.orphan": "Ya no es una mesa de tu local",
    "comandas.plan.ed.sel.table": "Mesa {t}",
    "comandas.plan.ed.sel.wall": "Pared",
    "comandas.plan.ed.sel.wallHint": "Arrastrá los puntos de las puntas para alargarla o achicarla.",
    "comandas.plan.ed.sel.text": "Nombre",
    "comandas.plan.ed.sel.unplace": "Sacar del plano",
    "comandas.plan.ed.sel.rename": "Cambiar",
    "comandas.plan.ed.sel.renameTable": "Cambiar número o nombre",
    "comandas.plan.ed.renameTable.label": "Nuevo número o nombre para la mesa {t}",
    "comandas.plan.ed.renameTable.hint": "Cambia en el plano, en el Turno y en Configuración.",
    "comandas.plan.ed.renameTable.ok": "Cambiar",
    "comandas.plan.ed.renameTable.busy": "La {t} tiene un pedido abierto: el nombre se le cambia cuando se cobre.",
    "comandas.plan.ed.renameTable.one": "La 1 no se puede cambiar: la numeración de las mesas arranca ahí.",
    "comandas.plan.ed.sel.delete": "Borrar",
    "comandas.plan.ed.text.label": "¿Cómo se llama esta parte?",
    "comandas.plan.ed.text.placeholder": "Ej.: Salón",
    "comandas.plan.ed.text.ok": "Listo",
    "comandas.plan.ed.text.suggestions": "Salón,Vereda,Patio,Barra,Cocina,Baños,Entrada,Terraza",
    "comandas.plan.ed.start.title": "¿Cómo arrancamos?",
    "comandas.plan.ed.start.room": "Un salón con todas tus mesas",
    "comandas.plan.ed.start.roomDesc": "Cuatro paredes y tus {n} mesas en filas. Un toque y ya anda: después movés lo que quieras.",
    "comandas.plan.ed.start.rows": "Solo las mesas, en filas",
    "comandas.plan.ed.start.rowsDesc": "Sin paredes: las dibujás vos, si querés.",
    "comandas.plan.ed.start.blank": "Hoja en blanco",
    "comandas.plan.ed.start.blankDesc": "Dibujás todo desde cero.",
    "comandas.plan.ed.start.entrance": "Entrada",
    "comandas.plan.ed.zoomIn": "Acercar",
    "comandas.plan.ed.zoomOut": "Alejar",
    "comandas.plan.ed.zoomFit": "Ver todo",
    "comandas.plan.ed.exit.title": "Tenés cambios sin guardar",
    "comandas.plan.ed.exit.body": "Si salís ahora, se pierde lo que cambiaste desde la última vez que guardaste.",
    "comandas.plan.ed.exit.save": "Guardar y salir",
    "comandas.plan.ed.exit.discard": "Salir sin guardar",
    "comandas.plan.ed.exit.stay": "Seguir dibujando",
    "comandas.plan.ed.recover.text": "Quedó un plano sin guardar de la última vez.",
    "comandas.plan.ed.recover.yes": "Recuperarlo",
    "comandas.plan.ed.recover.no": "Descartar",
  },

  en: {
    "comandas.menuDashboard.title": "Orders",
    "comandas.menuDashboard.desc": "Take table orders and send tickets to the kitchen.",
    "comandas.menuDashboard.badge": "New",
    "comandas.nav.back": "Back to panel",
    "comandas.nav.turno": "Service",
    "comandas.nav.config": "Settings",
    "comandas.nav.historial": "History",
    "comandas.nav.stock": "Stock",
    // ── Stock ──
    "comandas.hist.voidedItems": "Voided dishes ({n})",
    "comandas.hist.voidedItemsPaid": "The ones on a table that WAS charged are the ones to look at: that dish was cooked and nobody paid for it.",
    "comandas.hist.viOpenTable": "OPEN TABLE",
    "comandas.hist.viVoidTable": "VOIDED TABLE",
    "comandas.hist.viMerged": "MERGED TABLE",
    "comandas.hist.voidedItemsHint": "They were sent to the kitchen and then removed from the bill. It can be legitimate (added to the wrong table, came out wrong) or not: that is why the name and time are kept.",
    "comandas.hist.voided": "Voided ({n})",
    "comandas.hist.voidedHint":
      "They don't add to the totals: they were never charged. It lists the ones that sent something to the kitchen and the ones voided after the bill was printed for the customer.",
    "comandas.stale.bar": "{n} table(s) left open from previous days · {total} uncharged",
    "comandas.stale.see": "View",
    "comandas.stale.eyebrow": "Left open",
    "comandas.stale.title": "Tables from previous days",
    "comandas.stale.hint":
      "The day was closed and these tables were never charged or voided. Bring them to today to charge them, or void them if they won't be charged. Anything already sent to the kitchen has been deducted from stock anyway.",
    "comandas.stale.meta": "{items} item(s) · {total}",
    "comandas.stale.bring": "Bring to today",
    "comandas.stale.void": "Void",
    "comandas.stale.voidConfirm": "Sure? Void",
    "comandas.stock.out": "Out of stock",
    "comandas.stock.left": "{n} left",
    "comandas.stock.blocked": "Out of stock: {name}",
    "comandas.stock.eyebrow": "Inventory",
    "comandas.stock.title": "Stock",
    "comandas.stock.subtitle": "Each ingredient's balance is computed for you: it starts from your count and subtracts what gets sold, using your Costs recipes.",
    "comandas.stock.refresh": "Refresh",
    "comandas.stock.error.title": "Couldn't load stock",
    "comandas.stock.error.body": "Firestore rejected the read. Usually the comandas rules aren't deployed yet.",
    "comandas.stock.noIng.title": "You haven't added ingredients yet",
    "comandas.stock.noIng.body": "Stock uses the ingredients and recipes you set up in Costs. Add them there and come back to pick which ones to track.",
    "comandas.stock.noIng.cta": "Go to Costs",
    "comandas.stock.banner.out": "{n} out of stock",
    "comandas.stock.banner.low": "{n} to restock",
    "comandas.stock.banner.need": "{n} without an initial count",
    "comandas.stock.banner.quickNoStock": "{n} sold dish(es) do NOT reduce stock (quick-costed). Add their detailed recipe so they discount.",
    "comandas.stock.banner.ok": "All good",
    "comandas.stock.inventory.title": "Inventory",
    "comandas.stock.inventory.desc": "Estimated balance of each ingredient you track. A physical count recalibrates it.",
    "comandas.stock.inventory.empty": "You're not tracking any ingredient yet. Pick some below.",
    "comandas.stock.row.consumed": "Used {qty} {unit} this period",
    "comandas.stock.row.needCount": "Needs count",
    "comandas.stock.row.min": "Min",
    "comandas.stock.status.ok": "OK",
    "comandas.stock.status.low": "Low",
    "comandas.stock.status.out": "Out",
    "comandas.stock.status.unknown": "No count",
    "comandas.stock.status.stale": "Old count",
    "comandas.stock.row.stale": "Count too old — recount",
    "comandas.stock.row.recipeIssue": "⚠ Check the unit in the recipe",
    "comandas.stock.act.purchase": "Add",
    "comandas.stock.act.waste": "Waste",
    "comandas.stock.act.count": "Count",
    "comandas.stock.act.adjust": "Adjust",
    "comandas.stock.act.untrack": "Stop tracking",
    "comandas.stock.track.title": "Ingredients to track",
    "comandas.stock.track.desc": "Choose which ingredients to control. Tap one to start tracking it (then do the initial count).",
    "comandas.stock.track.allTracked": "You're tracking all your ingredients.",
    "comandas.stock.movs.title": "Movements",
    "comandas.stock.movs.desc": "Latest purchases, waste, adjustments and counts.",
    "comandas.stock.movs.empty": "No movements yet.",
    "comandas.stock.movType.count": "Count",
    "comandas.stock.movType.purchase": "Purchase",
    "comandas.stock.movType.waste": "Waste",
    "comandas.stock.movType.adjust": "Adjustment",
    "comandas.stock.modal.count": "How much is there NOW? This sets the balance and starts counting from here.",
    "comandas.stock.modal.purchase": "How much came in? Added to stock.",
    "comandas.stock.modal.waste": "How much was lost, broken or expired? Subtracted from stock.",
    "comandas.stock.modal.adjust": "Manual correction. Use a negative number to subtract (e.g. -2).",
    "comandas.stock.modal.notePlaceholder": "Note (optional)",
    "comandas.stock.modal.cancel": "Cancel",
    "comandas.stock.modal.confirm": "Save",
    "comandas.turno.title": "Service — tables",
    "comandas.turno.items": "items",
    "comandas.turno.free": "Free",
    "comandas.turno.opened": "Open",
    "comandas.turno.pending": "Order not sent",
    "comandas.turno.sent": "Sent to kitchen",
    "comandas.mesa.title": "Table",
    "comandas.mesa.searchPlaceholder": "Type and Enter… (e.g. burger, coke, cover)",
    "comandas.turno.eyebrow": "Service in progress",
    "comandas.turno.openHint": "Tap a table, or type the number",
    "comandas.turno.openGo": "Open table",
    "comandas.turno.summaryOpen": "{open} of {total} tables open",
    "comandas.turno.noPrinterLocal": "No printer set up yet. Tap “Printers” to connect one — until then orders won’t print.",
    "comandas.turno.printerConnecting": "Connecting to the printer… the agent is reconnecting it by itself, no need to do anything.",
    "comandas.turno.noPrinterCloud": "No printer connected yet. Set it up from the local PC (open “Comandas” there → Printers).",
    "comandas.mesa.searchHint": "Enter adds · 1-9 quantity",
    "comandas.mesa.ticketLabel": "Table order",
    "comandas.mesa.itemsCount": "{n} items",
    "comandas.mesa.emptyShort": "empty",
    "comandas.mesa.products": "Items",
    "comandas.mesa.allSent": "All sent",
    "comandas.mesa.lineNew": "New",
    "comandas.mesa.lineSent": "In kitchen",
    "comandas.mesa.editHint": "1-9 quantity · +/− adjust · Del remove · Enter done",
    "comandas.mesa.shortcutsTitle": "Keyboard shortcuts",
    "comandas.mesa.bill": "Charge / close table",
    "comandas.mesa.close": "Close table",
    "comandas.mesa.billSoonTitle": "Coming soon: charge and close table",
    "comandas.mesa.soon": "Soon",
    "comandas.mesa.noteEyebrow": "Note",
    "comandas.mesa.justOpened": "just opened",
    "comandas.mesa.minAgo": "{m} min ago",
    "comandas.mesa.hAgo": "{h}h {m}m ago",
    "comandas.mesa.sc.add": "Adds the highlighted product",
    "comandas.mesa.sc.move": "Choose among results",
    "comandas.mesa.sc.qtyMatch": "With a match: adds that quantity",
    "comandas.mesa.sc.qtyPrefix": "Number first = quantity",
    "comandas.mesa.sc.note": "Note on the last line",
    "comandas.mesa.sc.send": "Sends to kitchen · empty returns to tables",
    "comandas.mesa.sc.dlv": "Customer and address",
    "comandas.mesa.sc.dlvApp": "App order number",
    "comandas.mesa.sc.dlvRetiro": "Name and phone",
    "comandas.mesa.sc.dlvPay": "Time and payment",
    "comandas.turno.billed": "Bill requested",
    "comandas.cobro.title": "Close table",
    "comandas.cobro.printBill": "Print bill",
    "comandas.cobro.reprintBill": "Reprint bill",
    "comandas.cobro.printing": "Printing…",
    "comandas.cobro.billPrinted": "Bill for {table} printed ✓",
    "comandas.cobro.method": "How did they pay?",
    "comandas.cobro.oneMethod": "One method",
    "comandas.cobro.splitPay": "Split payment",
    "comandas.cobro.remaining": "Left",
    "comandas.cobro.over": "Over",
    "comandas.cobro.settled": "Done ✓",
    "comandas.cobro.addPay": "Add",
    "comandas.cobro.addRest": "Rest",
    "comandas.cobro.amountPh": "Amount $",
    "comandas.cobro.splitHint": "You split into {n} bills — pick the method for each",
    "comandas.cobro.confirm": "Close table",
    "comandas.cobro.charging": "Closing…",
    "comandas.cobro.done": "{table} closed ✓",
    "comandas.cobro.needMethod": "One of the parts is missing its payment method.",
    "comandas.cobro.sumMismatch": "The payments do not add up to the table total. Check the breakdown.",
    "comandas.covers.title": "How many covers?",
    "comandas.covers.confirm": "Open table",
    "comandas.covers.skip": "Skip",
    "comandas.covers.chargeLabel": "Covers",
    "comandas.covers.priceNote": "{money} per cover",
    "comandas.covers.takeaway": "Takeaway",
    "comandas.covers.placeholder": "Other amount",
    "comandas.covers.short": "{n} cov.",
    "comandas.covers.add": "Covers",
    "comandas.config.covers.title": "Covers",
    "comandas.config.covers.track": "Ask for covers when opening a table",
    "comandas.config.covers.desc": "When opening a table it asks how many diners. Adds to the day's total covers at close.",
    "comandas.config.covers.perCover": "Show spend per cover",
    "comandas.config.covers.perCoverDesc": "Sales divided by covers, in the day close, the history and the printed ticket. It's the number that doesn't change whether people came in twos or sixes.",
    "comandas.config.covers.price": "How much you charge per cover",
    "comandas.config.covers.priceHint": "It's added to the bill based on the covers you set on the table. Leave it at 0 if you don't charge a cover. Changing the price doesn't touch tables that are already open.",
    "comandas.config.waiterSales.title": "Sales by waiter",
    "comandas.config.waiterSales.track": "Show the per-waiter breakdown at close",
    "comandas.config.waiterSales.desc": "Adds up each waiter's sales (who closed each table) in the day close. Only shows if more than one worked.",
    "comandas.config.tips.title": "Tips",
    "comandas.config.tips.track": "Track tips per waiter",
    "comandas.config.tips.desc": "When closing a table a field appears to note the tip. The day close totals tips per waiter (to split) and shows each one's %.",
    "comandas.cobro.tip": "Tip (optional)",
    "comandas.cobro.tipCash": "In cash",
    "comandas.cobro.tipWhere": "Was the tip in cash?",
    "comandas.cobro.payTitle": "How did they pay?",
    "comandas.cobro.tipWithPay": "With the payment",
    "comandas.cierre.tipsByWaiter": "Tips by waiter",
    "comandas.config.routing.title": "Station routing",
    "comandas.config.routing.desc": "Choose which printer each category prints on. “No ticket” = no kitchen ticket (e.g. fridge drinks) but still on the bill. Untouched, everything goes to Kitchen.",
    "comandas.config.routing.empty": "Load the menu to see the categories.",
    "comandas.config.routing.none": "No ticket",
    "comandas.config.routing.category": "Category",
    "comandas.config.routing.station": "Printer",
    "comandas.config.routing.separate": "Own ticket",
    "comandas.config.routing.default": "Default",
    "comandas.config.routing.addonsEmpty": "No off-menu add-ons yet.",
    "comandas.config.tables.count": "Count (tables 1..N)",
    "comandas.config.tables.customLabel": "Extra custom tables (optional)",
    "comandas.config.tables.customHint": "Comma-separated: Bar, Delivery, Patio 1. Added on top of the numbered tables above (they don't replace them).",
    "comandas.waiter.eyebrow": "Local mode",
    "comandas.waiter.title": "What's your name?",
    "comandas.waiter.hint": "So we know which waiter took each table. Saved on this phone.",
    "comandas.waiter.placeholder": "Your name",
    "comandas.waiter.save": "Save",
    "comandas.waiter.later": "Later",
    "comandas.waiter.chip": "Waiter: {name}",
    "comandas.waiter.set": "Set your name",
    "comandas.closed.eyebrow": "Today",
    "comandas.closed.title": "Tables closed today",
    "comandas.closed.button": "Closed today ({n})",
    "comandas.closed.reopen": "Reopen",
    "comandas.closed.reprint": "Reprint",
    "comandas.closed.done": "Done",
    "comandas.voided.button": "Voided today ({n})",
    "comandas.unpaid.chip": "Unpaid ({n})",
    "comandas.unpaid.eyebrow": "Still open",
    "comandas.unpaid.title": "{n} unpaid",
    "comandas.unpaid.hint": "They're not in the day close. Tap one to charge or void it.",
    "comandas.unpaid.since": "opened {time}",
    "comandas.unpaid.total": "Total unpaid",
    "comandas.unpaid.banner": "{n} still unpaid ({total}): not included in this summary.",
    "comandas.unpaid.see": "See",
    "comandas.unpaid.goTurno": "Go to the shift",
    "comandas.cierre.unpaidTitle": "UNPAID: {n}",
    "comandas.cierre.unpaidNote": "Not in this close: charge or void them.",
    "comandas.voided.eyebrow": "Control",
    "comandas.voided.title": "Tables voided today",
    "comandas.voided.hint": "Tables voided without charging. If it says BILL PRINTED, the customer had already been given the bill.",
    "comandas.voided.billed": "BILL PRINTED",
    "comandas.voided.items": "{n} item(s)",
    "comandas.voided.noName": "no name",
    "comandas.voided.total": "Voided total",
    "comandas.reopen.done": "{table} reopened",
    "comandas.reopen.occupied": "Table {table} is already open. Close it or change its number before reopening this one.",
    "comandas.reopen.pickEyebrow": "Table taken",
    "comandas.reopen.pickTitle": "Table {table} is already open. Which table to reopen it in?",
    "comandas.reopen.pickHint": "Pick a free table.",
    "comandas.reopen.noneFree": "No free tables right now.",
    "comandas.reopen.pickCancel": "Cancel",
    "comandas.cancel.chip": "Cancel",
    "comandas.cancel.confirm": "Cancel {table}? It's voided without charging and leaves the open ones.",
    "comandas.cierre.button": "Day report",
    "comandas.turno.printers": "Printers",
    "comandas.cierre.title": "Day close",
    "comandas.cierre.mesas": "Tables closed",
    "comandas.cierre.covers": "Covers",
    "comandas.cierre.byMethod": "By payment method",
    "comandas.cierre.byWaiter": "By waiter",
    "comandas.hist.pickRange": "Pick the days",
    "comandas.hist.dayCount": "{n} days",
    "comandas.hist.presetToday": "Today",
    "comandas.hist.presetYesterday": "Yesterday",
    "comandas.hist.presetWeek": "This week",
    "comandas.hist.presetMonth": "This month",
    "comandas.hist.presetPrevMonth": "Last month",
    "comandas.hist.daysPicked": "{n} days picked",
    "comandas.hist.rangeSameMonth": "{m} {a}–{b}",
    "comandas.hist.rangeSpan": "{a} – {b}",
    "comandas.hist.pickDays": "Single days",
    "comandas.hist.pickDaysHint": "Tap the days you want to compare (every Saturday, for instance).",
    "comandas.hist.rangeHint": "Tap the first day, then the last one.",
    "comandas.hist.clearPick": "Clear",
    "comandas.hist.apply": "See these days",
    "comandas.hist.maxRange": "Up to 3 months at a time.",
    "comandas.hist.perDay": "{m} a day on average",
    "comandas.hist.tablesRange": "Tables charged",
    "comandas.hist.prev": "Previous",
    "comandas.hist.next": "Next",
    "comandas.hist.emptyRange": "No closed sales on those days.",
    "comandas.hist.loadFailed": "Those sales could not be read. Tap Refresh to try again.",
    "comandas.hist.scopeVisible": "of what you are looking at",
    "comandas.hist.eyebrow": "Management report",
    "comandas.hist.title": "History",
    "comandas.hist.nonFiscal": "Non-fiscal — internal control",
    "comandas.hist.emptyDay": "No closed sales that day.",
    "comandas.hist.total": "Sold",
    "comandas.hist.avgTicket": "Avg ticket",
    "comandas.hist.reprint": "Reprint day close",
    "comandas.hist.sold": "What you sold",
    "comandas.hist.soldCount": "{n} products · {u} units",
    "comandas.hist.soldSearch": "Search a dish…",
    "comandas.hist.soldNoMatch": "Nothing with that name was sold on those days.",
    "comandas.hist.soldNote": "Does not include cover charges, manually added extras or the delivery surcharge, and does not subtract discounts.",
    "comandas.hist.byQty": "By quantity",
    "comandas.hist.byMoney": "By revenue",
    "comandas.hist.flat": "All together",
    "comandas.hist.byCat": "By category",
    "comandas.hist.catUnits": "{u} units",
    "comandas.hist.noCat": "No category",
    "comandas.hist.showRest": "See the other {n}",
    "comandas.hist.tipLabel": "Tip",
    "comandas.hist.tip": "tip {m} ({how})",
    "comandas.hist.tipApart": "The tip is not part of the table total: it came in separately, through that method.",
    "comandas.hist.dlvPhone": "Phone",
    "comandas.hist.dlvTime": "For {time}",
    "comandas.hist.tables": "Tables that day",
    "comandas.hist.detailEyebrow": "Table detail",
    "comandas.hist.paidWith": "Paid with",
    "comandas.hist.loadError": "Couldn't load that day",
    "comandas.hist.refresh": "Refresh",
    "comandas.hist.last30": "Last 30 days",
    "comandas.cierre.empty": "No sales yet",
    "comandas.cierre.print": "Print close",
    "comandas.cierre.printing": "Printing…",
    "comandas.cierre.ticketTitle": "DAY CLOSE",
    "comandas.cierre.productsTitle": "PRODUCTS SOLD",
    "comandas.cierre.voidedTitle": "VOIDED (not charged)",
    "comandas.cierre.voidedItemsTitle": "Voided dishes already sent",
    "comandas.cierre.periodTitle": "PERIOD SUMMARY",
    "comandas.cierre.periodRange": "Last 30 days",
    "comandas.mesa.subtotal": "Subtotal",
    "comandas.adj.eyebrow": "Bill",
    "comandas.adj.title": "Charges & discounts",
    "comandas.adj.charge": "Charge",
    "comandas.adj.discount": "Discount",
    "comandas.adj.labelPlaceholder": "Concept (e.g. cake, service)",
    "comandas.adj.add": "Add",
    "comandas.adj.presets": "Saved",
    "comandas.adj.savePreset": "Save as preset",
    "comandas.adj.button": "Charge / discount",
    "comandas.adj.buttonN": "Adjustments ({n})",
    "comandas.cats.button": "Browse by category",
    "comandas.cats.title": "Categories",
    "comandas.cats.other": "Other",
    "comandas.cats.empty": "Menu hasn't loaded yet.",
    "comandas.cats.added": "Added: {name}",
    "comandas.void.action": "Void table (no charge)",
    "comandas.void.confirm": "Sure? Void without charging",
    "comandas.void.done": "{table} voided",
    "comandas.void.label": "Voided (no charge)",
    "comandas.void.tag": "VOID",
    "comandas.void.sentAction": "Void this item (already in kitchen)",
    "comandas.void.sentActionShort": "Void",
    "comandas.void.sentEyebrow": "Void sent item",
    "comandas.void.sentWarn": "A VOID notice prints at the kitchen printer and the item is removed from the bill.",
    "comandas.void.sentConfirm": "Yes, void",
    "comandas.void.sentConfirmN": "Void ({n})",
    "comandas.void.sentTitle": "Void sent items",
    "comandas.void.sentBusy": "Voiding…",
    "comandas.void.sentDone": "{name} voided",
    "comandas.void.sentDoneN": "{n} items voided",
    "comandas.split.button": "Split",
    "comandas.split.eyebrow": "Split the bill",
    "comandas.split.title": "How to split?",
    "comandas.split.equal": "Equal parts",
    "comandas.split.byItem": "By item",
    "comandas.split.howMany": "How many parts?",
    "comandas.split.eachPays": "Each one (÷ {n}): ",
    "comandas.split.printEqual": "Print {n} tickets",
    "comandas.split.printing": "Printing…",
    "comandas.split.pickItems": "Pick how much of each item",
    "comandas.split.tapHint": "Tap a row to add one",
    "comandas.split.each": "{price} ea.",
    "comandas.split.unassigned": "{n} left to assign",
    "comandas.split.allAssigned": "Everything is assigned",
    "comandas.split.zeroPart": "That part adds up to $0 — nothing to charge",
    "comandas.split.selected": "Selected: ",
    "comandas.split.printPart": "Print this part",
    "comandas.split.printedEqual": "{n} parts printed",
    "comandas.split.printedPart": "Part printed",
    "comandas.split.partOf": "Part {i} of {n}",
    "comandas.split.partLabel": "Bill part",
    "comandas.move.chip": "Move",
    "comandas.move.eyebrow": "Move / Merge table",
    "comandas.move.title": "Table {table} → where to?",
    "comandas.move.hint": "Free = move the whole table. Taken = merge the two.",
    "comandas.move.moveHere": "Move here",
    "comandas.move.join": "Merge",
    "comandas.move.ticketTitle": "TABLE CHANGE",
    "comandas.move.moved": "Table {from} moved to {to}",
    "comandas.move.merged": "Table {from} merged into {to}",
    "comandas.move.mergeSrcFail": "Merged, but couldn't free table {from}. Void it manually.",
    "comandas.move.confirmEyebrow": "Merge tables",
    "comandas.move.confirmTitle": "Table {from} → Table {to}",
    "comandas.move.confirmItems": "These move to table {to}:",
    "comandas.move.confirmNoItems": "Table {from} has no items.",
    "comandas.move.confirmCovers": "Covers: table {to} has {a} + table {from} has {b} → ends with {sum}",
    "comandas.move.confirmTotal": "Table {to} total: {total}",
    "comandas.move.confirmWarn": "Table {from} closes and everything stays in {to}.",
    "comandas.move.confirmBack": "Back",
    "comandas.move.confirmGo": "Merge",
    "comandas.send.sentNoPrint": "Sent (that one prints no ticket)",
    "comandas.pay.efectivo": "Cash",
    "comandas.pay.mixto": "Mixed",
    "comandas.pay.debito": "Debit",
    "comandas.pay.credito": "Credit",
    "comandas.pay.transferencia": "Transfer",
    "comandas.pay.mercadopago": "MercadoPago",
    "comandas.pay.modo": "MODO",
    "comandas.pay.cuentadni": "Cuenta DNI",
    "comandas.pay.vales": "Vouchers",
    "comandas.channel.salon": "Dine-in",
    "comandas.channel.delivery": "Delivery",
    "comandas.channel.takeaway": "Takeaway",
    "comandas.delivery.title": "Delivery & takeaway",
    "comandas.delivery.hint": "Orders that don't belong to a table.",
    "comandas.delivery.new": "New order",
    "comandas.delivery.empty": "No open orders.",
    "comandas.delivery.emptyOwn": "No open orders. Tap a button above to start one.",
    "comandas.delivery.envioSub": "We deliver it",
    "comandas.delivery.retiroSub": "Customer picks it up",
    "comandas.delivery.fromApp": "From an app:",
    "comandas.delivery.appNoAddress": "App orders don't take an address or payment: the app handles them. Delivering and charging it yourself? Open it as a Delivery from the Service screen.",
    "comandas.delivery.count": "Delivery ({n})",
    "comandas.delivery.eyebrow": "App order",
    "comandas.delivery.refTitle": "What's the order number?",
    "comandas.delivery.refHint": "The number the app shows. You'll need it later, when the app pays you out.",
    "comandas.delivery.ref": "Order no.",
    "comandas.delivery.refPh": "e.g. A4F2",
    "comandas.delivery.customer": "Customer (optional)",
    "comandas.delivery.customerPh": "Name",
    "comandas.delivery.save": "Done",
    "comandas.delivery.noMove": "An app order can't be moved or merged into a table.",
    "comandas.delivery.markup": "{pct}% markup",
    "comandas.delivery.commissionChip": "{pct}% fee",
    "comandas.delivery.items": "items",
    "comandas.delivery.gone": "That kind of order is no longer available. Open it again from the Service screen.",
    "comandas.delivery.closed": "That order isn't open anymore.",
    "comandas.dlv.kind.envio": "Delivery",
    "comandas.dlv.kind.retiro": "Takeaway",
    "comandas.dlv.orderShort": "Order {n}",
    "comandas.dlv.addCustomerEnvio": "Add customer and address",
    "comandas.dlv.addCustomerRetiro": "Add name and phone",
    "comandas.dlv.bagPrint": "Print order ticket",
    "comandas.dlv.bagReprint": "Reprint order ticket",
    "comandas.dlv.bagPrinted": "Order ticket printed ({table})",
    "comandas.dlv.bagNoPrinter": "{table}: no printer available for the bag ticket. Check it and tap “Print order ticket”.",
    "comandas.dlv.bagFailed": "{table}: the bag ticket did NOT print. Check the bill printer and tap “Print order ticket”.",
    "comandas.dlv.bagUnconfirmed": "{table}: couldn't confirm whether the bag ticket printed. Check the printer before reprinting it.",
    "comandas.dlv.feeLabel": "Delivery fee",
    "comandas.dlv.a.titleEnvio": "Who is it for, and where?",
    "comandas.dlv.a.titleRetiro": "Under what name?",
    "comandas.dlv.a.orderIs": "This is order {n}",
    "comandas.dlv.a.later": "If something's missing, fill it in later from “Customer and delivery”.",
    "comandas.dlv.a.name": "Name",
    "comandas.dlv.a.namePh": "Grace",
    "comandas.dlv.a.phone": "Phone",
    "comandas.dlv.a.phonePh": "555 123 4567",
    "comandas.dlv.a.address": "Street and number",
    "comandas.dlv.a.addressPh": "1234 Main St",
    "comandas.dlv.a.noNumber": "Missing the street number? Without it the driver can't find the house.",
    "comandas.dlv.a.floor": "Floor / apt",
    "comandas.dlv.a.floorPh": "Apt 2B",
    "comandas.dlv.a.ref": "Cross streets / directions (for the driver)",
    "comandas.dlv.a.refPh": "between Oak and Elm, green gate",
    "comandas.dlv.kbdHint": "Enter goes to the next field · Esc closes without losing what you typed",
    "comandas.dlv.b.title": "Time and payment",
    "comandas.dlv.b.whenEnvio": "When for?",
    "comandas.dlv.b.whenRetiro": "When will they pick it up?",
    "comandas.dlv.b.asap": "As soon as possible",
    "comandas.dlv.b.in30": "+30 min",
    "comandas.dlv.b.in45": "+45 min",
    "comandas.dlv.b.in60": "+1 h",
    "comandas.dlv.b.timePh": "or type the time: 2130",
    "comandas.dlv.b.timeAria": "Time",
    "comandas.dlv.b.timeBad": "I don't understand that time. Try 21:30 or 2130.",
    "comandas.dlv.b.timeIs": "Set for {time}",
    "comandas.dlv.b.fee": "Delivery fee",
    "comandas.dlv.b.pay": "How are they paying?",
    "comandas.dlv.b.payUnset": "Not set",
    "comandas.dlv.b.paid": "Already paid (you saw it credited)",
    "comandas.dlv.b.paidAmount": "Paid",
    "comandas.dlv.b.paidShort": "{amount} still to collect: the ticket will tell the driver.",
    "comandas.dlv.b.paidOver": "Paid {amount} too much.",
    "comandas.dlv.b.payWith": "How much will they pay with?",
    "comandas.dlv.b.exact": "Exact",
    "comandas.dlv.b.payWithPh": "Amount",
    "comandas.dlv.b.change": "Change: {amount}",
    "comandas.dlv.b.notEnough": "Not enough: {amount} short",
    "comandas.dlv.b.note": "Order note (prints on the kitchen ticket and the bag ticket)",
    "comandas.dlv.b.notePh": "gluten-free, add napkins…",
    "comandas.dlv.card.title": "Customer and delivery",
    "comandas.dlv.card.whenPay": "Time and payment",
    "comandas.dlv.card.noPhone": "No phone",
    "comandas.dlv.card.noAddress": "No address",
    "comandas.dlv.card.edit": "Edit",
    "comandas.dlv.send.title": "Before sending it to the kitchen",
    "comandas.dlv.send.hint": "On the order ticket, whatever is missing prints as a blank line to fill in by hand.",
    "comandas.dlv.send.fixAddress": "Add the address",
    "comandas.dlv.send.fixPay": "Add how they pay",
    "comandas.dlv.send.anyway": "Send anyway",
    "comandas.dlv.send.kbd": "Enter fills it in · Esc sends anyway",
    "comandas.dlv.send.back": "Back to the order (don't send yet)",
    "comandas.dlv.card.noName": "No name",
    "comandas.dlv.card.deliverAt": "Deliver at {time}",
    "comandas.dlv.card.pickupAt": "Pickup at {time}",
    "comandas.dlv.card.asap": "As soon as possible",
    "comandas.dlv.card.paid": "Already paid · {method}",
    "comandas.dlv.card.paidPart": "Paid {paid} · {rest} left",
    "comandas.dlv.card.payUnset": "Payment method not set",
    "comandas.dlv.card.cashExact": "Cash · exact amount",
    "comandas.dlv.card.cashChange": "Cash · pays with {payWith} → change {change}",
    "comandas.dlv.card.fee": "Delivery fee {amount}",
    "comandas.dlv.card.note": "Note: {note}",
    "comandas.dlv.warn.noAddress": "Address missing",
    "comandas.dlv.warn.noPay": "Payment method missing",
    "comandas.dlv.warn.shortPay": "Pays with less than the total ({amount} short)",
    "comandas.dlv.warn.overPaid": "Paid {amount} too much",
    "comandas.dlv.warn.stale": "The bag ticket printed with outdated details",
    "comandas.dlv.warn.reprint": "Reprint",
    "comandas.dlv.agentOld": "Your printer doesn't print the delivery details yet. It updates itself in a few minutes; until then the ticket prints as usual.",
    "comandas.dlv.cobro.plan": "Planned: {method}",
    "comandas.dlv.cobro.planPaid": "Planned: {method} · already paid {amount}",
    "comandas.dlv.cobro.change": "Paid with {payWith}: change {change}",
    "comandas.dlv.p.tagEnvio": "DELIVERY",
    "comandas.dlv.p.tagRetiro": "TAKEAWAY",
    "comandas.dlv.p.forTime": "FOR {time}",
    "comandas.dlv.p.note": "NOTE: {note}",
    "comandas.dlv.p.updated": "UPDATED",
    "comandas.dlv.p.updatedHint": "Replaces the previous ticket - do not cook again",
    "comandas.dlv.p.orderNo": "ORDER {n}",
    "comandas.dlv.p.typeEnvio": "HOME DELIVERY",
    "comandas.dlv.p.typeRetiro": "PICKUP IN STORE",
    "comandas.dlv.p.deliverAt": "Deliver at {time}",
    "comandas.dlv.p.pickupAt": "Pickup at {time}",
    "comandas.dlv.p.asap": "As soon as possible",
    "comandas.dlv.p.phone": "Customer phone: {phone}",
    "comandas.dlv.p.addressBlank": "Address: ______________________",
    "comandas.dlv.p.paidAll": "PAID - DO NOT CHARGE",
    "comandas.dlv.p.paidPart": "PAID {paid} - CHARGE {rest}",
    "comandas.dlv.p.collect": "CHARGE {amount}",
    "comandas.dlv.p.payBlank": "Payment: ______________",
    "comandas.dlv.p.exact": "Exact amount, no change",
    "comandas.dlv.p.payWith": "Pays with",
    "comandas.dlv.p.change": "BRING CHANGE",
    "comandas.dlv.p.notEnough": "Pays with {amount} - NOT ENOUGH",
    "comandas.dlv.p.paidDone": "PAID {amount}",
    "comandas.dlv.list.paid": "Paid",
    "comandas.dlv.list.dupNo": "Duplicate no.",
    "comandas.dlv.list.stale": "Outdated ticket",
    "comandas.dlv.list.noBag": "Ticket missing",
    "comandas.dlv.renumbered": "Another device took order {from}: this one is now {n}. Let the customer know.",
    "comandas.dlv.b.timeIsTomorrow": "Set for TOMORROW at {time}",
    "comandas.dlv.b.paidPh": "How much did they pay? (from the receipt)",
    "comandas.dlv.b.paidMissing": "Enter how much they paid, or untick “Already paid”. Without an amount, the ticket would tell the driver to charge.",
    "comandas.dlv.card.paidNoMethod": "Paid {paid} · method missing",
    "comandas.dlv.warn.paidNoMethod": "Paid, but the payment method is missing",
    "comandas.dlv.warn.noBag": "The bag ticket didn't print",
    "comandas.dlv.warn.print": "Print",
    "comandas.dlv.cobro.paidNoMethod": "Already paid {amount}, but the method wasn't recorded: choose it.",
    "comandas.cobro.appPaid": "{app} collects it",
    "comandas.cobro.appPaidHint": "They pay you out later: this money is not in today's till.",
    "comandas.cobro.payNow": "I collect it now",
    "comandas.cobro.payNowHint": "Paid the driver or by transfer: this money does come in today.",
    "comandas.cobro.todayGroup": "Comes in today",
    "comandas.cobro.deferredGroup": "The app collects it",
    "comandas.cobro.commission": "{pct}% fee",
    "comandas.cobro.net": "You keep",
    "comandas.cobro.gross": "Gross",
    "comandas.cierre.today": "Comes in today",
    "comandas.cierre.deferred": "Paid out later",
    "comandas.cierre.deferredHint": "Collected by the apps. Not in the till: they pay you out later.",
    "comandas.cierre.commission": "App fees",
    "comandas.cierre.commissionDay": "App fees (whole day)",
    "comandas.cierre.net": "Net (after fees)",
    "comandas.cierre.byChannel": "By channel",
    "comandas.cierre.dlvFeesTitle": "Delivery fees",
    "comandas.cierre.dlvFees": "Delivery fees charged ({n})",
    "comandas.cierre.dlvFeesCash": "Of that, in cash",
    "comandas.cierre.dlvFeesHint": "Already included in the total: don't add them again. If the fee belongs to the driver, the cash part is what you owe them.",
    "comandas.cierre.delivery": "Delivery & takeaway",
    "comandas.cierre.avgSalon": "Average ticket (dine-in)",
    "comandas.cierre.perCover": "Per cover",
    "comandas.cierre.perCoverTitle": "Per cover",
    "comandas.cierre.todayTitle": "COMES IN TODAY",
    "comandas.cierre.deferredTitle": "PAID OUT LATER",
    "comandas.cierre.deferredNote": "collected by the apps - not in the till",
    "comandas.cierre.commissionTitle": "App fees",
    "comandas.cierre.commissionOf": "fee",
    "comandas.cierre.commissionDayTitle": "App fees (day total)",
    "comandas.cierre.netTitle": "they pay you",
    "comandas.cierre.subtotalTitle": "subtotal",
    "comandas.cierre.deliveryTitle": "Delivery & takeaway",
    "comandas.settle.title": "The apps owe you",
    "comandas.settle.hint": "What the apps collected in this period and you haven't marked as paid out yet.",
    "comandas.settle.empty": "Nothing owed: it's all settled.",
    "comandas.settle.gross": "Gross",
    "comandas.settle.commission": "Fee",
    "comandas.settle.net": "Estimated net",
    "comandas.settle.pending": "Pending",
    "comandas.settle.orders": "{n} orders",
    "comandas.settle.mark": "Mark as paid out",
    "comandas.settle.markConfirm": "Sure?",
    "comandas.settle.saving": "Saving…",
    "comandas.settle.done": "Done: {n} orders marked as paid out.",
    "comandas.settle.partial": "Marked {n} of {total}. Try again for the rest.",
    "comandas.settle.undone": "Undone: {n} orders are pending again.",
    "comandas.settle.settledTag": "paid out",
    "comandas.settle.undo": "Undo",
    "comandas.config.delivery.title": "Delivery & takeaway",
    "comandas.config.delivery.railTitle": "Delivery",
    "comandas.config.delivery.desc": "Orders that don't belong to a table: the ones you deliver, the ones customers pick up and, if you want, app orders.",
    "comandas.config.delivery.enable": "Take delivery and takeaway orders",
    "comandas.config.delivery.enableHint": "They show up above the tables, on the Service screen. Opening one asks for the customer's details (and the address, for a delivery). Nothing else to set up.",
    "comandas.config.delivery.ownTitle": "Your own orders",
    "comandas.config.delivery.ownDesc": "You collect the money, like a table. They're ready to use.",
    "comandas.config.delivery.envio": "Home delivery",
    "comandas.config.delivery.envioDesc": "Your driver takes it. You enter name, phone and address, and a bag ticket prints with how much to charge and the change.",
    "comandas.config.delivery.retiro": "Takeaway",
    "comandas.config.delivery.retiroDesc": "The customer picks it up. You enter name and phone.",
    "comandas.config.delivery.more": "More options",
    "comandas.config.delivery.remove": "Remove",
    "comandas.config.delivery.ownNameHint": "How it's recorded in closed orders and in the history. Applies to new orders.",
    "comandas.config.delivery.ownMarkupHint": "If you charge more for these orders than in the dining room. It's added automatically; menu prices stay untouched.",
    "comandas.config.delivery.noneActive": "Like this there'll be no button on the Service screen: turn on Delivery or Takeaway, or add an app.",
    "comandas.config.delivery.appsTitle": "Delivery apps",
    "comandas.config.delivery.optional": "optional",
    "comandas.config.delivery.appsDesc": "If you also sell through an app, add it. What the app collects doesn't go into that day's till: they pay you out later.",
    "comandas.config.delivery.appsEmpty": "You haven't added any app. You don't need one to take your own orders.",
    "comandas.config.delivery.addOther": "Another app",
    "comandas.config.delivery.appsNote": "An app order only takes the order number: the app has the address and the payment.",
    "comandas.config.delivery.platforms": "Platforms",
    "comandas.config.delivery.name": "Name",
    "comandas.config.delivery.namePh": "App name",
    "comandas.config.delivery.commission": "Fee %",
    "comandas.config.delivery.commissionHint": "Fee: what the app keeps. It doesn't change what you charge: it's so you know what you actually keep.",
    "comandas.config.delivery.markup": "Markup %",
    "comandas.config.delivery.markupHint": "If you sell at higher prices on the app, set how much. It's added to the order automatically; menu prices stay untouched.",
    "comandas.config.delivery.settlementDays": "Pays you after… (days)",
    "comandas.config.delivery.settlementDaysHint": "So the till can warn you when a payout is late. At 0 it never warns.",
    "comandas.settle.overdue": "{d} days late",
    "comandas.settle.overdueTotal": "Late",
    "comandas.config.delivery.needName": "Give the app a name before saving.",
    "comandas.config.delivery.tableWarn": "Heads up: you have a table called “{name}”. If you start using this section, remove it from custom tables so the same order isn't entered twice.",
    "comandas.config.delivery.fee": "Delivery fee",
    "comandas.config.delivery.feeHint": "Added automatically to every delivery, and you can change it on each order. At 0 nothing is charged.",
    "comandas.config.delivery.ticketTitle": "What gets printed",
    "comandas.config.delivery.ticketDesc": "A delivery prints two papers: the kitchen ticket (number, name, time and note; no money or address) and the order ticket, stapled to the bag (customer, address, how much to charge and the change). A takeaway order prints only the kitchen ticket, unless you turn on its ticket below.",
    "comandas.config.delivery.ticketEnvio": "Order ticket for deliveries",
    "comandas.config.delivery.ticketEnvioDesc": "Prints automatically when you send a delivery to the kitchen, on the bill printer. The driver reads it: where to go, how much to charge and how much change to bring.",
    "comandas.config.delivery.ticketRetiro": "Order ticket for takeaway orders",
    "comandas.config.delivery.ticketRetiroDesc": "For phone orders that get picked up: name, time and whether it's paid. Off, a counter sale doesn't use a second paper.",
    "comandas.config.delivery.kitchenName": "Customer name on the kitchen ticket",
    "comandas.config.delivery.kitchenNameDesc": "Large, above the dishes: it's what gets called out at the counter and what tells two identical orders apart.",
    "comandas.config.delivery.agentOld": "Your printer doesn't print takeaway and delivery details yet (it updates itself in a few minutes). Until then the order ticket won't print automatically and tickets print as before.",
    "comandas.mesa.empty": "Nothing added yet. Type a dish above and press Enter.",
    "comandas.mesa.total": "Total",
    "comandas.mesa.menuPending": "Loading the menu… tables and orders work as usual.",
    "comandas.mesa.send": "Send to kitchen ({n})",
    "comandas.mesa.sendAdd": "Send addition ({n})",
    "comandas.mesa.reprintAll": "Reprint all",
    "comandas.mesa.sending": "Sending…",
    "comandas.mesa.sent": "sent ✓",
    "comandas.mesa.note": "Note",
    "comandas.mesa.noteFor": "Note for",
    "comandas.mesa.notePlaceholder": "e.g. no salt, well done…",
    "comandas.mesa.saveNote": "Save",
    "comandas.mesa.cancel": "Cancel",
    "comandas.mesa.cs.add": "add",
    "comandas.mesa.cs.qty": "quantity",
    "comandas.mesa.cs.note": "note",
    "comandas.mesa.cs.move": "select",
    "comandas.mesa.cs.send": "send",
    "comandas.turno.open": "Open a table:",
    "comandas.turno.openPlaceholder": "No. + Enter",
    "comandas.mesa.lineSelected": "Line selected — number = quantity · + / − adjust · Del removes · Esc release",
    "comandas.send.nothing": "No new items to send.",
    "comandas.send.closedOrder": "{table} is already closed: it can't be sent to the kitchen. To keep adding to it, reopen it from «Closed today».",
    "comandas.mesa.paidElsewhere": "{table} was paid on another device. It's free now: open it again for the next guests.",
    "comandas.mesa.paidElsewhereUnsent": "{table} was paid on another device. {n} item(s) you added here were NOT sent to the kitchen: open the table again and add them.",
    "comandas.mesa.voidedElsewhere": "{table} was voided on another device. It's free now.",
    "comandas.mesa.voidedElsewhereUnsent": "{table} was voided on another device. {n} item(s) you added here were NOT sent to the kitchen: open the table again and add them.",
    "comandas.send.saveError": "Couldn't save the order: {msg}",
    "comandas.config.tables.title": "Number of tables",
    "comandas.config.tables.desc": "How many tables to show in the service grid.",
    "comandas.config.title": "Orders settings",
    "comandas.config.subtitle": "Set up your printers and how the kitchen ticket and bill look. The preview on the right is the real 80mm paper.",
    "comandas.config.title.eyebrow": "My place",
    "comandas.config.sections": "Sections",
    "comandas.config.tipBox.title": "Tip:",
    "comandas.config.tipBox.body": "tap a section to jump to it. Everything you change shows instantly on the ticket.",
    "comandas.preview.live": "Live",
    "comandas.config.comanda.showWaiterDesc": "The kitchen knows who to call.",
    "comandas.config.comanda.showTimeDesc": "Exact time the order came in.",
    "comandas.config.comanda.showOrderNumberDesc": "Daily sequence, for disputes.",
    "comandas.config.comanda.groupByStationDesc": "Grill, cold kitchen, bar… each reads its own.",
    "comandas.config.comanda.invertNotes": "Notes highlighted in black",
    "comandas.config.comanda.invertNotesDesc": "Black background, white text. If your printer smudges it and it is hard to read, turn it off: notes print in plain bold.",
    "comandas.tiempos.markHere": "Draw the line here",
    "comandas.tiempos.removeMark": "Remove the line",
    "comandas.tiempos.pill": "Course {n}",
    "comandas.tiempos.hereAfter": "Line here",
    "comandas.tiempos.removeAria": "Remove this line",
    "comandas.tiempos.ticket": "COURSE {n}",
    "comandas.tiempos.ticketWait": "COURSE {n} - WAIT",
    "comandas.config.comanda.tiempos": "Mark courses with a line",
    "comandas.config.comanda.tiemposDesc": "So the kitchen doesn't fire everything at once. The waiter marks what goes out now and what waits until the table is ready, and the ticket prints already split. Useful for starters and mains, and for the guest who begins with a main. Marked with the button at the foot of the order (or the / key if you use a keyboard), and items keep the order they were added.",
    "comandas.config.comanda.courseMode": "How the line looks",
    "comandas.config.comanda.courseModeText": "With text",
    "comandas.config.comanda.courseModeLine": "Just the line",
    "comandas.config.comanda.courseLabel": "What the line says",
    "comandas.config.comanda.courseLabelHelp": "Write {n} where you want the course number. Empty = the default text.",
    "comandas.config.comanda.courseH": "Line height",
    "comandas.config.comanda.courseW": "Line width",
    "comandas.config.style.title": "How the kitchen ticket reads",
    "comandas.config.style.desc": "Kitchens are dim, steamy and rushed. Tweak these and watch the ticket beside it until it reads at a glance; then print a real test.",
    "comandas.config.style.itemSize": "Item size",
    "comandas.config.style.itemH": "Item height",
    "comandas.config.style.itemW": "Item width",
    "comandas.config.style.noteH": "Note height",
    "comandas.config.style.noteW": "Note width",
    "comandas.config.style.itemBold": "Item name in bold",
    "comandas.config.style.itemBoldDesc": "The heavier type, the same the COCINA header uses. If items print faded, try this first.",
    "comandas.config.style.noteSize": "Note size",
    "comandas.config.style.tableSize": "Table number size",
    "comandas.config.style.stationBold": "Station separators in bold",
    "comandas.config.style.stationBoldDesc": "The “-- GRILL --” lines that split the ticket.",
    "comandas.config.style.sizeNormal": "Normal",
    "comandas.config.style.sizeTall": "Large",
    "comandas.config.style.sizeTall2": "Larger",
    "comandas.config.style.sizeBig": "Extra large",
    "comandas.config.style.sizeAuto": "Automatic",
    "comandas.config.style.paper": "Paper width",
    "comandas.config.style.paperHint": "So the preview tells the truth. It doesn't change the printer: it's the roll you already have.",
    "comandas.config.style.wrapWarn": "At “Extra large” only {n} characters fit per line: items with long names break into two. Give them a short kitchen name below.",
    "comandas.config.style.agentOld": "This venue's printer updates itself in a few minutes. Until then it keeps printing as before, even though you already see it changed here.",
    "comandas.config.style.test": "Print a test",
    "comandas.config.kitchenNames.title": "Kitchen names",
    "comandas.config.kitchenNames.desc": "A dish can be called “PENNE RIGATE CON LANGOSTINOS SALTEADOS” on the menu and reach the kitchen as “PENNE”. The chef knows which one it is and reads it far faster. The menu, the customer's bill and the reports don't change.",
    "comandas.config.kitchenNames.search": "Search for a dish…",
    "comandas.config.kitchenNames.placeholder": "Short name",
    "comandas.config.kitchenNames.empty": "Search for a dish to give it a short name.",
    "comandas.config.kitchenNames.none": "None yet. Dishes without a short name print with their menu name.",
    "comandas.config.kitchenNames.count": "{n} with a short name",
    "comandas.config.kitchenNames.stale": "check",
    "comandas.config.kitchenNames.staleHint": "This dish was renamed on the menu. Meanwhile it prints with the full name: confirm it by typing the short name again.",
    "comandas.config.kitchenNames.readOnly": "This is set from the panel, not from the venue's screen (otherwise it gets overwritten).",
    "comandas.config.cuenta.showTipDesc": "Shows calculated at the bottom of the bill.",
    "comandas.config.cuenta.footerHelper": "The last line your customer reads. Make it yours.",
    "comandas.config.save": "Save changes",
    "comandas.config.unsaved": "You have unsaved changes",
    "comandas.config.printers.namePlaceholder": "e.g. Kitchen",
    "comandas.config.printers.connected": "Connected",
    "comandas.config.printers.notConnected": "Not connected",
    "comandas.config.printers.showTech": "Technical details (IP & port)",
    "comandas.config.printers.hideTech": "Hide technical details",
    "comandas.config.printers.addManual": "Add manually",
    "comandas.config.printers.detectOnLocalPc": "Don't know the IP? The printer connects automatically from the local PC: open “Comandas” there → Printers button.",
    "comandas.config.printers.addDetect": "Detect printer",
    "comandas.config.printers.billPrinter": "Bill printer",
    "comandas.config.printers.billPrinterAuto": "Automatic (checkout → bar → kitchen)",
    "comandas.config.printers.billPrinterHelp": "Which printer the customer bill and the day-close print on.",
    "comandas.config.printers.unnamed": "Unnamed printer",
    "comandas.config.printers.viaUsb": "USB",
    "comandas.config.printers.viaNet": "Network",
    "comandas.config.printers.usbQueue": "Windows printer",
    "comandas.config.printers.techHint": "If you connect the printer with the code above, the IP fills in automatically. This is only for manual setup.",
    "comandas.print.expired": "The order couldn't be confirmed (unconfirmed). Check the printer and reprint.",
    "comandas.print.failedMixed": "TABLE {table}: part of the order did not print and went back to pending, and another part could not be confirmed. Check the printers before reprinting.",
    "comandas.print.failedTable": "TABLE {table}: the order did NOT print. Those items went back to pending: check the printer and tap Send again.",
    "comandas.print.failedBill": "{table}: the bill or order ticket did NOT print. Check the printer and reprint that paper.",
    "comandas.print.unconfirmedBill": "{table}: couldn't confirm whether the bill or order ticket printed. Check the printer before reprinting it.",
    "comandas.print.failedTableAndBag": "{table}: neither the kitchen ticket nor the bag ticket printed. The items went back to pending: check the printer and tap Send (the bag ticket prints again with it).",
    "comandas.print.failedReprint": "TABLE {table}: the order did NOT print. Check the printer and reprint the full order.",
    "comandas.print.failedTableClosed": "TABLE {table}: the order did NOT print and the table is already closed. Check whether those items are still owed.",
    "comandas.print.unconfirmedTable": "TABLE {table}: we could not confirm the print. Check the printer BEFORE reprinting: it may have printed anyway.",
    "comandas.print.someFailed": "{n} of {total} ticket(s) didn't print. Check that printer(s) and reprint the full order.",
    "comandas.print.someUnconfirmed": "{n} of {total} ticket(s) unconfirmed. Check the printer(s) BEFORE reprinting: they may have printed anyway.",
    "comandas.send.partialNoPrinter": "{n} item(s) didn't print: that station's printer isn't available. They're still pending.",
    "comandas.wizard.title": "Add printer",
    "comandas.wizard.detected": "Printer found",
    "comandas.wizard.close": "Close",
    "comandas.wizard.back": "Back",
    "comandas.wizard.next": "Next",
    "comandas.wizard.retry": "Retry",
    "comandas.wizard.howQuestion": "How is the printer plugged in?",
    "comandas.wizard.usb": "Via USB",
    "comandas.wizard.usbDesc": "With a USB cable to this computer.",
    "comandas.wizard.net": "Via network (Ethernet)",
    "comandas.wizard.netDesc": "With a network cable to the router or extender.",
    "comandas.wizard.detectingUsb": "Looking for USB printers…",
    "comandas.wizard.detectingNet": "Looking for the printer on the network…",
    "comandas.wizard.pickUsb": "Pick the USB printer:",
    "comandas.wizard.pickNet": "Printer found:",
    "comandas.wizard.noUsb": "No USB printers found. If it shows under 'Unspecified', it needs a driver: install 'Generic / Text Only' on its USB port and retry.",
    "comandas.wizard.noNet": "Couldn't find it automatically. Type the IP manually:",
    "comandas.wizard.foundNet": "found on the network",
    "comandas.wizard.netExcluded": "(Already-registered ones are hidden.)",
    "comandas.wizard.netTestHint": "Pick one; then print a test to confirm which it is.",
    "comandas.wizard.netAllRegistered": "The ones I found are already registered. If it's new, type its IP manually.",
    "comandas.wizard.netTestBeforeRegister": "Print a test before registering: the ticket comes out of the real printer, so you confirm which it is.",
    "comandas.wizard.factoryBtn": "Assign IP (printer at 192.168.123.100)",
    "comandas.wizard.factoryHint": "For a printer at 192.168.123.100 (factory). The PC must be WIRED (not WiFi) on the same router as the printer. Takes 1-2 min.",
    "comandas.wizard.factoryWorking": "Setting up… up to 1-2 min. Don't close this window.",
    "comandas.wizard.factoryNotFound": "Not found. Make sure it's on, at 192.168.123.100 (self-test), and the PC is wired to the same router.",
    "comandas.wizard.orManualIp": "Or type the IP manually",
    "comandas.wizard.changeIpBtn": "Change the IP (if two ended up the same)",
    "comandas.wizard.changeIpTitle": "Change a printer's IP",
    "comandas.wizard.changeIpHint": "Turn off the others and leave ON only this one. Enter its current IP (see the self-test). Then confirm with the self-test that it changed.",
    "comandas.wizard.changeIpCurLabel": "Printer's current IP",
    "comandas.wizard.changeIpGo": "Change IP",
    "comandas.wizard.changeIpWorking": "Changing the IP…",
    "comandas.wizard.errChangeIp": "Couldn't change the IP. Make sure it's on and the others are off.",
    "comandas.wizard.usbCfgBtn": "Set up via USB",
    "comandas.wizard.usbCfgWhy": "I send the IP over the USB cable (no network needed).",
    "comandas.wizard.usbCfgTitle": "Set up via USB",
    "comandas.wizard.usbCfgStep1b": "Unplug other USB printers (to avoid mix-ups).",
    "comandas.wizard.usbCfgStep1": "Plug the new printer via USB.",
    "comandas.wizard.usbCfgStep2": "Turn it on and wait for Windows to recognize it.",
    "comandas.wizard.usbCfgStep3": "Tap \"Set up via USB\": I'll assign it an IP on your network.",
    "comandas.wizard.usbCfgDetect": "Detect USB printer",
    "comandas.wizard.usbCfgPick": "Which one is the new printer?",
    "comandas.wizard.usbCfgNoQueue": "No USB printers found. If it shows under 'Unspecified', install the 'Generic / Text Only' driver and retry.",
    "comandas.wizard.usbCfgGo": "Set up this one",
    "comandas.wizard.usbCfgWorking": "Setting up…",
    "comandas.wizard.usbCfgSent": "IP sent via USB:",
    "comandas.wizard.usbReplug1": "Unplug the cable you used to configure.",
    "comandas.wizard.usbReplug2": "Plug the network cable into the extender/router.",
    "comandas.wizard.usbReplug3": "Turn it on and wait ~20 sec.",
    "comandas.wizard.usbReplugTest": "It's connected — print test",
    "comandas.wizard.usbCfgReplug": "Confirm with the self-test that the IP changed. If the test printed, register it.",
    "comandas.wizard.errUsbCfg": "Couldn't set up via USB. Make sure it's plugged in via USB and on.",
    "comandas.wizard.offline": "offline",
    "comandas.wizard.nameUsb": "e.g. Kitchen (USB)",
    "comandas.wizard.nameNet": "e.g. Bar",
    "comandas.wizard.test": "Print test",
    "comandas.wizard.register": "Register",
    "comandas.wizard.working": "One moment…",
    "comandas.wizard.testOk": "✓ Test sent. If you saw the ticket, register it.",
    "comandas.wizard.testFail": "Couldn't print the test",
    "comandas.wizard.done": "✓ Printer ready!",
    "comandas.wizard.errGeneric": "Something went wrong. Try again.",
    "comandas.wizard.errDetect": "Couldn't detect. Try again.",
    "comandas.wizard.errTest": "Couldn't print the test.",
    "comandas.wizard.errRegister": "Couldn't register the printer.",
    "comandas.config.local.useMenu": "Use menu info",
    "comandas.config.comanda.desc": "The ticket that prints in the kitchen. Choose what to show (never has prices).",
    "comandas.config.cuenta.desc": "The pre-bill handed to the customer.",
    "comandas.config.advanced.title": "Advanced options",
    "comandas.config.advanced.desc": "Printer routing, sales by waiter and start of business day. Only if you need them.",
    "comandas.config.saving": "Saving…",
    "comandas.config.saved": "Settings saved",
    "comandas.config.printers.title": "Printers",
    "comandas.config.printers.desc": "Your venue printers. Each has its IP and station.",
    "comandas.config.printers.add": "Add printer",
    "comandas.config.printers.name": "Name",
    "comandas.config.printers.ip": "IP",
    "comandas.config.printers.port": "Port",
    "comandas.config.printers.station": "Station",
    "comandas.config.printers.empty": "No printers yet.",
    "comandas.config.printers.test": "Print test",
    "comandas.config.printers.testing": "Sending…",
    "comandas.config.printers.remove": "Remove",
    "comandas.config.printers.autoDetected": "Auto-detected by the agent",
    "comandas.station.cocina": "Kitchen",
    "comandas.station.barra": "Bar",
    "comandas.station.caja": "Cashier",
    "comandas.config.local.title": "Venue info (for the bill)",
    "comandas.config.local.desc": "Shown on the header of the customer bill.",
    "comandas.config.local.name": "Venue name",
    "comandas.config.local.address": "Address",
    "comandas.config.local.phone": "Phone",
    "comandas.config.comanda.title": "Kitchen ticket",
    "comandas.config.comanda.showWaiter": "Show waiter",
    "comandas.config.comanda.showTime": "Show time",
    "comandas.config.comanda.showOrderNumber": "Show ticket #",
    "comandas.config.comanda.groupByStation": "Group by station",
    "comandas.config.comanda.noPrices": "The kitchen ticket NEVER shows prices (by design).",
    "comandas.config.cuenta.scale": "Font size",
    "comandas.config.cuenta.scale1": "Normal",
    "comandas.config.cuenta.scale2": "Large",
    "comandas.config.cuenta.scale3": "Extra large",
    "comandas.config.cuenta.scaleHelper": "Enlarges the whole bill, not one part. It grows in height: dish names are not cut off and prices stay aligned. \"Extra large\" uses almost twice the paper.",
    "comandas.config.cuenta.title": "Bill (customer)",
    "comandas.config.cuenta.showTip": "Suggest tip",
    "comandas.config.cuenta.tipPercent": "Suggested percent",
    "comandas.config.cuenta.footer": "Footer message",
    "comandas.config.cuenta.legendLocked": "Fixed legal notice (can't be edited): protects the venue from the bill being mistaken for a fiscal invoice.",
    "comandas.config.addons.title": "Off-menu add-ons",
    "comandas.config.addons.desc": "Chargeable items not on the menu (cover, extra cream…). You'll find them fast while taking orders.",
    "comandas.config.addons.add": "Add add-on",
    "comandas.config.addons.name": "Name",
    "comandas.config.addons.price": "Price",
    "comandas.config.addons.empty": "No add-ons yet.",
    "comandas.config.addons.route": "Printer",
    "comandas.config.addons.routeHint": "“No ticket” = that add-on won't print in the kitchen, but it's still charged. “Default” = same as before.",
    "comandas.config.addons.needName": "Name the add-on: an empty one is dropped when you save.",
    "comandas.config.quickNotes.title": "Frequent notes",
    "comandas.config.quickNotes.desc": "Pick with one tap when adding a note (no salt, well done…).",
    "comandas.config.quickNotes.add": "Add",
    "comandas.config.quickNotes.placeholder": "New note…",
    "comandas.config.dayRollover.title": "Start of business day",
    "comandas.config.dayRollover.desc": "When a new 'business day' starts. Set it to a quiet early-morning hour (not your closing time), so the night shift isn't split and you have time to close out.",
    "comandas.config.separateTickets.title": "Separate ticket per station",
    "comandas.config.separateTickets.desc": "Kitchen and bar print as separate cut tickets (one to carry to each side), even on the same printer.",
    "comandas.config.revokeDevices.button": "Disconnect phones",
    "comandas.config.revokeDevices.desc": "Cuts off all linked phones. They'll have to scan the QR again. Useful if you let a waiter go.",
    "comandas.config.revokeDevices.confirm": "Disconnect all phones? Every waiter will have to scan the QR again.",
    "comandas.config.revokeDevices.done": "Done. Phones are disconnected — ask them to scan the QR again (may take up to 2 minutes to apply).",
    "comandas.preview.title": "Preview (80mm paper)",
    "comandas.preview.comanda": "Ticket",
    "comandas.preview.cuenta": "Bill",
    "comandas.preview.delivery": "Delivery",
    "comandas.preview.deliveryKitchen": "Kitchen ticket",
    "comandas.preview.deliveryBag": "Order ticket (goes in the bag)",
    "comandas.print.queued": "Sent to printer… {table}",
    "comandas.print.printing": "Printing…",
    "comandas.print.done": "{table} → printed! ✓",
    "comandas.print.queuedOk": "{table} → at the printer ✓",
    "comandas.print.error": "Print failed: {msg}",
    "comandas.print.noPrinter": "Add a printer with its IP first.",
    "comandas.print.slow": "{table}: taking longer than usual. Wait before reprinting…",
    "comandas.print.timeout": "{table}: no confirmation. Check the printer BEFORE reprinting: it may have printed anyway.",
    // ── Floor plan ──
    "comandas.plan.view.aria": "How to see the tables",
    "comandas.plan.view.grid": "Grid",
    "comandas.plan.view.plan": "Floor plan",
    "comandas.plan.miniHint": "Tap an area to zoom in",
    "comandas.plan.miniOpen": "{open} of {total} open",
    "comandas.plan.outside": "Not on the plan",
    "comandas.plan.outsideFree": "+{n} free",
    "comandas.plan.items": "{n} items",
    "comandas.plan.cfg.title": "Floor plan",
    "comandas.plan.cfg.desc": "Draw your venue and Service shows each table in its place, colored by its status.",
    "comandas.plan.cfg.empty": "You haven't drawn your venue yet. It's optional: without it, Service keeps the usual grid.",
    "comandas.plan.cfg.draw": "Draw my venue",
    "comandas.plan.cfg.edit": "Edit the plan",
    "comandas.plan.cfg.placed": "{n} of {total} tables on the plan",
    "comandas.plan.cfg.noTables": "You haven't placed any table on the plan yet: until you place at least one, Service keeps the grid.",
    "comandas.plan.cfg.start": "When Service opens, show",
    "comandas.plan.cfg.startDesc": "Each device can switch with the Grid | Floor plan button; when it's opened again, it starts as you set here.",
    "comandas.plan.cfg.cloudOnly": "The floor plan is drawn from the online panel, in this same section.",
    "comandas.plan.ed.title": "Floor plan",
    "comandas.plan.ed.back": "Back",
    "comandas.plan.ed.save": "Save",
    "comandas.plan.ed.saving": "Saving…",
    "comandas.plan.ed.saved": "Saved",
    "comandas.plan.ed.unsaved": "Not saved",
    "comandas.plan.ed.saveError": "Couldn't save. Check the connection and try again.",
    "comandas.plan.ed.undo": "Undo",
    "comandas.plan.ed.redo": "Redo",
    "comandas.plan.ed.cancel": "Cancel",
    "comandas.plan.ed.clear": "Start over",
    "comandas.plan.ed.clearConfirm": "Delete the whole plan? You can undo it until you save.",
    "comandas.plan.ed.clearYes": "Delete all",
    "comandas.plan.ed.canvas": "Plan sheet",
    "comandas.plan.ed.tool.move": "Move",
    "comandas.plan.ed.tool.wall": "Wall",
    "comandas.plan.ed.tool.text": "Name",
    "comandas.plan.ed.tool.tables": "Tables",
    "comandas.plan.ed.tip.move": "Drag walls, names and tables to arrange them; drag the background to move the sheet. Tap one to change or delete it.",
    "comandas.plan.ed.tip.wall": "Drag from one end to the other to draw a wall. It stays straight and joins the others by itself. The door is the gap you leave. To move the sheet, use two fingers or go back to Move.",
    "comandas.plan.ed.tip.text": "Tap where the name of that area goes: dining room, sidewalk, patio…",
    "comandas.plan.ed.tip.place": "Tap the plan where table {t} goes.",
    "comandas.plan.ed.tip.allPlaced": "All your tables are on the plan. Drag them to arrange them.",
    "comandas.plan.ed.tray.title": "Not placed ({n})",
    "comandas.plan.ed.tray.all": "Place all in rows",
    "comandas.plan.ed.tray.done": "All tables are on the plan.",
    "comandas.plan.ed.tray.hint": "Tables you add or delete here also change in Settings › Number of tables.",
    "comandas.plan.ed.tray.orphans": "{list}: no longer tables of your venue, so they don't show in Service.",
    "comandas.plan.ed.tray.orphansOut": "Remove them from the plan",
    "comandas.plan.ed.tray.add": "Add table",
    "comandas.plan.ed.tray.deleteLeft": "Delete the leftover ones ({n})",
    "comandas.plan.ed.newTable.label": "New table: number or name",
    "comandas.plan.ed.newTable.hint": "Then tap the sheet where it goes.",
    "comandas.plan.ed.newTable.ok": "Add",
    "comandas.plan.ed.newTable.empty": "Type a number or a name.",
    "comandas.plan.ed.newTable.long": "A shorter name (up to 20 characters).",
    "comandas.plan.ed.newTable.comma": "No commas, please.",
    "comandas.plan.ed.newTable.exists": "There's already a table {t}.",
    "comandas.plan.ed.newTable.full": "You reached the maximum of named tables (200).",
    "comandas.plan.ed.left.title": "Delete the leftover tables",
    "comandas.plan.ed.left.body": "These are deleted from your venue: {list}. If you miss one later, add it again from here.",
    "comandas.plan.ed.left.busy": "Tables with an open order stay: {list}.",
    "comandas.plan.ed.left.one": "Table 1 stays: table numbering starts there.",
    "comandas.plan.ed.left.tooMany": "They can't all be deleted at once: there would be more than 200 named tables. Lower the number in Settings › Number of tables.",
    "comandas.plan.ed.left.yes": "Delete ({n})",
    "comandas.plan.ed.left.ok": "Got it",
    "comandas.plan.ed.orphan": "No longer a table of your venue",
    "comandas.plan.ed.sel.table": "Table {t}",
    "comandas.plan.ed.sel.wall": "Wall",
    "comandas.plan.ed.sel.wallHint": "Drag the end points to make it longer or shorter.",
    "comandas.plan.ed.sel.text": "Name",
    "comandas.plan.ed.sel.unplace": "Remove from plan",
    "comandas.plan.ed.sel.rename": "Change",
    "comandas.plan.ed.sel.renameTable": "Change number or name",
    "comandas.plan.ed.renameTable.label": "New number or name for table {t}",
    "comandas.plan.ed.renameTable.hint": "It changes on the plan, in Service and in Settings.",
    "comandas.plan.ed.renameTable.ok": "Change",
    "comandas.plan.ed.renameTable.busy": "Table {t} has an open order: you can rename it once it's paid.",
    "comandas.plan.ed.renameTable.one": "Table 1 can't be changed: table numbering starts there.",
    "comandas.plan.ed.sel.delete": "Delete",
    "comandas.plan.ed.text.label": "What's this area called?",
    "comandas.plan.ed.text.placeholder": "E.g.: Dining room",
    "comandas.plan.ed.text.ok": "Done",
    "comandas.plan.ed.text.suggestions": "Dining room,Sidewalk,Patio,Bar,Kitchen,Restrooms,Entrance,Terrace",
    "comandas.plan.ed.start.title": "How do we start?",
    "comandas.plan.ed.start.room": "A room with all your tables",
    "comandas.plan.ed.start.roomDesc": "Four walls and your {n} tables in rows. One tap and it works: then move whatever you want.",
    "comandas.plan.ed.start.rows": "Just the tables, in rows",
    "comandas.plan.ed.start.rowsDesc": "No walls: draw them yourself if you want.",
    "comandas.plan.ed.start.blank": "Blank sheet",
    "comandas.plan.ed.start.blankDesc": "Draw everything from scratch.",
    "comandas.plan.ed.start.entrance": "Entrance",
    "comandas.plan.ed.zoomIn": "Zoom in",
    "comandas.plan.ed.zoomOut": "Zoom out",
    "comandas.plan.ed.zoomFit": "See all",
    "comandas.plan.ed.exit.title": "You have unsaved changes",
    "comandas.plan.ed.exit.body": "If you leave now, you'll lose what you changed since you last saved.",
    "comandas.plan.ed.exit.save": "Save and leave",
    "comandas.plan.ed.exit.discard": "Leave without saving",
    "comandas.plan.ed.exit.stay": "Keep drawing",
    "comandas.plan.ed.recover.text": "There's an unsaved plan from last time.",
    "comandas.plan.ed.recover.yes": "Recover it",
    "comandas.plan.ed.recover.no": "Discard",
  },

  pt: {
    "comandas.menuDashboard.title": "Comandas",
    "comandas.menuDashboard.desc": "Anote pedidos por mesa e envie a comanda para a cozinha.",
    "comandas.menuDashboard.badge": "Novo",
    "comandas.nav.back": "Voltar ao painel",
    "comandas.nav.turno": "Turno",
    "comandas.nav.config": "Configuração",
    "comandas.nav.historial": "Histórico",
    "comandas.nav.stock": "Estoque",
    // ── Stock ──
    "comandas.hist.voidedItems": "Pratos anulados ({n})",
    "comandas.hist.voidedItemsPaid": "Os que estão numa mesa que FOI cobrada são os que interessam: esse prato foi feito e ninguém pagou.",
    "comandas.hist.viOpenTable": "MESA ABERTA",
    "comandas.hist.viVoidTable": "MESA ANULADA",
    "comandas.hist.viMerged": "MESA JUNTADA",
    "comandas.hist.voidedItemsHint": "Foram para a cozinha e depois saíram da conta. Pode ser legítimo (lançado na mesa errada, saiu mal) ou não: por isso fica com nome e hora.",
    "comandas.hist.voided": "Canceladas ({n})",
    "comandas.hist.voidedHint":
      "Não somam aos totais: não foram cobradas. Entram as que mandaram algo para a cozinha e as que foram canceladas depois de imprimir a conta para o cliente.",
    "comandas.stale.bar": "{n} mesa(s) ficaram abertas de dias anteriores · {total} sem cobrar",
    "comandas.stale.see": "Ver",
    "comandas.stale.eyebrow": "Ficaram abertas",
    "comandas.stale.title": "Mesas de dias anteriores",
    "comandas.stale.hint":
      "O dia foi fechado e estas mesas nunca foram cobradas nem canceladas. Traga-as para hoje para cobrar, ou cancele se não forem cobradas. O que já saiu para a cozinha baixou do estoque de qualquer forma.",
    "comandas.stale.meta": "{items} item(ns) · {total}",
    "comandas.stale.bring": "Trazer para hoje",
    "comandas.stale.void": "Cancelar",
    "comandas.stale.voidConfirm": "Tem certeza? Cancelar",
    "comandas.stock.out": "Esgotado",
    "comandas.stock.left": "Restam {n}",
    "comandas.stock.blocked": "Sem estoque: {name}",
    "comandas.stock.eyebrow": "Inventário",
    "comandas.stock.title": "Estoque",
    "comandas.stock.subtitle": "O saldo de cada insumo é calculado sozinho: parte da sua contagem e desconta o que é vendido, conforme as receitas de Custos.",
    "comandas.stock.refresh": "Atualizar",
    "comandas.stock.error.title": "Não foi possível carregar o estoque",
    "comandas.stock.error.body": "O Firestore rejeitou a leitura. Geralmente é porque as regras de comandas ainda não foram publicadas.",
    "comandas.stock.noIng.title": "Você ainda não cadastrou insumos",
    "comandas.stock.noIng.body": "O estoque usa os insumos e receitas que você cadastra em Custos. Cadastre-os lá e volte para escolher quais acompanhar.",
    "comandas.stock.noIng.cta": "Ir para Custos",
    "comandas.stock.banner.out": "{n} sem estoque",
    "comandas.stock.banner.low": "{n} para repor",
    "comandas.stock.banner.need": "{n} sem contagem inicial",
    "comandas.stock.banner.quickNoStock": "{n} prato(s) vendido(s) NÃO baixam estoque (custeados no modo rápido). Adicione a receita detalhada para que descontem.",
    "comandas.stock.banner.ok": "Tudo em ordem",
    "comandas.stock.inventory.title": "Inventário",
    "comandas.stock.inventory.desc": "Saldo estimado de cada insumo que você acompanha. Uma contagem física o recalibra.",
    "comandas.stock.inventory.empty": "Você ainda não acompanha nenhum insumo. Escolha abaixo.",
    "comandas.stock.row.consumed": "Consumiu {qty} {unit} no período",
    "comandas.stock.row.needCount": "Falta contagem",
    "comandas.stock.row.min": "Mínimo",
    "comandas.stock.status.ok": "OK",
    "comandas.stock.status.low": "Baixo",
    "comandas.stock.status.out": "Sem estoque",
    "comandas.stock.status.unknown": "Sem contagem",
    "comandas.stock.status.stale": "Contagem antiga",
    "comandas.stock.row.stale": "Contagem vencida — refaça",
    "comandas.stock.row.recipeIssue": "⚠ Verifique a unidade na receita",
    "comandas.stock.act.purchase": "Entrada",
    "comandas.stock.act.waste": "Perda",
    "comandas.stock.act.count": "Contagem",
    "comandas.stock.act.adjust": "Ajuste",
    "comandas.stock.act.untrack": "Parar de acompanhar",
    "comandas.stock.track.title": "Insumos a acompanhar",
    "comandas.stock.track.desc": "Escolha quais insumos controlar. Toque em um para começar a acompanhá-lo (depois faça a contagem inicial).",
    "comandas.stock.track.allTracked": "Você acompanha todos os seus insumos.",
    "comandas.stock.movs.title": "Movimentações",
    "comandas.stock.movs.desc": "Últimas entradas, perdas, ajustes e contagens.",
    "comandas.stock.movs.empty": "Nenhuma movimentação ainda.",
    "comandas.stock.movType.count": "Contagem",
    "comandas.stock.movType.purchase": "Entrada",
    "comandas.stock.movType.waste": "Perda",
    "comandas.stock.movType.adjust": "Ajuste",
    "comandas.stock.modal.count": "Quanto há AGORA? Isso fixa o saldo e passa a contar a partir daqui.",
    "comandas.stock.modal.purchase": "Quanto entrou? Somado ao estoque.",
    "comandas.stock.modal.waste": "Quanto se perdeu, quebrou ou venceu? Subtraído do estoque.",
    "comandas.stock.modal.adjust": "Correção manual. Use negativo para subtrair (ex.: -2).",
    "comandas.stock.modal.notePlaceholder": "Nota (opcional)",
    "comandas.stock.modal.cancel": "Cancelar",
    "comandas.stock.modal.confirm": "Salvar",
    "comandas.turno.title": "Turno — mesas",
    "comandas.turno.items": "itens",
    "comandas.turno.free": "Livre",
    "comandas.turno.opened": "Aberta",
    "comandas.turno.pending": "Pedido não enviado",
    "comandas.turno.sent": "Enviado à cozinha",
    "comandas.mesa.title": "Mesa",
    "comandas.mesa.searchPlaceholder": "Digite e Enter… (ex: milanesa, coca, couvert)",
    "comandas.turno.eyebrow": "Serviço em andamento",
    "comandas.turno.openHint": "Toque uma mesa, ou digite o número",
    "comandas.turno.openGo": "Abrir mesa",
    "comandas.turno.summaryOpen": "{open} de {total} mesas abertas",
    "comandas.turno.noPrinterLocal": "Ainda não configurou uma impressora. Toque em “Impressoras” para conectá-la — até lá as comandas não imprimem.",
    "comandas.turno.printerConnecting": "Conectando com a impressora… o agente está reconectando sozinho, não precisa fazer nada.",
    "comandas.turno.noPrinterCloud": "Ainda não há impressora conectada. Configure a partir do PC do local (abra “Comandas” lá → Impressoras).",
    "comandas.mesa.searchHint": "Enter adiciona · 1-9 quantidade",
    "comandas.mesa.ticketLabel": "Comanda da mesa",
    "comandas.mesa.itemsCount": "{n} produtos",
    "comandas.mesa.emptyShort": "vazia",
    "comandas.mesa.products": "Produtos",
    "comandas.mesa.allSent": "Tudo enviado",
    "comandas.mesa.lineNew": "Novo",
    "comandas.mesa.lineSent": "Na cozinha",
    "comandas.mesa.editHint": "1-9 quantidade · +/− ajustar · Del apagar · Enter pronto",
    "comandas.mesa.shortcutsTitle": "Atalhos de teclado",
    "comandas.mesa.bill": "Cobrar / fechar mesa",
    "comandas.mesa.close": "Fechar mesa",
    "comandas.mesa.billSoonTitle": "Em breve: cobrança e fechamento de mesa",
    "comandas.mesa.soon": "Em breve",
    "comandas.mesa.noteEyebrow": "Observação",
    "comandas.mesa.justOpened": "recém aberta",
    "comandas.mesa.minAgo": "há {m} min",
    "comandas.mesa.hAgo": "há {h}h {m}m",
    "comandas.mesa.sc.add": "Adiciona o produto destacado",
    "comandas.mesa.sc.move": "Escolha entre os resultados",
    "comandas.mesa.sc.qtyMatch": "Com um match: adiciona essa quantidade",
    "comandas.mesa.sc.qtyPrefix": "Número na frente = quantidade",
    "comandas.mesa.sc.note": "Observação da última linha",
    "comandas.mesa.sc.send": "Envia à cozinha · vazio volta às mesas",
    "comandas.mesa.sc.dlv": "Cliente e endereço",
    "comandas.mesa.sc.dlvApp": "N° do pedido no app",
    "comandas.mesa.sc.dlvRetiro": "Nome e telefone",
    "comandas.mesa.sc.dlvPay": "Hora e pagamento",
    "comandas.turno.billed": "Conta pedida",
    "comandas.cobro.title": "Fechar mesa",
    "comandas.cobro.printBill": "Imprimir conta",
    "comandas.cobro.reprintBill": "Reimprimir conta",
    "comandas.cobro.printing": "Imprimindo…",
    "comandas.cobro.billPrinted": "Conta de {table} impressa ✓",
    "comandas.cobro.method": "Como pagou?",
    "comandas.cobro.oneMethod": "Um meio",
    "comandas.cobro.splitPay": "Vários meios",
    "comandas.cobro.remaining": "Falta",
    "comandas.cobro.over": "Sobra",
    "comandas.cobro.settled": "Pronto ✓",
    "comandas.cobro.addPay": "Adicionar",
    "comandas.cobro.addRest": "Resto",
    "comandas.cobro.amountPh": "Valor $",
    "comandas.cobro.splitHint": "Você dividiu em {n} contas — escolha o meio de cada uma",
    "comandas.cobro.confirm": "Fechar mesa",
    "comandas.cobro.charging": "Fechando…",
    "comandas.cobro.done": "{table} fechada ✓",
    "comandas.cobro.needMethod": "Falta escolher a forma de pagamento de uma das partes.",
    "comandas.cobro.sumMismatch": "Os pagamentos não somam o total da mesa. Confira o detalhamento.",
    "comandas.covers.title": "Quantos talheres?",
    "comandas.covers.confirm": "Abrir mesa",
    "comandas.covers.skip": "Sem especificar",
    "comandas.covers.chargeLabel": "Talheres",
    "comandas.covers.priceNote": "{money} por talher",
    "comandas.covers.takeaway": "Para viagem",
    "comandas.covers.placeholder": "Outra quantidade",
    "comandas.covers.short": "{n} tlh.",
    "comandas.covers.add": "Talheres",
    "comandas.config.covers.title": "Talheres",
    "comandas.config.covers.track": "Pedir talheres ao abrir uma mesa",
    "comandas.config.covers.desc": "Ao abrir uma mesa pergunta quantos comensais. Soma ao total de talheres do dia no fechamento.",
    "comandas.config.covers.perCover": "Mostrar o gasto por pessoa",
    "comandas.config.covers.perCoverDesc": "O arrecadado dividido pelas pessoas, no fechamento, no histórico e no ticket impresso. É o número que não muda se vieram de dois em dois ou de seis em seis.",
    "comandas.config.covers.price": "Quanto você cobra por talher",
    "comandas.config.covers.priceHint": "É somado à conta conforme os talheres que você marcar na mesa. Deixe em 0 se não cobra talher. Mudar o preço não altera as mesas já abertas.",
    "comandas.config.waiterSales.title": "Vendas por garçom",
    "comandas.config.waiterSales.track": "Mostrar o detalhamento por garçom no fechamento",
    "comandas.config.waiterSales.desc": "Soma as vendas de cada garçom (quem fechou cada mesa) no fechamento do dia. Só aparece se trabalhou mais de um.",
    "comandas.config.tips.title": "Gorjetas",
    "comandas.config.tips.track": "Registrar gorjetas por garçom",
    "comandas.config.tips.desc": "Ao fechar uma mesa aparece um campo para anotar a gorjeta. No fechamento do dia soma por garçom (para dividir) e mostra o % de cada um.",
    "comandas.cobro.tip": "Gorjeta (opcional)",
    "comandas.cobro.tipCash": "Em dinheiro",
    "comandas.cobro.tipWhere": "A gorjeta foi em dinheiro?",
    "comandas.cobro.payTitle": "Como pagou?",
    "comandas.cobro.tipWithPay": "Com o pagamento",
    "comandas.cierre.tipsByWaiter": "Gorjetas por garçom",
    "comandas.config.routing.title": "Roteamento por estação",
    "comandas.config.routing.desc": "Escolha por qual impressora sai cada categoria. “Não imprime” = sem comanda (ex. bebidas de geladeira) mas SIM na conta. Sem mexer, tudo vai para a Cozinha.",
    "comandas.config.routing.empty": "Carregue o menu para ver as categorias.",
    "comandas.config.routing.none": "Não imprime",
    "comandas.config.routing.category": "Categoria",
    "comandas.config.routing.station": "Impressora",
    "comandas.config.routing.separate": "Ticket separado",
    "comandas.config.routing.default": "Padrão",
    "comandas.config.routing.addonsEmpty": "Você ainda não cadastrou adicionais fora do cardápio.",
    "comandas.config.tables.count": "Quantidade (mesas 1 a N)",
    "comandas.config.tables.customLabel": "Mesas personalizadas EXTRA (opcional)",
    "comandas.config.tables.customHint": "Separe por vírgulas: Balcão, Delivery, Pátio 1. São ADICIONADAS às numeradas acima (não as substituem).",
    "comandas.waiter.eyebrow": "Modo local",
    "comandas.waiter.title": "Qual é o seu nome?",
    "comandas.waiter.hint": "Para saber qual mesa cada garçom atendeu. Salvo neste celular.",
    "comandas.waiter.placeholder": "Seu nome",
    "comandas.waiter.save": "Salvar",
    "comandas.waiter.later": "Depois",
    "comandas.waiter.chip": "Garçom: {name}",
    "comandas.waiter.set": "Coloque seu nome",
    "comandas.closed.eyebrow": "Hoje",
    "comandas.closed.title": "Mesas fechadas hoje",
    "comandas.closed.button": "Fechadas hoje ({n})",
    "comandas.closed.reopen": "Reabrir",
    "comandas.closed.reprint": "Reimprimir",
    "comandas.closed.done": "Pronto",
    "comandas.voided.button": "Canceladas hoje ({n})",
    "comandas.unpaid.chip": "Sem cobrar ({n})",
    "comandas.unpaid.eyebrow": "Ficaram abertas",
    "comandas.unpaid.title": "{n} sem cobrar",
    "comandas.unpaid.hint": "Não estão no fechamento do dia. Toque em uma para cobrar ou anular.",
    "comandas.unpaid.since": "aberta {time}",
    "comandas.unpaid.total": "Total sem cobrar",
    "comandas.unpaid.banner": "Ainda há {n} sem cobrar ({total}): não estão neste resumo.",
    "comandas.unpaid.see": "Ver",
    "comandas.unpaid.goTurno": "Ir ao Turno",
    "comandas.cierre.unpaidTitle": "SEM COBRAR: {n}",
    "comandas.cierre.unpaidNote": "Não estão neste fechamento: cobre ou anule.",
    "comandas.voided.eyebrow": "Controle",
    "comandas.voided.title": "Mesas canceladas hoje",
    "comandas.voided.hint": "Mesas canceladas sem cobrar. Se diz CONTA IMPRESSA, a conta já tinha sido entregue ao cliente.",
    "comandas.voided.billed": "CONTA IMPRESSA",
    "comandas.voided.items": "{n} item(ns)",
    "comandas.voided.noName": "sem nome",
    "comandas.voided.total": "Total cancelado",
    "comandas.reopen.done": "{table} reaberta",
    "comandas.reopen.occupied": "A mesa {table} já está aberta. Feche-a ou mude o número antes de reabrir esta.",
    "comandas.reopen.pickEyebrow": "Mesa ocupada",
    "comandas.reopen.pickTitle": "A mesa {table} já está aberta. Em qual mesa reabrir?",
    "comandas.reopen.pickHint": "Escolha uma mesa livre.",
    "comandas.reopen.noneFree": "Não há mesas livres agora.",
    "comandas.reopen.pickCancel": "Cancelar",
    "comandas.cancel.chip": "Cancelar",
    "comandas.cancel.confirm": "Cancelar {table}? É anulada sem cobrar e sai das abertas.",
    "comandas.cierre.button": "Relatório do dia",
    "comandas.turno.printers": "Impressoras",
    "comandas.cierre.title": "Fechamento do dia",
    "comandas.cierre.mesas": "Mesas fechadas",
    "comandas.cierre.covers": "Talheres",
    "comandas.cierre.byMethod": "Por forma de pagamento",
    "comandas.cierre.byWaiter": "Por garçom",
    "comandas.hist.pickRange": "Escolher os dias",
    "comandas.hist.dayCount": "{n} dias",
    "comandas.hist.presetToday": "Hoje",
    "comandas.hist.presetYesterday": "Ontem",
    "comandas.hist.presetWeek": "Esta semana",
    "comandas.hist.presetMonth": "Este mês",
    "comandas.hist.presetPrevMonth": "Mês passado",
    "comandas.hist.daysPicked": "{n} dias escolhidos",
    "comandas.hist.rangeSameMonth": "{a} a {b} de {m}",
    "comandas.hist.rangeSpan": "{a} – {b}",
    "comandas.hist.pickDays": "Dias avulsos",
    "comandas.hist.pickDaysHint": "Toque nos dias que quiser comparar (os sábados, por exemplo).",
    "comandas.hist.rangeHint": "Toque no primeiro dia e depois no último.",
    "comandas.hist.clearPick": "Limpar",
    "comandas.hist.apply": "Ver estes dias",
    "comandas.hist.maxRange": "Até 3 meses por vez.",
    "comandas.hist.perDay": "méd. {m} por dia",
    "comandas.hist.tablesRange": "Mesas cobradas",
    "comandas.hist.prev": "Anterior",
    "comandas.hist.next": "Seguinte",
    "comandas.hist.emptyRange": "Sem vendas fechadas nesses dias.",
    "comandas.hist.loadFailed": "Não foi possível ler essas vendas. Toque em Atualizar para tentar de novo.",
    "comandas.hist.scopeVisible": "do que você está vendo",
    "comandas.hist.eyebrow": "Relatório de gestão",
    "comandas.hist.title": "Histórico",
    "comandas.hist.nonFiscal": "Não fiscal — controle interno",
    "comandas.hist.emptyDay": "Sem vendas fechadas neste dia.",
    "comandas.hist.total": "Vendido",
    "comandas.hist.avgTicket": "Ticket médio",
    "comandas.hist.reprint": "Reimprimir fechamento do dia",
    "comandas.hist.sold": "O que foi vendido",
    "comandas.hist.soldCount": "{n} produtos · {u} unidades",
    "comandas.hist.soldSearch": "Procurar um prato…",
    "comandas.hist.soldNoMatch": "Nada com esse nome foi vendido nesses dias.",
    "comandas.hist.soldNote": "Não inclui couverts, adicionais lançados à mão nem a taxa de delivery, e não desconta os descontos.",
    "comandas.hist.byQty": "Por quantidade",
    "comandas.hist.byMoney": "Por valor",
    "comandas.hist.flat": "Tudo junto",
    "comandas.hist.byCat": "Por categoria",
    "comandas.hist.catUnits": "{u} unidades",
    "comandas.hist.noCat": "Sem categoria",
    "comandas.hist.showRest": "Ver os {n} restantes",
    "comandas.hist.tipLabel": "Gorjeta",
    "comandas.hist.tip": "gorjeta {m} ({how})",
    "comandas.hist.tipApart": "A gorjeta não entra no total da mesa: entrou à parte, por esse meio.",
    "comandas.hist.dlvPhone": "Tel.",
    "comandas.hist.dlvTime": "Para as {time}",
    "comandas.hist.tables": "Mesas do dia",
    "comandas.hist.detailEyebrow": "Detalhe da mesa",
    "comandas.hist.paidWith": "Pagou com",
    "comandas.hist.loadError": "Não consegui carregar esse dia",
    "comandas.hist.refresh": "Atualizar",
    "comandas.hist.last30": "Últimos 30 dias",
    "comandas.cierre.empty": "Sem vendas ainda",
    "comandas.cierre.print": "Imprimir fechamento",
    "comandas.cierre.printing": "Imprimindo…",
    "comandas.cierre.ticketTitle": "FECHAMENTO DO DIA",
    "comandas.cierre.productsTitle": "PRODUTOS VENDIDOS",
    "comandas.cierre.voidedTitle": "ANULADAS (não cobradas)",
    "comandas.cierre.voidedItemsTitle": "Pratos anulados já enviados",
    "comandas.cierre.periodTitle": "RESUMO DO PERIODO",
    "comandas.cierre.periodRange": "Ultimos 30 dias",
    "comandas.mesa.subtotal": "Subtotal",
    "comandas.adj.eyebrow": "Conta",
    "comandas.adj.title": "Adicionais e descontos",
    "comandas.adj.charge": "Adicional",
    "comandas.adj.discount": "Desconto",
    "comandas.adj.labelPlaceholder": "Conceito (ex: bolo, serviço)",
    "comandas.adj.add": "Adicionar",
    "comandas.adj.presets": "Salvos",
    "comandas.adj.savePreset": "Salvar como preset",
    "comandas.adj.button": "Adicional / desconto",
    "comandas.adj.buttonN": "Ajustes ({n})",
    "comandas.cats.button": "Ver cardápio por categorias",
    "comandas.cats.title": "Categorias",
    "comandas.cats.other": "Outros",
    "comandas.cats.empty": "O cardápio ainda não carregou.",
    "comandas.cats.added": "Adicionado: {name}",
    "comandas.void.action": "Anular mesa sem cobrar",
    "comandas.void.confirm": "Tem certeza? Anular sem cobrar",
    "comandas.void.done": "{table} anulada",
    "comandas.void.label": "Anulada (sem cobrança)",
    "comandas.void.tag": "ANULADA",
    "comandas.void.sentAction": "Anular este item (já está na cozinha)",
    "comandas.void.sentActionShort": "Anular",
    "comandas.void.sentEyebrow": "Anular item enviado",
    "comandas.void.sentWarn": "Imprime um aviso de ANULAÇÃO na impressora da cozinha e o item sai da conta.",
    "comandas.void.sentConfirm": "Sim, anular",
    "comandas.void.sentConfirmN": "Anular ({n})",
    "comandas.void.sentTitle": "Anular itens enviados",
    "comandas.void.sentBusy": "Anulando…",
    "comandas.void.sentDone": "{name} anulado",
    "comandas.void.sentDoneN": "{n} itens anulados",
    "comandas.split.button": "Dividir",
    "comandas.split.eyebrow": "Dividir a conta",
    "comandas.split.title": "Como dividir?",
    "comandas.split.equal": "Partes iguais",
    "comandas.split.byItem": "Por item",
    "comandas.split.howMany": "Em quantas partes?",
    "comandas.split.eachPays": "Cada um (÷ {n}): ",
    "comandas.split.printEqual": "Imprimir {n} tickets",
    "comandas.split.printing": "Imprimindo…",
    "comandas.split.pickItems": "Escolha quanto de cada item",
    "comandas.split.tapHint": "Toque na linha para somar de um em um",
    "comandas.split.each": "{price} cada",
    "comandas.split.unassigned": "Faltam {n} para dividir",
    "comandas.split.allAssigned": "Você já dividiu tudo",
    "comandas.split.zeroPart": "Essa parte dá $0 — não há nada a cobrar",
    "comandas.split.selected": "Selecionado: ",
    "comandas.split.printPart": "Imprimir esta parte",
    "comandas.split.printedEqual": "{n} partes impressas",
    "comandas.split.printedPart": "Parte impressa",
    "comandas.split.partOf": "Parte {i} de {n}",
    "comandas.split.partLabel": "Parte da conta",
    "comandas.move.chip": "Mover",
    "comandas.move.eyebrow": "Mover / Juntar mesa",
    "comandas.move.title": "Mesa {table} → para onde?",
    "comandas.move.hint": "Livre = mover a mesa inteira. Ocupada = juntar as duas.",
    "comandas.move.moveHere": "Mover aqui",
    "comandas.move.join": "Juntar",
    "comandas.move.ticketTitle": "MUDANÇA DE MESA",
    "comandas.move.moved": "Mesa {from} movida para {to}",
    "comandas.move.merged": "Mesa {from} juntada com a {to}",
    "comandas.move.mergeSrcFail": "Juntadas, mas não consegui liberar a mesa {from}. Anule-a manualmente.",
    "comandas.move.confirmEyebrow": "Juntar mesas",
    "comandas.move.confirmTitle": "Mesa {from} → Mesa {to}",
    "comandas.move.confirmItems": "Vão para a mesa {to}:",
    "comandas.move.confirmNoItems": "A mesa {from} não tem produtos.",
    "comandas.move.confirmCovers": "Talheres: a {to} tem {a} + a {from} tem {b} → fica com {sum}",
    "comandas.move.confirmTotal": "Total da mesa {to}: {total}",
    "comandas.move.confirmWarn": "A mesa {from} fecha e tudo fica na {to}.",
    "comandas.move.confirmBack": "Voltar",
    "comandas.move.confirmGo": "Juntar",
    "comandas.send.sentNoPrint": "Enviado (isso não sai na comanda)",
    "comandas.pay.efectivo": "Dinheiro",
    "comandas.pay.mixto": "Misto",
    "comandas.pay.debito": "Débito",
    "comandas.pay.credito": "Crédito",
    "comandas.pay.transferencia": "Transferência",
    "comandas.pay.mercadopago": "MercadoPago",
    "comandas.pay.modo": "MODO",
    "comandas.pay.cuentadni": "Cuenta DNI",
    "comandas.pay.vales": "Vales",
    "comandas.channel.salon": "Salão",
    "comandas.channel.delivery": "Delivery",
    "comandas.channel.takeaway": "Para viagem",
    "comandas.delivery.title": "Delivery e para viagem",
    "comandas.delivery.hint": "Pedidos que não são de uma mesa.",
    "comandas.delivery.new": "Novo pedido",
    "comandas.delivery.empty": "Não há pedidos abertos.",
    "comandas.delivery.emptyOwn": "Não há pedidos abertos. Toque em um botão acima para lançar um.",
    "comandas.delivery.envioSub": "Nós levamos",
    "comandas.delivery.retiroSub": "O cliente vem buscar",
    "comandas.delivery.fromApp": "De um app:",
    "comandas.delivery.appNoAddress": "Pedido de app não leva endereço nem cobrança: o app cuida disso. É você quem entrega e cobra? Abra como Entrega pelo Turno.",
    "comandas.delivery.count": "Delivery ({n})",
    "comandas.delivery.eyebrow": "Pedido de app",
    "comandas.delivery.refTitle": "Qual é o número do pedido?",
    "comandas.delivery.refHint": "O número que o app mostra. Serve para achá-lo depois, quando o app te repassar.",
    "comandas.delivery.ref": "N° do pedido",
    "comandas.delivery.refPh": "ex. A4F2",
    "comandas.delivery.customer": "Cliente (opcional)",
    "comandas.delivery.customerPh": "Nome",
    "comandas.delivery.save": "Pronto",
    "comandas.delivery.noMove": "Um pedido de app não se move nem se junta com uma mesa.",
    "comandas.delivery.markup": "Acréscimo {pct}%",
    "comandas.delivery.commissionChip": "Comissão {pct}%",
    "comandas.delivery.items": "prod.",
    "comandas.delivery.gone": "Esse tipo de pedido não está mais disponível. Abra de novo pelo Turno.",
    "comandas.delivery.closed": "Esse pedido não está mais aberto.",
    "comandas.dlv.kind.envio": "Entrega",
    "comandas.dlv.kind.retiro": "Para viagem",
    "comandas.dlv.orderShort": "Pedido {n}",
    "comandas.dlv.addCustomerEnvio": "Informar cliente e endereço",
    "comandas.dlv.addCustomerRetiro": "Informar nome e telefone",
    "comandas.dlv.bagPrint": "Imprimir ticket do pedido",
    "comandas.dlv.bagReprint": "Reimprimir ticket do pedido",
    "comandas.dlv.bagPrinted": "Ticket do pedido impresso ({table})",
    "comandas.dlv.bagNoPrinter": "{table}: não há impressora disponível para o ticket da sacola. Confira e toque em “Imprimir ticket do pedido”.",
    "comandas.dlv.bagFailed": "{table}: o ticket da sacola NÃO saiu. Confira a impressora da conta e toque em “Imprimir ticket do pedido”.",
    "comandas.dlv.bagUnconfirmed": "{table}: não foi possível confirmar se o ticket da sacola saiu. Confira a impressora antes de reimprimir.",
    "comandas.dlv.feeLabel": "Taxa de entrega",
    "comandas.dlv.a.titleEnvio": "Para quem e para onde?",
    "comandas.dlv.a.titleRetiro": "Em nome de quem?",
    "comandas.dlv.a.orderIs": "É o pedido {n}",
    "comandas.dlv.a.later": "Se faltar algo, você completa depois em «Cliente e entrega».",
    "comandas.dlv.a.name": "Nome",
    "comandas.dlv.a.namePh": "Graciela",
    "comandas.dlv.a.phone": "Telefone",
    "comandas.dlv.a.phonePh": "11 91234-5678",
    "comandas.dlv.a.address": "Rua e número",
    "comandas.dlv.a.addressPh": "Rua São Martinho, 1234",
    "comandas.dlv.a.noNumber": "Falta o número? Sem ele o entregador não acha a casa.",
    "comandas.dlv.a.floor": "Andar / apto",
    "comandas.dlv.a.floorPh": "Apto 2B",
    "comandas.dlv.a.ref": "Entre ruas / referência (para o entregador)",
    "comandas.dlv.a.refPh": "entre Moreno e Belgrano, portão verde",
    "comandas.dlv.kbdHint": "Enter vai para o próximo · Esc fecha sem perder o que foi digitado",
    "comandas.dlv.b.title": "Hora e pagamento",
    "comandas.dlv.b.whenEnvio": "Para quando?",
    "comandas.dlv.b.whenRetiro": "Quando vem buscar?",
    "comandas.dlv.b.asap": "O quanto antes",
    "comandas.dlv.b.in30": "+30 min",
    "comandas.dlv.b.in45": "+45 min",
    "comandas.dlv.b.in60": "+1 h",
    "comandas.dlv.b.timePh": "ou digite a hora: 2130",
    "comandas.dlv.b.timeAria": "Hora",
    "comandas.dlv.b.timeBad": "Não entendi essa hora. Tente 21:30 ou 2130.",
    "comandas.dlv.b.timeIs": "Fica para as {time}",
    "comandas.dlv.b.fee": "Taxa de entrega",
    "comandas.dlv.b.pay": "Como vai pagar?",
    "comandas.dlv.b.payUnset": "Não definido",
    "comandas.dlv.b.paid": "Já pagou (você viu o crédito)",
    "comandas.dlv.b.paidAmount": "Pagou",
    "comandas.dlv.b.paidShort": "Falta cobrar {amount}: o ticket vai avisar o entregador.",
    "comandas.dlv.b.paidOver": "Pagou {amount} a mais.",
    "comandas.dlv.b.payWith": "Vai pagar com quanto?",
    "comandas.dlv.b.exact": "Exato",
    "comandas.dlv.b.payWithPh": "Valor",
    "comandas.dlv.b.change": "Troco: {amount}",
    "comandas.dlv.b.notEnough": "Não dá: faltam {amount}",
    "comandas.dlv.b.note": "Observação do pedido (sai na comanda e no ticket)",
    "comandas.dlv.b.notePh": "celíaco, mandar guardanapos…",
    "comandas.dlv.card.title": "Cliente e entrega",
    "comandas.dlv.card.whenPay": "Hora e pagamento",
    "comandas.dlv.card.noPhone": "Sem telefone",
    "comandas.dlv.card.noAddress": "Sem endereço",
    "comandas.dlv.card.edit": "Editar",
    "comandas.dlv.send.title": "Antes de mandar para a cozinha",
    "comandas.dlv.send.hint": "No ticket do pedido, o que faltar sai com uma linha para completar à mão.",
    "comandas.dlv.send.fixAddress": "Informar o endereço",
    "comandas.dlv.send.fixPay": "Informar como paga",
    "comandas.dlv.send.anyway": "Mandar assim mesmo",
    "comandas.dlv.send.kbd": "Enter completa · Esc manda assim mesmo",
    "comandas.dlv.send.back": "Voltar ao pedido (não mandar ainda)",
    "comandas.dlv.card.noName": "Sem nome",
    "comandas.dlv.card.deliverAt": "Entregar às {time}",
    "comandas.dlv.card.pickupAt": "Retira às {time}",
    "comandas.dlv.card.asap": "O quanto antes",
    "comandas.dlv.card.paid": "Já pagou · {method}",
    "comandas.dlv.card.paidPart": "Pagou {paid} · falta {rest}",
    "comandas.dlv.card.payUnset": "Forma de pagamento não definida",
    "comandas.dlv.card.cashExact": "Dinheiro · paga exato",
    "comandas.dlv.card.cashChange": "Dinheiro · paga com {payWith} → troco {change}",
    "comandas.dlv.card.fee": "Taxa de entrega {amount}",
    "comandas.dlv.card.note": "Obs: {note}",
    "comandas.dlv.warn.noAddress": "Falta o endereço",
    "comandas.dlv.warn.noPay": "Falta a forma de pagamento",
    "comandas.dlv.warn.shortPay": "Paga com menos que o total (faltam {amount})",
    "comandas.dlv.warn.overPaid": "Pagou {amount} a mais",
    "comandas.dlv.warn.stale": "O ticket da sacola saiu com dados antigos",
    "comandas.dlv.warn.reprint": "Reimprimir",
    "comandas.dlv.agentOld": "Sua impressora ainda não imprime os dados de entrega. Ela se atualiza sozinha em alguns minutos; enquanto isso, o ticket sai como sempre.",
    "comandas.dlv.cobro.plan": "Previsto: {method}",
    "comandas.dlv.cobro.planPaid": "Previsto: {method} · já pagou {amount}",
    "comandas.dlv.cobro.change": "Pagava com {payWith}: troco {change}",
    "comandas.dlv.p.tagEnvio": "ENTREGA",
    "comandas.dlv.p.tagRetiro": "PARA VIAGEM",
    "comandas.dlv.p.forTime": "PARA AS {time}",
    "comandas.dlv.p.note": "OBS: {note}",
    "comandas.dlv.p.updated": "ATUALIZADO",
    "comandas.dlv.p.updatedHint": "Substitui o ticket anterior - não cozinhar de novo",
    "comandas.dlv.p.orderNo": "PEDIDO {n}",
    "comandas.dlv.p.typeEnvio": "ENTREGA EM DOMICÍLIO",
    "comandas.dlv.p.typeRetiro": "RETIRADA NO LOCAL",
    "comandas.dlv.p.deliverAt": "Entregar às {time}",
    "comandas.dlv.p.pickupAt": "Retira às {time}",
    "comandas.dlv.p.asap": "O quanto antes",
    "comandas.dlv.p.phone": "Tel. cliente: {phone}",
    "comandas.dlv.p.addressBlank": "Endereço: ______________________",
    "comandas.dlv.p.paidAll": "JÁ PAGO - NÃO COBRAR",
    "comandas.dlv.p.paidPart": "PAGOU {paid} - COBRAR {rest}",
    "comandas.dlv.p.collect": "COBRAR {amount}",
    "comandas.dlv.p.payBlank": "Pagamento: ______________",
    "comandas.dlv.p.exact": "Paga exato, sem troco",
    "comandas.dlv.p.payWith": "Paga com",
    "comandas.dlv.p.change": "LEVAR TROCO",
    "comandas.dlv.p.notEnough": "Paga com {amount} - NÃO DÁ",
    "comandas.dlv.p.paidDone": "PAGO {amount}",
    "comandas.dlv.list.paid": "Pago",
    "comandas.dlv.list.dupNo": "Nº repetido",
    "comandas.dlv.list.stale": "Ticket antigo",
    "comandas.dlv.list.noBag": "Falta o ticket",
    "comandas.dlv.renumbered": "Outro aparelho pegou o pedido {from}: este passa a ser o {n}. Avise o cliente.",
    "comandas.dlv.b.timeIsTomorrow": "Fica para AMANHÃ às {time}",
    "comandas.dlv.b.paidPh": "Quanto pagou? (do comprovante)",
    "comandas.dlv.b.paidMissing": "Coloque quanto pagou, ou desmarque «Já pagou». Sem valor, o ticket diria ao entregador para cobrar.",
    "comandas.dlv.card.paidNoMethod": "Pagou {paid} · falta a forma",
    "comandas.dlv.warn.paidNoMethod": "Pagou, mas falta a forma de pagamento",
    "comandas.dlv.warn.noBag": "O ticket da sacola não saiu",
    "comandas.dlv.warn.print": "Imprimir",
    "comandas.dlv.cobro.paidNoMethod": "Já pagou {amount}, mas não foi anotado com o quê: escolha a forma.",
    "comandas.cobro.appPaid": "Quem cobra é {app}",
    "comandas.cobro.appPaidHint": "Te repassa depois: esse dinheiro não entra no caixa de hoje.",
    "comandas.cobro.payNow": "Eu cobro agora",
    "comandas.cobro.payNowHint": "Pagou ao entregador ou por transferência: esse dinheiro entra hoje.",
    "comandas.cobro.todayGroup": "Entra hoje",
    "comandas.cobro.deferredGroup": "Quem cobra é o app",
    "comandas.cobro.commission": "Comissão {pct}%",
    "comandas.cobro.net": "Fica pra você",
    "comandas.cobro.gross": "Bruto",
    "comandas.cierre.today": "Entra hoje",
    "comandas.cierre.deferred": "Recebe depois",
    "comandas.cierre.deferredHint": "Cobrado pelos apps. Não está no caixa: te repassam mais adiante.",
    "comandas.cierre.commission": "Comissão dos apps",
    "comandas.cierre.commissionDay": "Comissão dos apps (dia todo)",
    "comandas.cierre.net": "Líquido (depois das comissões)",
    "comandas.cierre.byChannel": "Por canal",
    "comandas.cierre.dlvFeesTitle": "Entregas",
    "comandas.cierre.dlvFees": "Taxas de entrega cobradas ({n})",
    "comandas.cierre.dlvFeesCash": "Disso, em dinheiro",
    "comandas.cierre.dlvFeesHint": "Já estão incluídas no total: não se somam à parte. Se a taxa é do entregador, o que entrou em dinheiro é o que tem que pagar a ele.",
    "comandas.cierre.delivery": "Delivery e para viagem",
    "comandas.cierre.avgSalon": "Ticket médio (salão)",
    "comandas.cierre.perCover": "Por pessoa",
    "comandas.cierre.perCoverTitle": "Por pessoa",
    "comandas.cierre.todayTitle": "ENTRA HOJE",
    "comandas.cierre.deferredTitle": "RECEBE DEPOIS",
    "comandas.cierre.deferredNote": "cobrado pelos apps - nao esta no caixa",
    "comandas.cierre.commissionTitle": "Comissao apps",
    "comandas.cierre.commissionOf": "comissao",
    "comandas.cierre.commissionDayTitle": "Comissao apps (total do dia)",
    "comandas.cierre.netTitle": "te repassam",
    "comandas.cierre.subtotalTitle": "subtotal",
    "comandas.cierre.deliveryTitle": "Delivery e para viagem",
    "comandas.settle.title": "Os apps te devem",
    "comandas.settle.hint": "O que os apps cobraram neste período e você ainda não marcou como recebido.",
    "comandas.settle.empty": "Não te devem nada: está tudo recebido.",
    "comandas.settle.gross": "Bruto",
    "comandas.settle.commission": "Comissão",
    "comandas.settle.net": "Líquido estimado",
    "comandas.settle.pending": "Pendente",
    "comandas.settle.orders": "{n} pedidos",
    "comandas.settle.mark": "Marcar recebido",
    "comandas.settle.markConfirm": "Tem certeza?",
    "comandas.settle.saving": "Salvando…",
    "comandas.settle.done": "Pronto: {n} pedidos marcados como recebidos.",
    "comandas.settle.partial": "Marcados {n} de {total}. Tente de novo com os que faltam.",
    "comandas.settle.undone": "Desfeito: {n} pedidos voltam a ficar pendentes.",
    "comandas.settle.settledTag": "recebido",
    "comandas.settle.undo": "Desfazer",
    "comandas.config.delivery.title": "Delivery e para viagem",
    "comandas.config.delivery.railTitle": "Delivery",
    "comandas.config.delivery.desc": "Pedidos que não são de uma mesa: os que você entrega, os que o cliente vem buscar e, se quiser, os dos apps.",
    "comandas.config.delivery.enable": "Receber pedidos de delivery e para viagem",
    "comandas.config.delivery.enableHint": "Aparecem acima das mesas, no Turno. Ao abrir um, ele pede os dados do cliente (numa entrega, também o endereço). Não precisa configurar mais nada.",
    "comandas.config.delivery.ownTitle": "Seus pedidos",
    "comandas.config.delivery.ownDesc": "Você mesmo cobra, como uma mesa. Já vêm prontos para usar.",
    "comandas.config.delivery.envio": "Entrega em domicílio",
    "comandas.config.delivery.envioDesc": "Seu entregador leva. Você informa nome, telefone e endereço, e sai um ticket para a sacola com quanto cobrar e o troco.",
    "comandas.config.delivery.retiro": "Para viagem",
    "comandas.config.delivery.retiroDesc": "O cliente vem buscar. Você informa nome e telefone.",
    "comandas.config.delivery.more": "Mais opções",
    "comandas.config.delivery.remove": "Remover",
    "comandas.config.delivery.ownNameHint": "É como fica registrado nos pedidos fechados e no histórico. Vale para os pedidos novos.",
    "comandas.config.delivery.ownMarkupHint": "Se você cobra mais nesses pedidos do que no salão. É somado sozinho; os preços do cardápio não mudam.",
    "comandas.config.delivery.noneActive": "Assim não vai aparecer nenhum botão no Turno: ative Entrega ou Para viagem, ou adicione um app.",
    "comandas.config.delivery.appsTitle": "Apps de delivery",
    "comandas.config.delivery.optional": "opcional",
    "comandas.config.delivery.appsDesc": "Se você também vende por um app, adicione. O que o app cobra não entra no caixa do dia: ele te repassa depois.",
    "comandas.config.delivery.appsEmpty": "Você não adicionou nenhum app. Não é preciso para receber seus próprios pedidos.",
    "comandas.config.delivery.addOther": "Outro app",
    "comandas.config.delivery.appsNote": "Num pedido de app só se informa o número do pedido: o endereço e a cobrança ficam com o app.",
    "comandas.config.delivery.platforms": "Plataformas",
    "comandas.config.delivery.name": "Nome",
    "comandas.config.delivery.namePh": "Nome do app",
    "comandas.config.delivery.commission": "Comissão %",
    "comandas.config.delivery.commissionHint": "Comissão: o que fica com o app. Não muda o que você cobra: serve para saber quanto sobra de verdade.",
    "comandas.config.delivery.markup": "Acréscimo %",
    "comandas.config.delivery.markupHint": "Se no app você vende mais caro, informe quanto. É somado ao pedido sozinho; os preços do cardápio não mudam.",
    "comandas.config.delivery.settlementDays": "Te repassa em… (dias)",
    "comandas.config.delivery.settlementDaysHint": "Para o caixa avisar se um repasse atrasou. Em 0 não avisa.",
    "comandas.settle.overdue": "atrasado há {d} dias",
    "comandas.settle.overdueTotal": "Atrasado",
    "comandas.config.delivery.needName": "Dê um nome ao app antes de salvar.",
    "comandas.config.delivery.tableWarn": "Atenção: você tem uma mesa chamada “{name}”. Se começar a usar esta seção, tire-a das mesas personalizadas para não lançar o mesmo pedido duas vezes.",
    "comandas.config.delivery.fee": "Taxa de entrega",
    "comandas.config.delivery.feeHint": "É somado sozinho a cada entrega, e em cada pedido dá para mudar. Em 0 não é cobrado.",
    "comandas.config.delivery.ticketTitle": "O que é impresso",
    "comandas.config.delivery.ticketDesc": "Uma entrega imprime dois papéis: a comanda da cozinha (número, nome, hora e observação; sem valores nem endereço) e o ticket do pedido, grampeado na sacola (cliente, endereço, quanto cobrar e o troco). Um pedido para viagem imprime só a comanda, a menos que você ative o ticket dele aqui embaixo.",
    "comandas.config.delivery.ticketEnvio": "Ticket do pedido nas entregas",
    "comandas.config.delivery.ticketEnvioDesc": "Sai sozinho ao mandar uma entrega para a cozinha, pela impressora da conta. Quem lê é o entregador: para onde vai, quanto cobrar e quanto troco levar.",
    "comandas.config.delivery.ticketRetiro": "Ticket do pedido nos pedidos para viagem",
    "comandas.config.delivery.ticketRetiroDesc": "Para pedidos por telefone que vêm buscar: nome, hora e se já pagou. Desligado, uma venda de balcão não gasta um segundo papel.",
    "comandas.config.delivery.kitchenName": "Nome do cliente na comanda",
    "comandas.config.delivery.kitchenNameDesc": "Grande, acima dos pratos: é o que se chama no balcão e o que distingue dois pedidos iguais.",
    "comandas.config.delivery.agentOld": "Sua impressora ainda não imprime os dados dos pedidos para viagem (ela se atualiza sozinha em alguns minutos). Enquanto isso o ticket do pedido não sai sozinho e os papéis saem como antes.",
    "comandas.mesa.empty": "Nada lançado ainda. Digite um prato acima e aperte Enter.",
    "comandas.mesa.total": "Total",
    "comandas.mesa.menuPending": "Baixando o cardápio… as mesas e os pedidos funcionam igual.",
    "comandas.mesa.send": "Enviar à cozinha ({n})",
    "comandas.mesa.sendAdd": "Enviar adicional ({n})",
    "comandas.mesa.reprintAll": "Reimprimir tudo",
    "comandas.mesa.sending": "Enviando…",
    "comandas.mesa.sent": "enviado ✓",
    "comandas.mesa.note": "Observação",
    "comandas.mesa.noteFor": "Observação para",
    "comandas.mesa.notePlaceholder": "Ex: sem sal, bem passado…",
    "comandas.mesa.saveNote": "Salvar",
    "comandas.mesa.cancel": "Cancelar",
    "comandas.mesa.cs.add": "adicionar",
    "comandas.mesa.cs.qty": "quantidade",
    "comandas.mesa.cs.note": "observar",
    "comandas.mesa.cs.move": "escolher",
    "comandas.mesa.cs.send": "enviar",
    "comandas.turno.open": "Abrir uma mesa:",
    "comandas.turno.openPlaceholder": "N° + Enter",
    "comandas.mesa.lineSelected": "Linha selecionada — número = quantidade · + / − ajusta · Del apaga · Esc solta",
    "comandas.send.nothing": "Não há itens novos para enviar.",
    "comandas.send.closedOrder": "{table} já está fechada: não dá para mandar para a cozinha. Para continuar lançando, reabra-a em «Fechadas hoje».",
    "comandas.mesa.paidElsewhere": "{table} foi paga em outro aparelho. Já está livre: abra de novo para os próximos clientes.",
    "comandas.mesa.paidElsewhereUnsent": "{table} foi paga em outro aparelho. {n} item(ns) que você lançou aqui NÃO foram para a cozinha: abra a mesa de novo e lance-os.",
    "comandas.mesa.voidedElsewhere": "{table} foi anulada em outro aparelho. Já está livre.",
    "comandas.mesa.voidedElsewhereUnsent": "{table} foi anulada em outro aparelho. {n} item(ns) que você lançou aqui NÃO foram para a cozinha: abra a mesa de novo e lance-os.",
    "comandas.send.saveError": "Não foi possível salvar o pedido: {msg}",
    "comandas.config.tables.title": "Quantidade de mesas",
    "comandas.config.tables.desc": "Quantas mesas mostrar na grade de turno.",
    "comandas.config.title": "Configuração de comandas",
    "comandas.config.subtitle": "Configure suas impressoras e como aparecem a comanda e a conta. A prévia à direita é o papel de 80mm real.",
    "comandas.config.title.eyebrow": "Meu local",
    "comandas.config.sections": "Seções",
    "comandas.config.tipBox.title": "Dica:",
    "comandas.config.tipBox.body": "toque em uma seção para ir até ela. Tudo que você muda aparece na hora no ticket.",
    "comandas.preview.live": "Ao vivo",
    "comandas.config.comanda.showWaiterDesc": "A cozinha sabe a quem avisar.",
    "comandas.config.comanda.showTimeDesc": "Hora exata em que entrou o pedido.",
    "comandas.config.comanda.showOrderNumberDesc": "Sequência do dia, para reclamações.",
    "comandas.config.comanda.groupByStationDesc": "Grelha, cozinha fria, bar… cada um lê o seu.",
    "comandas.config.comanda.invertNotes": "Observações destacadas em preto",
    "comandas.config.comanda.invertNotesDesc": "Fundo preto com letra branca. Se na sua impressora borra e não dá para ler, desligue: saem em negrito normal.",
    "comandas.tiempos.markHere": "Marcar até aqui",
    "comandas.tiempos.removeMark": "Tirar a linha",
    "comandas.tiempos.pill": "{n}.º tempo",
    "comandas.tiempos.hereAfter": "Linha aqui",
    "comandas.tiempos.removeAria": "Tirar esta linha",
    "comandas.tiempos.ticket": "TEMPO {n}",
    "comandas.tiempos.ticketWait": "TEMPO {n} - ESPERAR",
    "comandas.config.comanda.tiempos": "Marcar tempos com uma linha",
    "comandas.config.comanda.tiemposDesc": "Para que a cozinha não mande tudo de uma vez. O garçom marca o que sai agora e o que espera a mesa terminar o anterior, e a comanda já sai dividida. Serve para entradas e pratos principais, e também para quem começa por um principal. Marca-se com o botão ao pé do pedido (ou com a tecla / se usar teclado), e os pratos saem na ordem em que foram carregados.",
    "comandas.config.comanda.courseMode": "Como se vê a linha",
    "comandas.config.comanda.courseModeText": "Com texto",
    "comandas.config.comanda.courseModeLine": "Só a linha",
    "comandas.config.comanda.courseLabel": "O que diz a linha",
    "comandas.config.comanda.courseLabelHelp": "Escreva {n} onde quiser o número do tempo. Vazio = o texto padrão.",
    "comandas.config.comanda.courseH": "Altura da linha",
    "comandas.config.comanda.courseW": "Largura da linha",
    "comandas.config.style.title": "Como se lê a comanda",
    "comandas.config.style.desc": "Na cozinha há pouca luz, vapor e pressa. Toque nestas opções e olhe o ticket ao lado até ler de relance; depois imprima um teste de verdade.",
    "comandas.config.style.itemSize": "Tamanho do prato",
    "comandas.config.style.itemH": "Altura do prato",
    "comandas.config.style.itemW": "Largura do prato",
    "comandas.config.style.noteH": "Altura das observações",
    "comandas.config.style.noteW": "Largura das observações",
    "comandas.config.style.itemBold": "Nome do prato em negrito",
    "comandas.config.style.itemBoldDesc": "É a letra mais grossa, a mesma do título COCINA. Se os pratos saem apagados, é a primeira coisa a testar.",
    "comandas.config.style.noteSize": "Tamanho das observações",
    "comandas.config.style.tableSize": "Tamanho do número da mesa",
    "comandas.config.style.stationBold": "Separadores de estação em negrito",
    "comandas.config.style.stationBoldDesc": "As linhas “-- PARRILLA --” que dividem a comanda.",
    "comandas.config.style.sizeNormal": "Normal",
    "comandas.config.style.sizeTall": "Grande",
    "comandas.config.style.sizeTall2": "Maior",
    "comandas.config.style.sizeBig": "Muito grande",
    "comandas.config.style.sizeAuto": "Automático",
    "comandas.config.style.paper": "Largura do papel",
    "comandas.config.style.paperHint": "Para que a pré-visualização mostre a verdade. Não muda a impressora: é a largura da bobina que você já tem.",
    "comandas.config.style.wrapWarn": "Com “Muito grande” cabem {n} caracteres por linha: os pratos de nome longo saem partidos em dois. Resolve-se dando a eles um nome curto para a cozinha, mais abaixo.",
    "comandas.config.style.agentOld": "A impressora deste local se atualiza sozinha em alguns minutos. Até lá continua imprimindo como antes, mesmo que aqui você já veja mudado.",
    "comandas.config.style.test": "Imprimir um teste",
    "comandas.config.kitchenNames.title": "Nomes para a cozinha",
    "comandas.config.kitchenNames.desc": "Um prato pode se chamar “PENNE RIGATE CON LANGOSTINOS SALTEADOS” no cardápio e chegar à cozinha como “PENNE”. O chef sabe qual é e lê muito mais rápido. O cardápio, a conta do cliente e os relatórios não mudam.",
    "comandas.config.kitchenNames.search": "Procurar um prato…",
    "comandas.config.kitchenNames.placeholder": "Nome curto",
    "comandas.config.kitchenNames.empty": "Procure um prato para dar a ele um nome curto.",
    "comandas.config.kitchenNames.none": "Ainda não há nenhum. Os pratos sem nome curto saem com o nome do cardápio.",
    "comandas.config.kitchenNames.count": "{n} com nome curto",
    "comandas.config.kitchenNames.stale": "revisar",
    "comandas.config.kitchenNames.staleHint": "Este prato mudou de nome no cardápio. Enquanto isso sai com o nome completo: confirme digitando o nome curto de novo.",
    "comandas.config.kitchenNames.readOnly": "Isto se configura pelo painel, não pela tela do local (senão é sobrescrito).",
    "comandas.config.cuenta.showTipDesc": "Aparece calculada no rodapé da conta.",
    "comandas.config.cuenta.footerHelper": "A última linha que seu cliente lê. Que seja sua.",
    "comandas.config.save": "Salvar alterações",
    "comandas.config.unsaved": "Você tem alterações não salvas",
    "comandas.config.printers.namePlaceholder": "Ex: Cozinha",
    "comandas.config.printers.connected": "Conectada",
    "comandas.config.printers.notConnected": "Sem conectar",
    "comandas.config.printers.showTech": "Dados técnicos (IP e porta)",
    "comandas.config.printers.hideTech": "Ocultar dados técnicos",
    "comandas.config.printers.addManual": "Adicionar manualmente",
    "comandas.config.printers.detectOnLocalPc": "Não sabe o IP? A impressora conecta sozinha a partir do PC do local: abra “Comandas” lá → botão Impressoras.",
    "comandas.config.printers.addDetect": "Detectar impressora",
    "comandas.config.printers.billPrinter": "Impressora da conta",
    "comandas.config.printers.billPrinterAuto": "Automático (caixa → bar → cozinha)",
    "comandas.config.printers.billPrinterHelp": "Por qual impressora sai a conta do cliente e o fechamento do dia.",
    "comandas.config.printers.unnamed": "Impressora sem nome",
    "comandas.config.printers.viaUsb": "USB",
    "comandas.config.printers.viaNet": "Rede",
    "comandas.config.printers.usbQueue": "Impressora do Windows",
    "comandas.config.printers.techHint": "Se conectar a impressora com o código acima, o IP é preenchido sozinho. Isto é só para configuração manual.",
    "comandas.print.expired": "A comanda não pôde ser confirmada (sem confirmação). Verifique a impressora e reimprima.",
    "comandas.print.failedMixed": "MESA {table}: parte da comanda não saiu e voltou para pendentes, e outra parte não pôde ser confirmada. Confira as impressoras antes de reimprimir.",
    "comandas.print.failedTable": "MESA {table}: a comanda NÃO saiu. Esses itens voltaram para pendentes: confira a impressora e toque em Enviar de novo.",
    "comandas.print.failedBill": "{table}: a conta ou o ticket do pedido NÃO saiu. Confira a impressora e reimprima esse papel.",
    "comandas.print.unconfirmedBill": "{table}: não foi possível confirmar se a conta ou o ticket do pedido saiu. Confira a impressora antes de reimprimir.",
    "comandas.print.failedTableAndBag": "{table}: NÃO saíram nem a comanda nem o ticket da sacola. Os itens voltaram para pendentes: confira a impressora e toque em Enviar (o ticket sai de novo com a comanda).",
    "comandas.print.failedReprint": "MESA {table}: a comanda NÃO saiu. Confira a impressora e reimprima a comanda completa.",
    "comandas.print.failedTableClosed": "MESA {table}: a comanda NÃO saiu e a mesa já foi fechada. Verifique se esses itens ficaram pendentes.",
    "comandas.print.unconfirmedTable": "MESA {table}: não conseguimos confirmar a impressão. Confira a impressora ANTES de reimprimir: pode ter saído mesmo assim.",
    "comandas.print.someFailed": "{n} de {total} comanda(s) não foram impressas. Verifique essa(s) impressora(s) e reimprima a comanda completa.",
    "comandas.print.someUnconfirmed": "{n} de {total} comanda(s) sem confirmação. Confira a(s) impressora(s) ANTES de reimprimir: podem ter saído mesmo assim.",
    "comandas.send.partialNoPrinter": "{n} item(ns) não foram impressos: a impressora dessa estação não está disponível. Ficaram pendentes.",
    "comandas.wizard.title": "Adicionar impressora",
    "comandas.wizard.detected": "Impressora encontrada",
    "comandas.wizard.close": "Fechar",
    "comandas.wizard.back": "Voltar",
    "comandas.wizard.next": "Seguinte",
    "comandas.wizard.retry": "Tentar de novo",
    "comandas.wizard.howQuestion": "Como a impressora está conectada?",
    "comandas.wizard.usb": "Por USB",
    "comandas.wizard.usbDesc": "Com cabo USB a este computador.",
    "comandas.wizard.net": "Por rede (Ethernet)",
    "comandas.wizard.netDesc": "Com cabo de rede ao roteador ou extensor.",
    "comandas.wizard.detectingUsb": "Procurando impressoras USB…",
    "comandas.wizard.detectingNet": "Procurando a impressora na rede…",
    "comandas.wizard.pickUsb": "Escolha a impressora USB:",
    "comandas.wizard.pickNet": "Impressora encontrada:",
    "comandas.wizard.noUsb": "Não vejo impressoras USB. Se aparece em 'Não especificado', falta o driver: instale 'Generic / Text Only' na porta USB e tente de novo.",
    "comandas.wizard.noNet": "Não encontrei sozinho. Digite o IP manualmente:",
    "comandas.wizard.foundNet": "encontrada na rede",
    "comandas.wizard.netExcluded": "(Ocultei as já registradas.)",
    "comandas.wizard.netTestHint": "Escolha uma; depois imprima um teste para confirmar qual é.",
    "comandas.wizard.netAllRegistered": "As que encontrei já estão registradas. Se for nova, digite o IP manualmente.",
    "comandas.wizard.netTestBeforeRegister": "Imprima um teste antes de registrar: o ticket sai pela impressora real, assim confirma qual é.",
    "comandas.wizard.factoryBtn": "Definir IP (impressora em 192.168.123.100)",
    "comandas.wizard.factoryHint": "Para uma impressora em 192.168.123.100 (de fábrica). O PC precisa estar por CABO (não WiFi) no mesmo roteador que a impressora. Leva 1-2 min.",
    "comandas.wizard.factoryWorking": "Configurando… até 1-2 min. Não feche esta janela.",
    "comandas.wizard.factoryNotFound": "Não encontrei. Verifique que esteja ligada, em 192.168.123.100 (self-test), e que o PC esteja por cabo no mesmo roteador.",
    "comandas.wizard.orManualIp": "Ou digite o IP manualmente",
    "comandas.wizard.changeIpBtn": "Trocar o IP (se duas ficaram iguais)",
    "comandas.wizard.changeIpTitle": "Trocar o IP de uma impressora",
    "comandas.wizard.changeIpHint": "Desligue as outras e deixe ligada SÓ esta. Digite o IP atual (veja o self-test). Depois confirme no self-test que mudou.",
    "comandas.wizard.changeIpCurLabel": "IP atual da impressora",
    "comandas.wizard.changeIpGo": "Trocar IP",
    "comandas.wizard.changeIpWorking": "Trocando o IP…",
    "comandas.wizard.errChangeIp": "Não consegui trocar o IP. Verifique que esteja ligada e que desligou as outras.",
    "comandas.wizard.usbCfgBtn": "Configurar por USB",
    "comandas.wizard.usbCfgWhy": "Envio o IP pelo cabo USB (não depende da rede).",
    "comandas.wizard.usbCfgTitle": "Configurar por USB",
    "comandas.wizard.usbCfgStep1b": "Desconecte outras impressoras USB (para não confundir).",
    "comandas.wizard.usbCfgStep1": "Conecte a impressora nova por USB.",
    "comandas.wizard.usbCfgStep2": "Ligue-a e espere o Windows reconhecê-la.",
    "comandas.wizard.usbCfgStep3": "Toque em \"Configurar por USB\": atribuo um IP da sua rede.",
    "comandas.wizard.usbCfgDetect": "Detectar impressora USB",
    "comandas.wizard.usbCfgPick": "Qual é a impressora nova?",
    "comandas.wizard.usbCfgNoQueue": "Não vejo impressoras USB. Se aparece em 'Não especificado', instale o driver 'Generic / Text Only' e tente de novo.",
    "comandas.wizard.usbCfgGo": "Configurar esta",
    "comandas.wizard.usbCfgWorking": "Configurando…",
    "comandas.wizard.usbCfgSent": "IP enviado por USB:",
    "comandas.wizard.usbReplug1": "Desconecte o cabo que usou para configurar.",
    "comandas.wizard.usbReplug2": "Conecte o cabo de rede ao extensor/roteador.",
    "comandas.wizard.usbReplug3": "Ligue-a e espere ~20 seg.",
    "comandas.wizard.usbReplugTest": "Já está conectada — imprimir teste",
    "comandas.wizard.usbCfgReplug": "Confirme no self-test que o IP mudou. Se o teste saiu, registre.",
    "comandas.wizard.errUsbCfg": "Não consegui configurar por USB. Verifique que esteja conectada por USB e ligada.",
    "comandas.wizard.offline": "sem conexão",
    "comandas.wizard.nameUsb": "Ex: Cozinha (USB)",
    "comandas.wizard.nameNet": "Ex: Bar",
    "comandas.wizard.test": "Imprimir teste",
    "comandas.wizard.register": "Registrar",
    "comandas.wizard.working": "Um momento…",
    "comandas.wizard.testOk": "✓ O teste saiu. Se viu o ticket, registre.",
    "comandas.wizard.testFail": "Não foi possível imprimir o teste",
    "comandas.wizard.done": "✓ Impressora pronta!",
    "comandas.wizard.errGeneric": "Algo deu errado. Tente de novo.",
    "comandas.wizard.errDetect": "Não foi possível detectar. Tente de novo.",
    "comandas.wizard.errTest": "Não foi possível imprimir o teste.",
    "comandas.wizard.errRegister": "Não foi possível registrar a impressora.",
    "comandas.config.local.useMenu": "Usar dados do menu",
    "comandas.config.comanda.desc": "É o ticket que sai na cozinha. Escolha o que mostrar (nunca leva preços).",
    "comandas.config.cuenta.desc": "É a pré-conta entregue ao cliente.",
    "comandas.config.advanced.title": "Opções avançadas",
    "comandas.config.advanced.desc": "Roteamento por impressora, vendas por garçom e início do dia. Só se precisar.",
    "comandas.config.saving": "Salvando…",
    "comandas.config.saved": "Configuração salva",
    "comandas.config.printers.title": "Impressoras",
    "comandas.config.printers.desc": "As impressoras do local. Cada uma tem seu IP e estação.",
    "comandas.config.printers.add": "Adicionar impressora",
    "comandas.config.printers.name": "Nome",
    "comandas.config.printers.ip": "IP",
    "comandas.config.printers.port": "Porta",
    "comandas.config.printers.station": "Estação",
    "comandas.config.printers.empty": "Nenhuma impressora ainda.",
    "comandas.config.printers.test": "Imprimir teste",
    "comandas.config.printers.testing": "Enviando…",
    "comandas.config.printers.remove": "Remover",
    "comandas.config.printers.autoDetected": "Detectada pelo agente",
    "comandas.station.cocina": "Cozinha",
    "comandas.station.barra": "Bar",
    "comandas.station.caja": "Caixa",
    "comandas.config.local.title": "Dados do local (para a conta)",
    "comandas.config.local.desc": "Aparecem no cabeçalho da conta do cliente.",
    "comandas.config.local.name": "Nome do local",
    "comandas.config.local.address": "Endereço",
    "comandas.config.local.phone": "Telefone",
    "comandas.config.comanda.title": "Comanda de cozinha",
    "comandas.config.comanda.showWaiter": "Mostrar garçom",
    "comandas.config.comanda.showTime": "Mostrar hora",
    "comandas.config.comanda.showOrderNumber": "Mostrar N° da comanda",
    "comandas.config.comanda.groupByStation": "Agrupar por estação",
    "comandas.config.comanda.noPrices": "A comanda de cozinha NUNCA leva preços (assim deve ser).",
    "comandas.config.cuenta.scale": "Tamanho da letra",
    "comandas.config.cuenta.scale1": "Normal",
    "comandas.config.cuenta.scale2": "Grande",
    "comandas.config.cuenta.scale3": "Muito grande",
    "comandas.config.cuenta.scaleHelper": "Aumenta a conta inteira, não uma parte. Cresce em altura: os nomes dos pratos não são cortados e os preços ficam alinhados. «Muito grande» usa quase o dobro de papel.",
    "comandas.config.cuenta.title": "Conta (cliente)",
    "comandas.config.cuenta.showTip": "Sugerir gorjeta",
    "comandas.config.cuenta.tipPercent": "Percentual sugerido",
    "comandas.config.cuenta.footer": "Mensagem final",
    "comandas.config.cuenta.legendLocked": "Aviso legal fixo (não editável): protege o local de a conta ser confundida com uma nota fiscal.",
    "comandas.config.addons.title": "Adicionais fora do cardápio",
    "comandas.config.addons.desc": "Itens cobráveis que não estão no cardápio (couvert, creme extra…). Depois você acha rápido ao lançar o pedido.",
    "comandas.config.addons.add": "Adicionar adicional",
    "comandas.config.addons.name": "Nome",
    "comandas.config.addons.price": "Preço",
    "comandas.config.addons.empty": "Sem adicionais ainda.",
    "comandas.config.addons.route": "Impressora",
    "comandas.config.addons.routeHint": "“Não imprime” = esse adicional NÃO sai na comanda, mas é cobrado igual. “Padrão” = como até agora.",
    "comandas.config.addons.needName": "Dê um nome ao adicional: vazio, ele some ao salvar.",
    "comandas.config.quickNotes.title": "Observações frequentes",
    "comandas.config.quickNotes.desc": "Escolhidas com um toque ao anotar um prato (sem sal, bem passado…).",
    "comandas.config.quickNotes.add": "Adicionar",
    "comandas.config.quickNotes.placeholder": "Nova observação…",
    "comandas.config.dayRollover.title": "Início do dia",
    "comandas.config.dayRollover.desc": "Hora em que começa um novo 'dia de negócio'. Coloque numa hora tranquila da madrugada (não a de fechamento), assim o turno da noite não se parte e você tem tempo de fechar o caixa.",
    "comandas.config.separateTickets.title": "Ticket separado por estação",
    "comandas.config.separateTickets.desc": "Cozinha e bar saem em comandas cortadas separadas (uma para levar a cada lado), mesmo na mesma impressora.",
    "comandas.config.revokeDevices.button": "Desvincular celulares",
    "comandas.config.revokeDevices.desc": "Corta o acesso de todos os celulares vinculados. Terão que escanear o QR de novo. Útil se demitir um garçom.",
    "comandas.config.revokeDevices.confirm": "Desvincular todos os celulares? Todos os garçons terão que escanear o QR de novo.",
    "comandas.config.revokeDevices.done": "Pronto. Os celulares foram desvinculados — peça para escanearem o QR de novo (pode levar até 2 minutos).",
    "comandas.preview.title": "Prévia (papel 80mm)",
    "comandas.preview.comanda": "Comanda",
    "comandas.preview.cuenta": "Conta",
    "comandas.preview.delivery": "Entrega",
    "comandas.preview.deliveryKitchen": "Comanda (cozinha)",
    "comandas.preview.deliveryBag": "Ticket do pedido (vai na sacola)",
    "comandas.print.queued": "Enviado à impressora… {table}",
    "comandas.print.printing": "Imprimindo…",
    "comandas.print.done": "{table} → impresso! ✓",
    "comandas.print.queuedOk": "{table} → na impressora ✓",
    "comandas.print.error": "Falha na impressão: {msg}",
    "comandas.print.noPrinter": "Adicione uma impressora com seu IP primeiro.",
    "comandas.print.slow": "{table}: está demorando mais que o normal. Espere antes de reimprimir…",
    "comandas.print.timeout": "{table}: sem confirmação. Confira a impressora ANTES de reimprimir: pode ter saído mesmo assim.",
    // ── Planta do salão ──
    "comandas.plan.view.aria": "Como ver as mesas",
    "comandas.plan.view.grid": "Grade",
    "comandas.plan.view.plan": "Planta",
    "comandas.plan.miniHint": "Toque numa parte para aproximar",
    "comandas.plan.miniOpen": "{open} de {total} abertas",
    "comandas.plan.outside": "Fora da planta",
    "comandas.plan.outsideFree": "+{n} livres",
    "comandas.plan.items": "{n} itens",
    "comandas.plan.cfg.title": "Planta do salão",
    "comandas.plan.cfg.desc": "Desenhe o seu salão e o Turno mostra cada mesa no seu lugar, com a cor de como está.",
    "comandas.plan.cfg.empty": "Você ainda não desenhou o seu salão. É opcional: sem ele, o Turno continua com a grade de sempre.",
    "comandas.plan.cfg.draw": "Desenhar meu salão",
    "comandas.plan.cfg.edit": "Editar a planta",
    "comandas.plan.cfg.placed": "{n} de {total} mesas na planta",
    "comandas.plan.cfg.noTables": "Você ainda não colocou nenhuma mesa na planta: até colocar pelo menos uma, o Turno continua com a grade.",
    "comandas.plan.cfg.start": "Ao abrir o Turno, mostrar",
    "comandas.plan.cfg.startDesc": "Cada aparelho pode trocar com o botão Grade | Planta; quando for aberto de novo, começa como você definir aqui.",
    "comandas.plan.cfg.cloudOnly": "A planta é desenhada pelo painel na nuvem, nesta mesma seção.",
    "comandas.plan.ed.title": "Planta do salão",
    "comandas.plan.ed.back": "Voltar",
    "comandas.plan.ed.save": "Salvar",
    "comandas.plan.ed.saving": "Salvando…",
    "comandas.plan.ed.saved": "Salvo",
    "comandas.plan.ed.unsaved": "Não salvo",
    "comandas.plan.ed.saveError": "Não foi possível salvar. Verifique a conexão e tente de novo.",
    "comandas.plan.ed.undo": "Desfazer",
    "comandas.plan.ed.redo": "Refazer",
    "comandas.plan.ed.cancel": "Cancelar",
    "comandas.plan.ed.clear": "Começar de novo",
    "comandas.plan.ed.clearConfirm": "Apagar toda a planta? Dá para desfazer enquanto não salvar.",
    "comandas.plan.ed.clearYes": "Apagar tudo",
    "comandas.plan.ed.canvas": "Folha da planta",
    "comandas.plan.ed.tool.move": "Mover",
    "comandas.plan.ed.tool.wall": "Parede",
    "comandas.plan.ed.tool.text": "Nome",
    "comandas.plan.ed.tool.tables": "Mesas",
    "comandas.plan.ed.tip.move": "Arraste paredes, nomes e mesas para organizá-los; arrastando o fundo você move a folha. Toque num deles para mudar ou apagar.",
    "comandas.plan.ed.tip.wall": "Arraste de uma ponta à outra para desenhar uma parede. Ela fica reta e se junta sozinha às outras. A porta é o espaço que você deixa. Para mover a folha, use dois dedos ou volte para Mover.",
    "comandas.plan.ed.tip.text": "Toque onde vai o nome dessa parte do local: salão, calçada, pátio…",
    "comandas.plan.ed.tip.place": "Toque na planta onde vai a mesa {t}.",
    "comandas.plan.ed.tip.allPlaced": "Todas as suas mesas estão na planta. Arraste-as para organizá-las.",
    "comandas.plan.ed.tray.title": "Sem lugar ({n})",
    "comandas.plan.ed.tray.all": "Colocar todas em fileiras",
    "comandas.plan.ed.tray.done": "Todas as mesas estão na planta.",
    "comandas.plan.ed.tray.hint": "As mesas que você adicionar ou apagar aqui também mudam em Configuração › Quantidade de mesas.",
    "comandas.plan.ed.tray.orphans": "{list}: já não são mesas do seu local, então não aparecem no Turno.",
    "comandas.plan.ed.tray.orphansOut": "Tirá-las da planta",
    "comandas.plan.ed.tray.add": "Adicionar mesa",
    "comandas.plan.ed.tray.deleteLeft": "Apagar as que sobram ({n})",
    "comandas.plan.ed.newTable.label": "Mesa nova: número ou nome",
    "comandas.plan.ed.newTable.hint": "Depois toque a folha onde ela vai.",
    "comandas.plan.ed.newTable.ok": "Adicionar",
    "comandas.plan.ed.newTable.empty": "Escreva um número ou um nome.",
    "comandas.plan.ed.newTable.long": "Um nome mais curto (até 20 caracteres).",
    "comandas.plan.ed.newTable.comma": "Sem vírgulas, por favor.",
    "comandas.plan.ed.newTable.exists": "Já existe uma mesa {t}.",
    "comandas.plan.ed.newTable.full": "Você chegou ao máximo de mesas com nome (200).",
    "comandas.plan.ed.left.title": "Apagar as mesas que sobram",
    "comandas.plan.ed.left.body": "Serão apagadas do seu local: {list}. Se depois faltar alguma, adicione de novo por aqui.",
    "comandas.plan.ed.left.busy": "Ficam as que têm um pedido aberto: {list}.",
    "comandas.plan.ed.left.one": "A 1 fica: a numeração das mesas começa nela.",
    "comandas.plan.ed.left.tooMany": "Não dá para apagar todas de uma vez: ficariam mais de 200 mesas com nome. Diminua a quantidade em Configuração › Quantidade de mesas.",
    "comandas.plan.ed.left.yes": "Apagar ({n})",
    "comandas.plan.ed.left.ok": "Entendi",
    "comandas.plan.ed.orphan": "Já não é uma mesa do seu local",
    "comandas.plan.ed.sel.table": "Mesa {t}",
    "comandas.plan.ed.sel.wall": "Parede",
    "comandas.plan.ed.sel.wallHint": "Arraste os pontos das pontas para aumentá-la ou diminuí-la.",
    "comandas.plan.ed.sel.text": "Nome",
    "comandas.plan.ed.sel.unplace": "Tirar da planta",
    "comandas.plan.ed.sel.rename": "Mudar",
    "comandas.plan.ed.sel.renameTable": "Mudar número ou nome",
    "comandas.plan.ed.renameTable.label": "Novo número ou nome para a mesa {t}",
    "comandas.plan.ed.renameTable.hint": "Muda na planta, no Turno e nas Configurações.",
    "comandas.plan.ed.renameTable.ok": "Mudar",
    "comandas.plan.ed.renameTable.busy": "A mesa {t} tem um pedido aberto: o nome pode ser mudado quando ela for paga.",
    "comandas.plan.ed.renameTable.one": "A mesa 1 não pode ser mudada: a numeração das mesas começa nela.",
    "comandas.plan.ed.sel.delete": "Apagar",
    "comandas.plan.ed.text.label": "Como se chama esta parte?",
    "comandas.plan.ed.text.placeholder": "Ex.: Salão",
    "comandas.plan.ed.text.ok": "Pronto",
    "comandas.plan.ed.text.suggestions": "Salão,Calçada,Pátio,Bar,Cozinha,Banheiros,Entrada,Terraço",
    "comandas.plan.ed.start.title": "Como começamos?",
    "comandas.plan.ed.start.room": "Um salão com todas as suas mesas",
    "comandas.plan.ed.start.roomDesc": "Quatro paredes e suas {n} mesas em fileiras. Um toque e já funciona: depois você move o que quiser.",
    "comandas.plan.ed.start.rows": "Só as mesas, em fileiras",
    "comandas.plan.ed.start.rowsDesc": "Sem paredes: você as desenha, se quiser.",
    "comandas.plan.ed.start.blank": "Folha em branco",
    "comandas.plan.ed.start.blankDesc": "Você desenha tudo do zero.",
    "comandas.plan.ed.start.entrance": "Entrada",
    "comandas.plan.ed.zoomIn": "Aproximar",
    "comandas.plan.ed.zoomOut": "Afastar",
    "comandas.plan.ed.zoomFit": "Ver tudo",
    "comandas.plan.ed.exit.title": "Você tem alterações não salvas",
    "comandas.plan.ed.exit.body": "Se sair agora, perde o que mudou desde a última vez que salvou.",
    "comandas.plan.ed.exit.save": "Salvar e sair",
    "comandas.plan.ed.exit.discard": "Sair sem salvar",
    "comandas.plan.ed.exit.stay": "Continuar desenhando",
    "comandas.plan.ed.recover.text": "Ficou uma planta sem salvar da última vez.",
    "comandas.plan.ed.recover.yes": "Recuperar",
    "comandas.plan.ed.recover.no": "Descartar",
  },
};

export default comandas;
